import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: TheGraph_BigDecimal;
  BigInt: TheGraph_BigInt;
  Bytes: string;
  CryptoAmount: CryptoAmount;
  CurveLpAmount: CryptoAmount<"CURVE_LP">;
  DateTime: any;
  FiduAmount: CryptoAmount<"FIDU">;
  GfiAmount: CryptoAmount<"GFI">;
  /** 8 bytes signed integer */
  Int8: any;
  JSON: any;
  /** A string representation of microseconds UNIX timestamp (16 digits) */
  Timestamp: any;
  UsdcAmount: CryptoAmount<"USDC">;
};

/** Indicates whether the current, partially filled bucket should be included in the response. Defaults to `exclude` */
export type Aggregation_Current =
  /** Exclude the current, partially filled bucket from the response */
  | 'exclude'
  /** Include the current, partially filled bucket in the response */
  | 'include';

export type Aggregation_Interval =
  | 'day'
  | 'hour';

export type BackerRewardsData = {
  __typename?: 'BackerRewardsData';
  contractAddress: Scalars['String'];
  id: Scalars['ID'];
  /** Note that this value is measured in GFI, not dollars */
  maxInterestDollarsEligible: Scalars['BigInt'];
  totalRewardPercentOfTotalGFI: Scalars['BigDecimal'];
  totalRewards: Scalars['BigInt'];
};

export type BackerRewardsData_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<BackerRewardsData_Filter>>>;
  contractAddress?: InputMaybe<Scalars['String']>;
  contractAddress_contains?: InputMaybe<Scalars['String']>;
  contractAddress_contains_nocase?: InputMaybe<Scalars['String']>;
  contractAddress_ends_with?: InputMaybe<Scalars['String']>;
  contractAddress_ends_with_nocase?: InputMaybe<Scalars['String']>;
  contractAddress_gt?: InputMaybe<Scalars['String']>;
  contractAddress_gte?: InputMaybe<Scalars['String']>;
  contractAddress_in?: InputMaybe<Array<Scalars['String']>>;
  contractAddress_lt?: InputMaybe<Scalars['String']>;
  contractAddress_lte?: InputMaybe<Scalars['String']>;
  contractAddress_not?: InputMaybe<Scalars['String']>;
  contractAddress_not_contains?: InputMaybe<Scalars['String']>;
  contractAddress_not_contains_nocase?: InputMaybe<Scalars['String']>;
  contractAddress_not_ends_with?: InputMaybe<Scalars['String']>;
  contractAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  contractAddress_not_in?: InputMaybe<Array<Scalars['String']>>;
  contractAddress_not_starts_with?: InputMaybe<Scalars['String']>;
  contractAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  contractAddress_starts_with?: InputMaybe<Scalars['String']>;
  contractAddress_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  maxInterestDollarsEligible?: InputMaybe<Scalars['BigInt']>;
  maxInterestDollarsEligible_gt?: InputMaybe<Scalars['BigInt']>;
  maxInterestDollarsEligible_gte?: InputMaybe<Scalars['BigInt']>;
  maxInterestDollarsEligible_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxInterestDollarsEligible_lt?: InputMaybe<Scalars['BigInt']>;
  maxInterestDollarsEligible_lte?: InputMaybe<Scalars['BigInt']>;
  maxInterestDollarsEligible_not?: InputMaybe<Scalars['BigInt']>;
  maxInterestDollarsEligible_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<BackerRewardsData_Filter>>>;
  totalRewardPercentOfTotalGFI?: InputMaybe<Scalars['BigDecimal']>;
  totalRewardPercentOfTotalGFI_gt?: InputMaybe<Scalars['BigDecimal']>;
  totalRewardPercentOfTotalGFI_gte?: InputMaybe<Scalars['BigDecimal']>;
  totalRewardPercentOfTotalGFI_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  totalRewardPercentOfTotalGFI_lt?: InputMaybe<Scalars['BigDecimal']>;
  totalRewardPercentOfTotalGFI_lte?: InputMaybe<Scalars['BigDecimal']>;
  totalRewardPercentOfTotalGFI_not?: InputMaybe<Scalars['BigDecimal']>;
  totalRewardPercentOfTotalGFI_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  totalRewards?: InputMaybe<Scalars['BigInt']>;
  totalRewards_gt?: InputMaybe<Scalars['BigInt']>;
  totalRewards_gte?: InputMaybe<Scalars['BigInt']>;
  totalRewards_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalRewards_lt?: InputMaybe<Scalars['BigInt']>;
  totalRewards_lte?: InputMaybe<Scalars['BigInt']>;
  totalRewards_not?: InputMaybe<Scalars['BigInt']>;
  totalRewards_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type BackerRewardsData_OrderBy =
  | 'contractAddress'
  | 'id'
  | 'maxInterestDollarsEligible'
  | 'totalRewardPercentOfTotalGFI'
  | 'totalRewards';

export type BlockChangedFilter = {
  number_gte: Scalars['Int'];
};

export type BlockInfo = {
  __typename?: 'BlockInfo';
  number: Scalars['Int'];
  timestamp: Scalars['Int'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']>;
  number?: InputMaybe<Scalars['Int']>;
  number_gte?: InputMaybe<Scalars['Int']>;
};

export type Borrower = {
  __typename?: 'Borrower';
  bio?: Maybe<Scalars['JSON']>;
  borrowerFinancials?: Maybe<Borrower_BorrowerFinancials>;
  contactInfo?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  deals?: Maybe<Array<Deal>>;
  documents?: Maybe<Array<Borrower_Documents>>;
  id?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  logo?: Maybe<Media>;
  mediaLinks?: Maybe<Array<Borrower_MediaLinks>>;
  name: Scalars['String'];
  orgType?: Maybe<Scalars['String']>;
  otherProducts?: Maybe<Scalars['JSON']>;
  team?: Maybe<Borrower_Team>;
  twitter?: Maybe<Scalars['String']>;
  underwritingPerformance?: Maybe<Borrower_UnderwritingPerformance>;
  updatedAt: Scalars['DateTime'];
  website?: Maybe<Scalars['String']>;
};


export type BorrowerBioArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type BorrowerContactInfoArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type BorrowerLogoArgs = {
  where?: InputMaybe<Borrower_Logo_Where>;
};


export type BorrowerOtherProductsArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type BorrowerContract = {
  __typename?: 'BorrowerContract';
  createdAt: Scalars['BigInt'];
  id: Scalars['ID'];
  user: User;
};

export type BorrowerContract_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<BorrowerContract_Filter>>>;
  createdAt?: InputMaybe<Scalars['BigInt']>;
  createdAt_gt?: InputMaybe<Scalars['BigInt']>;
  createdAt_gte?: InputMaybe<Scalars['BigInt']>;
  createdAt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  createdAt_lt?: InputMaybe<Scalars['BigInt']>;
  createdAt_lte?: InputMaybe<Scalars['BigInt']>;
  createdAt_not?: InputMaybe<Scalars['BigInt']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<BorrowerContract_Filter>>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type BorrowerContract_OrderBy =
  | 'createdAt'
  | 'id'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

export type Borrower_BorrowerFinancials = {
  __typename?: 'Borrower_BorrowerFinancials';
  audited?: Maybe<Borrower_BorrowerFinancials_Audited>;
  aum?: Maybe<Scalars['Float']>;
  currentLoansOutstanding?: Maybe<Scalars['Float']>;
  financialStatementSummary?: Maybe<Media>;
  pastOffChainDeals?: Maybe<Array<Borrower_BorrowerFinancials_PastOffChainDeals>>;
  totalLoansOriginated?: Maybe<Scalars['Float']>;
};


export type Borrower_BorrowerFinancialsFinancialStatementSummaryArgs = {
  where?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Where>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_FileNameOverride_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Where = {
  AND?: InputMaybe<Array<InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Where_Or>>>;
  alt?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Filename_Operator>;
  filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Filesize_Operator>;
  height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Height_Operator>;
  id?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Id_Operator>;
  mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Url_Operator>;
  width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Width_Operator>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Where_And = {
  alt?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Filename_Operator>;
  filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Filesize_Operator>;
  height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Height_Operator>;
  id?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Id_Operator>;
  mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Url_Operator>;
  width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Width_Operator>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Where_Or = {
  alt?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Filename_Operator>;
  filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Filesize_Operator>;
  height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Height_Operator>;
  id?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Id_Operator>;
  mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Url_Operator>;
  width?: InputMaybe<Borrower_BorrowerFinancials_FinancialStatementSummary_Width_Operator>;
};

export type Borrower_BorrowerFinancials_FinancialStatementSummary_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials_PastOffChainDeals = {
  __typename?: 'Borrower_BorrowerFinancials_PastOffChainDeals';
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Borrower_BorrowerFinancials_Audited =
  | 'no'
  | 'yes';

export type Borrower_Documents = Document;

export type Borrower_Logo_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_FileNameOverride_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Borrower_Logo_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Large__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Large__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Large__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Large__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Large__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Large__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Medium__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Medium__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Medium__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Medium__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Medium__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Medium__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Logo_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Where = {
  AND?: InputMaybe<Array<InputMaybe<Borrower_Logo_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Borrower_Logo_Where_Or>>>;
  alt?: InputMaybe<Borrower_Logo_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_Logo_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_Logo_Filename_Operator>;
  filesize?: InputMaybe<Borrower_Logo_Filesize_Operator>;
  height?: InputMaybe<Borrower_Logo_Height_Operator>;
  id?: InputMaybe<Borrower_Logo_Id_Operator>;
  mimeType?: InputMaybe<Borrower_Logo_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_Logo_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_Logo_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_Logo_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_Logo_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_Logo_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_Logo_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_Logo_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_Logo_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_Logo_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_Logo_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_Logo_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_Logo_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_Logo_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_Logo_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_Logo_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_Logo_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_Logo_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_Logo_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_Logo_Url_Operator>;
  width?: InputMaybe<Borrower_Logo_Width_Operator>;
};

export type Borrower_Logo_Where_And = {
  alt?: InputMaybe<Borrower_Logo_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_Logo_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_Logo_Filename_Operator>;
  filesize?: InputMaybe<Borrower_Logo_Filesize_Operator>;
  height?: InputMaybe<Borrower_Logo_Height_Operator>;
  id?: InputMaybe<Borrower_Logo_Id_Operator>;
  mimeType?: InputMaybe<Borrower_Logo_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_Logo_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_Logo_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_Logo_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_Logo_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_Logo_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_Logo_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_Logo_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_Logo_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_Logo_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_Logo_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_Logo_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_Logo_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_Logo_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_Logo_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_Logo_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_Logo_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_Logo_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_Logo_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_Logo_Url_Operator>;
  width?: InputMaybe<Borrower_Logo_Width_Operator>;
};

export type Borrower_Logo_Where_Or = {
  alt?: InputMaybe<Borrower_Logo_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_Logo_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_Logo_Filename_Operator>;
  filesize?: InputMaybe<Borrower_Logo_Filesize_Operator>;
  height?: InputMaybe<Borrower_Logo_Height_Operator>;
  id?: InputMaybe<Borrower_Logo_Id_Operator>;
  mimeType?: InputMaybe<Borrower_Logo_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_Logo_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_Logo_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_Logo_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_Logo_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_Logo_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_Logo_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_Logo_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_Logo_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_Logo_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_Logo_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_Logo_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_Logo_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_Logo_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_Logo_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_Logo_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_Logo_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_Logo_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_Logo_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_Logo_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_Logo_Url_Operator>;
  width?: InputMaybe<Borrower_Logo_Width_Operator>;
};

export type Borrower_Logo_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_MediaLinks = {
  __typename?: 'Borrower_MediaLinks';
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Borrower_Team = {
  __typename?: 'Borrower_Team';
  description?: Maybe<Scalars['JSON']>;
  members?: Maybe<Array<Borrower_Team_Members>>;
};


export type Borrower_TeamDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Borrower_Team_Members = TeamMember;

export type Borrower_UnderwritingPerformance = {
  __typename?: 'Borrower_UnderwritingPerformance';
  defaultRate?: Maybe<Scalars['Float']>;
  performanceDocument?: Maybe<Media>;
  underwritingDescription?: Maybe<Scalars['JSON']>;
};


export type Borrower_UnderwritingPerformancePerformanceDocumentArgs = {
  where?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Where>;
};


export type Borrower_UnderwritingPerformanceUnderwritingDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_FileNameOverride_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Where = {
  AND?: InputMaybe<Array<InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Where_Or>>>;
  alt?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Filename_Operator>;
  filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Filesize_Operator>;
  height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Height_Operator>;
  id?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Id_Operator>;
  mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Url_Operator>;
  width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Width_Operator>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Where_And = {
  alt?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Filename_Operator>;
  filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Filesize_Operator>;
  height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Height_Operator>;
  id?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Id_Operator>;
  mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Url_Operator>;
  width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Width_Operator>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Where_Or = {
  alt?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Alt_Operator>;
  fileNameOverride?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_FileNameOverride_Operator>;
  filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Filename_Operator>;
  filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Filesize_Operator>;
  height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Height_Operator>;
  id?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Id_Operator>;
  mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Url_Operator>;
  width?: InputMaybe<Borrower_UnderwritingPerformance_PerformanceDocument_Width_Operator>;
};

export type Borrower_UnderwritingPerformance_PerformanceDocument_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_Bio_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Borrower_BorrowerFinancials__Audited_Input =
  | 'no'
  | 'yes';

export type Borrower_BorrowerFinancials__Audited_Operator = {
  all?: InputMaybe<Array<InputMaybe<Borrower_BorrowerFinancials__Audited_Input>>>;
  equals?: InputMaybe<Borrower_BorrowerFinancials__Audited_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Borrower_BorrowerFinancials__Audited_Input>>>;
  not_equals?: InputMaybe<Borrower_BorrowerFinancials__Audited_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Borrower_BorrowerFinancials__Audited_Input>>>;
};

export type Borrower_BorrowerFinancials__Aum_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials__CurrentLoansOutstanding_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_BorrowerFinancials__FinancialStatementSummary_Operator = {
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Borrower_BorrowerFinancials__PastOffChainDeals__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials__PastOffChainDeals__Text_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_BorrowerFinancials__TotalLoansOriginated_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_ContactInfo_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Borrower_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Borrower_Deals_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Borrower_Linkedin_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Logo_Operator = {
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Borrower_MediaLinks__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_MediaLinks__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_MediaLinks__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_OrgType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_OtherProducts_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Borrower_Team__Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Borrower_Twitter_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_UnderwritingPerformance__DefaultRate_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Borrower_UnderwritingPerformance__PerformanceDocument_Operator = {
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Borrower_UnderwritingPerformance__UnderwritingDescription_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Borrower_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Borrower_Website_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Borrower_Where = {
  AND?: InputMaybe<Array<InputMaybe<Borrower_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Borrower_Where_Or>>>;
  bio?: InputMaybe<Borrower_Bio_Operator>;
  borrowerFinancials__audited?: InputMaybe<Borrower_BorrowerFinancials__Audited_Operator>;
  borrowerFinancials__aum?: InputMaybe<Borrower_BorrowerFinancials__Aum_Operator>;
  borrowerFinancials__currentLoansOutstanding?: InputMaybe<Borrower_BorrowerFinancials__CurrentLoansOutstanding_Operator>;
  borrowerFinancials__financialStatementSummary?: InputMaybe<Borrower_BorrowerFinancials__FinancialStatementSummary_Operator>;
  borrowerFinancials__pastOffChainDeals__id?: InputMaybe<Borrower_BorrowerFinancials__PastOffChainDeals__Id_Operator>;
  borrowerFinancials__pastOffChainDeals__text?: InputMaybe<Borrower_BorrowerFinancials__PastOffChainDeals__Text_Operator>;
  borrowerFinancials__totalLoansOriginated?: InputMaybe<Borrower_BorrowerFinancials__TotalLoansOriginated_Operator>;
  contactInfo?: InputMaybe<Borrower_ContactInfo_Operator>;
  createdAt?: InputMaybe<Borrower_CreatedAt_Operator>;
  deals?: InputMaybe<Borrower_Deals_Operator>;
  id?: InputMaybe<Borrower_Id_Operator>;
  linkedin?: InputMaybe<Borrower_Linkedin_Operator>;
  logo?: InputMaybe<Borrower_Logo_Operator>;
  mediaLinks__id?: InputMaybe<Borrower_MediaLinks__Id_Operator>;
  mediaLinks__title?: InputMaybe<Borrower_MediaLinks__Title_Operator>;
  mediaLinks__url?: InputMaybe<Borrower_MediaLinks__Url_Operator>;
  name?: InputMaybe<Borrower_Name_Operator>;
  orgType?: InputMaybe<Borrower_OrgType_Operator>;
  otherProducts?: InputMaybe<Borrower_OtherProducts_Operator>;
  team__description?: InputMaybe<Borrower_Team__Description_Operator>;
  twitter?: InputMaybe<Borrower_Twitter_Operator>;
  underwritingPerformance__defaultRate?: InputMaybe<Borrower_UnderwritingPerformance__DefaultRate_Operator>;
  underwritingPerformance__performanceDocument?: InputMaybe<Borrower_UnderwritingPerformance__PerformanceDocument_Operator>;
  underwritingPerformance__underwritingDescription?: InputMaybe<Borrower_UnderwritingPerformance__UnderwritingDescription_Operator>;
  updatedAt?: InputMaybe<Borrower_UpdatedAt_Operator>;
  website?: InputMaybe<Borrower_Website_Operator>;
};

export type Borrower_Where_And = {
  bio?: InputMaybe<Borrower_Bio_Operator>;
  borrowerFinancials__audited?: InputMaybe<Borrower_BorrowerFinancials__Audited_Operator>;
  borrowerFinancials__aum?: InputMaybe<Borrower_BorrowerFinancials__Aum_Operator>;
  borrowerFinancials__currentLoansOutstanding?: InputMaybe<Borrower_BorrowerFinancials__CurrentLoansOutstanding_Operator>;
  borrowerFinancials__financialStatementSummary?: InputMaybe<Borrower_BorrowerFinancials__FinancialStatementSummary_Operator>;
  borrowerFinancials__pastOffChainDeals__id?: InputMaybe<Borrower_BorrowerFinancials__PastOffChainDeals__Id_Operator>;
  borrowerFinancials__pastOffChainDeals__text?: InputMaybe<Borrower_BorrowerFinancials__PastOffChainDeals__Text_Operator>;
  borrowerFinancials__totalLoansOriginated?: InputMaybe<Borrower_BorrowerFinancials__TotalLoansOriginated_Operator>;
  contactInfo?: InputMaybe<Borrower_ContactInfo_Operator>;
  createdAt?: InputMaybe<Borrower_CreatedAt_Operator>;
  deals?: InputMaybe<Borrower_Deals_Operator>;
  id?: InputMaybe<Borrower_Id_Operator>;
  linkedin?: InputMaybe<Borrower_Linkedin_Operator>;
  logo?: InputMaybe<Borrower_Logo_Operator>;
  mediaLinks__id?: InputMaybe<Borrower_MediaLinks__Id_Operator>;
  mediaLinks__title?: InputMaybe<Borrower_MediaLinks__Title_Operator>;
  mediaLinks__url?: InputMaybe<Borrower_MediaLinks__Url_Operator>;
  name?: InputMaybe<Borrower_Name_Operator>;
  orgType?: InputMaybe<Borrower_OrgType_Operator>;
  otherProducts?: InputMaybe<Borrower_OtherProducts_Operator>;
  team__description?: InputMaybe<Borrower_Team__Description_Operator>;
  twitter?: InputMaybe<Borrower_Twitter_Operator>;
  underwritingPerformance__defaultRate?: InputMaybe<Borrower_UnderwritingPerformance__DefaultRate_Operator>;
  underwritingPerformance__performanceDocument?: InputMaybe<Borrower_UnderwritingPerformance__PerformanceDocument_Operator>;
  underwritingPerformance__underwritingDescription?: InputMaybe<Borrower_UnderwritingPerformance__UnderwritingDescription_Operator>;
  updatedAt?: InputMaybe<Borrower_UpdatedAt_Operator>;
  website?: InputMaybe<Borrower_Website_Operator>;
};

export type Borrower_Where_Or = {
  bio?: InputMaybe<Borrower_Bio_Operator>;
  borrowerFinancials__audited?: InputMaybe<Borrower_BorrowerFinancials__Audited_Operator>;
  borrowerFinancials__aum?: InputMaybe<Borrower_BorrowerFinancials__Aum_Operator>;
  borrowerFinancials__currentLoansOutstanding?: InputMaybe<Borrower_BorrowerFinancials__CurrentLoansOutstanding_Operator>;
  borrowerFinancials__financialStatementSummary?: InputMaybe<Borrower_BorrowerFinancials__FinancialStatementSummary_Operator>;
  borrowerFinancials__pastOffChainDeals__id?: InputMaybe<Borrower_BorrowerFinancials__PastOffChainDeals__Id_Operator>;
  borrowerFinancials__pastOffChainDeals__text?: InputMaybe<Borrower_BorrowerFinancials__PastOffChainDeals__Text_Operator>;
  borrowerFinancials__totalLoansOriginated?: InputMaybe<Borrower_BorrowerFinancials__TotalLoansOriginated_Operator>;
  contactInfo?: InputMaybe<Borrower_ContactInfo_Operator>;
  createdAt?: InputMaybe<Borrower_CreatedAt_Operator>;
  deals?: InputMaybe<Borrower_Deals_Operator>;
  id?: InputMaybe<Borrower_Id_Operator>;
  linkedin?: InputMaybe<Borrower_Linkedin_Operator>;
  logo?: InputMaybe<Borrower_Logo_Operator>;
  mediaLinks__id?: InputMaybe<Borrower_MediaLinks__Id_Operator>;
  mediaLinks__title?: InputMaybe<Borrower_MediaLinks__Title_Operator>;
  mediaLinks__url?: InputMaybe<Borrower_MediaLinks__Url_Operator>;
  name?: InputMaybe<Borrower_Name_Operator>;
  orgType?: InputMaybe<Borrower_OrgType_Operator>;
  otherProducts?: InputMaybe<Borrower_OtherProducts_Operator>;
  team__description?: InputMaybe<Borrower_Team__Description_Operator>;
  twitter?: InputMaybe<Borrower_Twitter_Operator>;
  underwritingPerformance__defaultRate?: InputMaybe<Borrower_UnderwritingPerformance__DefaultRate_Operator>;
  underwritingPerformance__performanceDocument?: InputMaybe<Borrower_UnderwritingPerformance__PerformanceDocument_Operator>;
  underwritingPerformance__underwritingDescription?: InputMaybe<Borrower_UnderwritingPerformance__UnderwritingDescription_Operator>;
  updatedAt?: InputMaybe<Borrower_UpdatedAt_Operator>;
  website?: InputMaybe<Borrower_Website_Operator>;
};

export type Borrowers = {
  __typename?: 'Borrowers';
  docs?: Maybe<Array<Maybe<Borrower>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type CallableLoan = Loan & {
  __typename?: 'CallableLoan';
  address: Scalars['Bytes'];
  allowedUidTypes: Array<UidType>;
  availableForDrawdown: Scalars['BigInt'];
  backers: Array<User>;
  balance: Scalars['BigInt'];
  borrowerContract: BorrowerContract;
  borrowerLogo?: Maybe<Scalars['String']>;
  borrowerName: Scalars['String'];
  createdAt: Scalars['Int'];
  creditLineAddress: Scalars['Bytes'];
  delinquency: LoanDelinquency;
  drawdownsPaused: Scalars['Boolean'];
  fundableAt: Scalars['Int'];
  fundingLimit: Scalars['BigInt'];
  id: Scalars['ID'];
  inLockupPeriod: Scalars['Boolean'];
  initialInterestOwed: Scalars['BigInt'];
  interestAmountRepaid: Scalars['BigInt'];
  interestRate: Scalars['BigDecimal'];
  interestRateBigInt: Scalars['BigInt'];
  interestWrittenDown: Scalars['BigInt'];
  isAfterTermEndTime: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  lastFullPaymentTime: Scalars['Int'];
  lateFeeRate: Scalars['BigDecimal'];
  loanPhase: LoanPhase;
  name: Scalars['String'];
  nextDueTime: Scalars['BigInt'];
  nextPrincipalDueTime: Scalars['Int'];
  numBackers: Scalars['Int'];
  /** Please note that numRepayments never updates, even if the underlying repaymentSchedule is changed. It always reflects the initial number of expected repayments. */
  numRepayments: Scalars['Int'];
  periodInterestDueAmount: Scalars['BigInt'];
  periodPrincipalDueAmount: Scalars['BigInt'];
  principalAmount: Scalars['BigInt'];
  principalAmountRepaid: Scalars['BigInt'];
  principalWrittenDown: Scalars['BigInt'];
  rawGfiApy: Scalars['BigDecimal'];
  remainingCapacity: Scalars['BigInt'];
  repaymentFrequency: RepaymentFrequency;
  repaymentSchedule: Array<ScheduledRepayment>;
  termEndTime: Scalars['BigInt'];
  termInSeconds: Scalars['Int'];
  termStartTime: Scalars['BigInt'];
  termTotalDueAmount: Scalars['BigInt'];
  tokens: Array<PoolToken>;
  totalDeposited: Scalars['BigInt'];
  usdcApy: Scalars['BigDecimal'];
};


export type CallableLoanBackersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<User_Filter>;
};


export type CallableLoanRepaymentScheduleArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ScheduledRepayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledRepayment_Filter>;
};


export type CallableLoanTokensArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PoolToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PoolToken_Filter>;
};

export type CallableLoan_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['Bytes']>;
  address_contains?: InputMaybe<Scalars['Bytes']>;
  address_gt?: InputMaybe<Scalars['Bytes']>;
  address_gte?: InputMaybe<Scalars['Bytes']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_lt?: InputMaybe<Scalars['Bytes']>;
  address_lte?: InputMaybe<Scalars['Bytes']>;
  address_not?: InputMaybe<Scalars['Bytes']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  allowedUidTypes?: InputMaybe<Array<UidType>>;
  allowedUidTypes_contains?: InputMaybe<Array<UidType>>;
  allowedUidTypes_not?: InputMaybe<Array<UidType>>;
  allowedUidTypes_not_contains?: InputMaybe<Array<UidType>>;
  and?: InputMaybe<Array<InputMaybe<CallableLoan_Filter>>>;
  availableForDrawdown?: InputMaybe<Scalars['BigInt']>;
  availableForDrawdown_gt?: InputMaybe<Scalars['BigInt']>;
  availableForDrawdown_gte?: InputMaybe<Scalars['BigInt']>;
  availableForDrawdown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  availableForDrawdown_lt?: InputMaybe<Scalars['BigInt']>;
  availableForDrawdown_lte?: InputMaybe<Scalars['BigInt']>;
  availableForDrawdown_not?: InputMaybe<Scalars['BigInt']>;
  availableForDrawdown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  backers?: InputMaybe<Array<Scalars['String']>>;
  backers_?: InputMaybe<User_Filter>;
  backers_contains?: InputMaybe<Array<Scalars['String']>>;
  backers_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  backers_not?: InputMaybe<Array<Scalars['String']>>;
  backers_not_contains?: InputMaybe<Array<Scalars['String']>>;
  backers_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  balance?: InputMaybe<Scalars['BigInt']>;
  balance_gt?: InputMaybe<Scalars['BigInt']>;
  balance_gte?: InputMaybe<Scalars['BigInt']>;
  balance_in?: InputMaybe<Array<Scalars['BigInt']>>;
  balance_lt?: InputMaybe<Scalars['BigInt']>;
  balance_lte?: InputMaybe<Scalars['BigInt']>;
  balance_not?: InputMaybe<Scalars['BigInt']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  borrowerContract?: InputMaybe<Scalars['String']>;
  borrowerContract_?: InputMaybe<BorrowerContract_Filter>;
  borrowerContract_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_gt?: InputMaybe<Scalars['String']>;
  borrowerContract_gte?: InputMaybe<Scalars['String']>;
  borrowerContract_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_lt?: InputMaybe<Scalars['String']>;
  borrowerContract_lte?: InputMaybe<Scalars['String']>;
  borrowerContract_not?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_not_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with_nocase?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Int']>;
  createdAt_gt?: InputMaybe<Scalars['Int']>;
  createdAt_gte?: InputMaybe<Scalars['Int']>;
  createdAt_in?: InputMaybe<Array<Scalars['Int']>>;
  createdAt_lt?: InputMaybe<Scalars['Int']>;
  createdAt_lte?: InputMaybe<Scalars['Int']>;
  createdAt_not?: InputMaybe<Scalars['Int']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  creditLineAddress?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_contains?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_gt?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_gte?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  creditLineAddress_lt?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_lte?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  drawdownsPaused?: InputMaybe<Scalars['Boolean']>;
  drawdownsPaused_in?: InputMaybe<Array<Scalars['Boolean']>>;
  drawdownsPaused_not?: InputMaybe<Scalars['Boolean']>;
  drawdownsPaused_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  fundableAt?: InputMaybe<Scalars['Int']>;
  fundableAt_gt?: InputMaybe<Scalars['Int']>;
  fundableAt_gte?: InputMaybe<Scalars['Int']>;
  fundableAt_in?: InputMaybe<Array<Scalars['Int']>>;
  fundableAt_lt?: InputMaybe<Scalars['Int']>;
  fundableAt_lte?: InputMaybe<Scalars['Int']>;
  fundableAt_not?: InputMaybe<Scalars['Int']>;
  fundableAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  fundingLimit?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_gt?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_gte?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fundingLimit_lt?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_lte?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_not?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  initialInterestOwed?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_gt?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_gte?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  initialInterestOwed_lt?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_lte?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_not?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAmountRepaid?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_gt?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_gte?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAmountRepaid_lt?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_lte?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_not?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRate?: InputMaybe<Scalars['BigDecimal']>;
  interestRateBigInt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_gt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_gte?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRateBigInt_lt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_lte?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_not?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_not?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestWrittenDown?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_gt?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_gte?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestWrittenDown_lt?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_lte?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_not?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPaused_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isPaused_not?: InputMaybe<Scalars['Boolean']>;
  isPaused_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  lastFullPaymentTime?: InputMaybe<Scalars['Int']>;
  lastFullPaymentTime_gt?: InputMaybe<Scalars['Int']>;
  lastFullPaymentTime_gte?: InputMaybe<Scalars['Int']>;
  lastFullPaymentTime_in?: InputMaybe<Array<Scalars['Int']>>;
  lastFullPaymentTime_lt?: InputMaybe<Scalars['Int']>;
  lastFullPaymentTime_lte?: InputMaybe<Scalars['Int']>;
  lastFullPaymentTime_not?: InputMaybe<Scalars['Int']>;
  lastFullPaymentTime_not_in?: InputMaybe<Array<Scalars['Int']>>;
  lateFeeRate?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  lateFeeRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_not?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  numBackers?: InputMaybe<Scalars['Int']>;
  numBackers_gt?: InputMaybe<Scalars['Int']>;
  numBackers_gte?: InputMaybe<Scalars['Int']>;
  numBackers_in?: InputMaybe<Array<Scalars['Int']>>;
  numBackers_lt?: InputMaybe<Scalars['Int']>;
  numBackers_lte?: InputMaybe<Scalars['Int']>;
  numBackers_not?: InputMaybe<Scalars['Int']>;
  numBackers_not_in?: InputMaybe<Array<Scalars['Int']>>;
  numRepayments?: InputMaybe<Scalars['Int']>;
  numRepayments_gt?: InputMaybe<Scalars['Int']>;
  numRepayments_gte?: InputMaybe<Scalars['Int']>;
  numRepayments_in?: InputMaybe<Array<Scalars['Int']>>;
  numRepayments_lt?: InputMaybe<Scalars['Int']>;
  numRepayments_lte?: InputMaybe<Scalars['Int']>;
  numRepayments_not?: InputMaybe<Scalars['Int']>;
  numRepayments_not_in?: InputMaybe<Array<Scalars['Int']>>;
  or?: InputMaybe<Array<InputMaybe<CallableLoan_Filter>>>;
  principalAmount?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_gt?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_gte?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmountRepaid_lt?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_lte?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_not?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmount_gt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_gte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmount_lt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_lte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalWrittenDown?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_gt?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_gte?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalWrittenDown_lt?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_lte?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_not?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rawGfiApy?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_gt?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_gte?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  rawGfiApy_lt?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_lte?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_not?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  remainingCapacity?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_gt?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_gte?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_in?: InputMaybe<Array<Scalars['BigInt']>>;
  remainingCapacity_lt?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_lte?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_not?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  repaymentFrequency?: InputMaybe<RepaymentFrequency>;
  repaymentFrequency_in?: InputMaybe<Array<RepaymentFrequency>>;
  repaymentFrequency_not?: InputMaybe<RepaymentFrequency>;
  repaymentFrequency_not_in?: InputMaybe<Array<RepaymentFrequency>>;
  repaymentSchedule?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_?: InputMaybe<ScheduledRepayment_Filter>;
  repaymentSchedule_contains?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not_contains?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  termEndTime?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termEndTime_lt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_lte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termInSeconds?: InputMaybe<Scalars['Int']>;
  termInSeconds_gt?: InputMaybe<Scalars['Int']>;
  termInSeconds_gte?: InputMaybe<Scalars['Int']>;
  termInSeconds_in?: InputMaybe<Array<Scalars['Int']>>;
  termInSeconds_lt?: InputMaybe<Scalars['Int']>;
  termInSeconds_lte?: InputMaybe<Scalars['Int']>;
  termInSeconds_not?: InputMaybe<Scalars['Int']>;
  termInSeconds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  termStartTime?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termStartTime_lt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_lte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tokens?: InputMaybe<Array<Scalars['String']>>;
  tokens_?: InputMaybe<PoolToken_Filter>;
  tokens_contains?: InputMaybe<Array<Scalars['String']>>;
  tokens_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  tokens_not?: InputMaybe<Array<Scalars['String']>>;
  tokens_not_contains?: InputMaybe<Array<Scalars['String']>>;
  tokens_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  totalDeposited?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_gt?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_gte?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalDeposited_lt?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_lte?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_not?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcApy?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_gt?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_gte?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  usdcApy_lt?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_lte?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_not?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
};

export type CallableLoan_OrderBy =
  | 'address'
  | 'allowedUidTypes'
  | 'availableForDrawdown'
  | 'backers'
  | 'balance'
  | 'borrowerContract'
  | 'borrowerContract__createdAt'
  | 'borrowerContract__id'
  | 'createdAt'
  | 'creditLineAddress'
  | 'drawdownsPaused'
  | 'fundableAt'
  | 'fundingLimit'
  | 'id'
  | 'initialInterestOwed'
  | 'interestAmountRepaid'
  | 'interestRate'
  | 'interestRateBigInt'
  | 'interestWrittenDown'
  | 'isPaused'
  | 'lastFullPaymentTime'
  | 'lateFeeRate'
  | 'numBackers'
  | 'numRepayments'
  | 'principalAmount'
  | 'principalAmountRepaid'
  | 'principalWrittenDown'
  | 'rawGfiApy'
  | 'remainingCapacity'
  | 'repaymentFrequency'
  | 'repaymentSchedule'
  | 'termEndTime'
  | 'termInSeconds'
  | 'termStartTime'
  | 'tokens'
  | 'totalDeposited'
  | 'usdcApy';

export type CommunityRewardsToken = {
  __typename?: 'CommunityRewardsToken';
  cliffLength: Scalars['BigInt'];
  endTime: Scalars['BigInt'];
  grantedAt: Scalars['BigInt'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  revokedAt: Scalars['BigInt'];
  source: CommunityRewardsTokenSource;
  startTime: Scalars['BigInt'];
  totalClaimed: Scalars['BigInt'];
  totalGranted: Scalars['BigInt'];
  user: User;
  vestingInterval: Scalars['BigInt'];
  vestingLength: Scalars['BigInt'];
};

export type CommunityRewardsTokenSource =
  | 'BACKER_MERKLE_DISTRIBUTOR'
  | 'MERKLE_DISTRIBUTOR';

export type CommunityRewardsToken_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<CommunityRewardsToken_Filter>>>;
  cliffLength?: InputMaybe<Scalars['BigInt']>;
  cliffLength_gt?: InputMaybe<Scalars['BigInt']>;
  cliffLength_gte?: InputMaybe<Scalars['BigInt']>;
  cliffLength_in?: InputMaybe<Array<Scalars['BigInt']>>;
  cliffLength_lt?: InputMaybe<Scalars['BigInt']>;
  cliffLength_lte?: InputMaybe<Scalars['BigInt']>;
  cliffLength_not?: InputMaybe<Scalars['BigInt']>;
  cliffLength_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  endTime?: InputMaybe<Scalars['BigInt']>;
  endTime_gt?: InputMaybe<Scalars['BigInt']>;
  endTime_gte?: InputMaybe<Scalars['BigInt']>;
  endTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  endTime_lt?: InputMaybe<Scalars['BigInt']>;
  endTime_lte?: InputMaybe<Scalars['BigInt']>;
  endTime_not?: InputMaybe<Scalars['BigInt']>;
  endTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  grantedAt?: InputMaybe<Scalars['BigInt']>;
  grantedAt_gt?: InputMaybe<Scalars['BigInt']>;
  grantedAt_gte?: InputMaybe<Scalars['BigInt']>;
  grantedAt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  grantedAt_lt?: InputMaybe<Scalars['BigInt']>;
  grantedAt_lte?: InputMaybe<Scalars['BigInt']>;
  grantedAt_not?: InputMaybe<Scalars['BigInt']>;
  grantedAt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  index?: InputMaybe<Scalars['Int']>;
  index_gt?: InputMaybe<Scalars['Int']>;
  index_gte?: InputMaybe<Scalars['Int']>;
  index_in?: InputMaybe<Array<Scalars['Int']>>;
  index_lt?: InputMaybe<Scalars['Int']>;
  index_lte?: InputMaybe<Scalars['Int']>;
  index_not?: InputMaybe<Scalars['Int']>;
  index_not_in?: InputMaybe<Array<Scalars['Int']>>;
  or?: InputMaybe<Array<InputMaybe<CommunityRewardsToken_Filter>>>;
  revokedAt?: InputMaybe<Scalars['BigInt']>;
  revokedAt_gt?: InputMaybe<Scalars['BigInt']>;
  revokedAt_gte?: InputMaybe<Scalars['BigInt']>;
  revokedAt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  revokedAt_lt?: InputMaybe<Scalars['BigInt']>;
  revokedAt_lte?: InputMaybe<Scalars['BigInt']>;
  revokedAt_not?: InputMaybe<Scalars['BigInt']>;
  revokedAt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  source?: InputMaybe<CommunityRewardsTokenSource>;
  source_in?: InputMaybe<Array<CommunityRewardsTokenSource>>;
  source_not?: InputMaybe<CommunityRewardsTokenSource>;
  source_not_in?: InputMaybe<Array<CommunityRewardsTokenSource>>;
  startTime?: InputMaybe<Scalars['BigInt']>;
  startTime_gt?: InputMaybe<Scalars['BigInt']>;
  startTime_gte?: InputMaybe<Scalars['BigInt']>;
  startTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  startTime_lt?: InputMaybe<Scalars['BigInt']>;
  startTime_lte?: InputMaybe<Scalars['BigInt']>;
  startTime_not?: InputMaybe<Scalars['BigInt']>;
  startTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalClaimed?: InputMaybe<Scalars['BigInt']>;
  totalClaimed_gt?: InputMaybe<Scalars['BigInt']>;
  totalClaimed_gte?: InputMaybe<Scalars['BigInt']>;
  totalClaimed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalClaimed_lt?: InputMaybe<Scalars['BigInt']>;
  totalClaimed_lte?: InputMaybe<Scalars['BigInt']>;
  totalClaimed_not?: InputMaybe<Scalars['BigInt']>;
  totalClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalGranted?: InputMaybe<Scalars['BigInt']>;
  totalGranted_gt?: InputMaybe<Scalars['BigInt']>;
  totalGranted_gte?: InputMaybe<Scalars['BigInt']>;
  totalGranted_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalGranted_lt?: InputMaybe<Scalars['BigInt']>;
  totalGranted_lte?: InputMaybe<Scalars['BigInt']>;
  totalGranted_not?: InputMaybe<Scalars['BigInt']>;
  totalGranted_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vestingInterval?: InputMaybe<Scalars['BigInt']>;
  vestingInterval_gt?: InputMaybe<Scalars['BigInt']>;
  vestingInterval_gte?: InputMaybe<Scalars['BigInt']>;
  vestingInterval_in?: InputMaybe<Array<Scalars['BigInt']>>;
  vestingInterval_lt?: InputMaybe<Scalars['BigInt']>;
  vestingInterval_lte?: InputMaybe<Scalars['BigInt']>;
  vestingInterval_not?: InputMaybe<Scalars['BigInt']>;
  vestingInterval_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  vestingLength?: InputMaybe<Scalars['BigInt']>;
  vestingLength_gt?: InputMaybe<Scalars['BigInt']>;
  vestingLength_gte?: InputMaybe<Scalars['BigInt']>;
  vestingLength_in?: InputMaybe<Array<Scalars['BigInt']>>;
  vestingLength_lt?: InputMaybe<Scalars['BigInt']>;
  vestingLength_lte?: InputMaybe<Scalars['BigInt']>;
  vestingLength_not?: InputMaybe<Scalars['BigInt']>;
  vestingLength_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type CommunityRewardsToken_OrderBy =
  | 'cliffLength'
  | 'endTime'
  | 'grantedAt'
  | 'id'
  | 'index'
  | 'revokedAt'
  | 'source'
  | 'startTime'
  | 'totalClaimed'
  | 'totalGranted'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType'
  | 'vestingInterval'
  | 'vestingLength';

export type CreditLine = {
  __typename?: 'CreditLine';
  balance: Scalars['BigInt'];
  borrowerContract: BorrowerContract;
  collectedPaymentBalance: Scalars['BigInt'];
  id: Scalars['ID'];
  interestAccruedAsOf: Scalars['BigInt'];
  interestApr: Scalars['BigInt'];
  interestAprDecimal: Scalars['BigDecimal'];
  interestOwed: Scalars['BigInt'];
  isAfterTermEndTime: Scalars['Boolean'];
  isEligibleForRewards: Scalars['Boolean'];
  isInDefault: Scalars['Boolean'];
  isLate: Scalars['Boolean'];
  lastFullPaymentTime: Scalars['BigInt'];
  lateFeeApr: Scalars['BigDecimal'];
  limit: Scalars['BigInt'];
  maxLimit: Scalars['BigInt'];
  nextDueTime: Scalars['BigInt'];
  termEndTime: Scalars['BigInt'];
  termStartTime: Scalars['BigInt'];
  tranchedPool: TranchedPool;
  version: TranchedPoolCreditLineVersion;
};

export type CreditLine_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<CreditLine_Filter>>>;
  balance?: InputMaybe<Scalars['BigInt']>;
  balance_gt?: InputMaybe<Scalars['BigInt']>;
  balance_gte?: InputMaybe<Scalars['BigInt']>;
  balance_in?: InputMaybe<Array<Scalars['BigInt']>>;
  balance_lt?: InputMaybe<Scalars['BigInt']>;
  balance_lte?: InputMaybe<Scalars['BigInt']>;
  balance_not?: InputMaybe<Scalars['BigInt']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  borrowerContract?: InputMaybe<Scalars['String']>;
  borrowerContract_?: InputMaybe<BorrowerContract_Filter>;
  borrowerContract_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_gt?: InputMaybe<Scalars['String']>;
  borrowerContract_gte?: InputMaybe<Scalars['String']>;
  borrowerContract_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_lt?: InputMaybe<Scalars['String']>;
  borrowerContract_lte?: InputMaybe<Scalars['String']>;
  borrowerContract_not?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_not_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  interestAccruedAsOf?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_gt?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_gte?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAccruedAsOf_lt?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_lte?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_not?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestApr?: InputMaybe<Scalars['BigInt']>;
  interestAprDecimal?: InputMaybe<Scalars['BigDecimal']>;
  interestAprDecimal_gt?: InputMaybe<Scalars['BigDecimal']>;
  interestAprDecimal_gte?: InputMaybe<Scalars['BigDecimal']>;
  interestAprDecimal_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestAprDecimal_lt?: InputMaybe<Scalars['BigDecimal']>;
  interestAprDecimal_lte?: InputMaybe<Scalars['BigDecimal']>;
  interestAprDecimal_not?: InputMaybe<Scalars['BigDecimal']>;
  interestAprDecimal_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestApr_gt?: InputMaybe<Scalars['BigInt']>;
  interestApr_gte?: InputMaybe<Scalars['BigInt']>;
  interestApr_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestApr_lt?: InputMaybe<Scalars['BigInt']>;
  interestApr_lte?: InputMaybe<Scalars['BigInt']>;
  interestApr_not?: InputMaybe<Scalars['BigInt']>;
  interestApr_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  isEligibleForRewards?: InputMaybe<Scalars['Boolean']>;
  isEligibleForRewards_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isEligibleForRewards_not?: InputMaybe<Scalars['Boolean']>;
  isEligibleForRewards_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  lastFullPaymentTime?: InputMaybe<Scalars['BigInt']>;
  lastFullPaymentTime_gt?: InputMaybe<Scalars['BigInt']>;
  lastFullPaymentTime_gte?: InputMaybe<Scalars['BigInt']>;
  lastFullPaymentTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lastFullPaymentTime_lt?: InputMaybe<Scalars['BigInt']>;
  lastFullPaymentTime_lte?: InputMaybe<Scalars['BigInt']>;
  lastFullPaymentTime_not?: InputMaybe<Scalars['BigInt']>;
  lastFullPaymentTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lateFeeApr?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeApr_gt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeApr_gte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeApr_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  lateFeeApr_lt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeApr_lte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeApr_not?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeApr_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  limit_gt?: InputMaybe<Scalars['BigInt']>;
  limit_gte?: InputMaybe<Scalars['BigInt']>;
  limit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  limit_lt?: InputMaybe<Scalars['BigInt']>;
  limit_lte?: InputMaybe<Scalars['BigInt']>;
  limit_not?: InputMaybe<Scalars['BigInt']>;
  limit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxLimit?: InputMaybe<Scalars['BigInt']>;
  maxLimit_gt?: InputMaybe<Scalars['BigInt']>;
  maxLimit_gte?: InputMaybe<Scalars['BigInt']>;
  maxLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxLimit_lt?: InputMaybe<Scalars['BigInt']>;
  maxLimit_lte?: InputMaybe<Scalars['BigInt']>;
  maxLimit_not?: InputMaybe<Scalars['BigInt']>;
  maxLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  nextDueTime?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_gt?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_gte?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  nextDueTime_lt?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_lte?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_not?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<CreditLine_Filter>>>;
  termEndTime?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termEndTime_lt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_lte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termStartTime?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termStartTime_lt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_lte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tranchedPool_?: InputMaybe<TranchedPool_Filter>;
  version?: InputMaybe<TranchedPoolCreditLineVersion>;
  version_in?: InputMaybe<Array<TranchedPoolCreditLineVersion>>;
  version_not?: InputMaybe<TranchedPoolCreditLineVersion>;
  version_not_in?: InputMaybe<Array<TranchedPoolCreditLineVersion>>;
};

export type CreditLine_OrderBy =
  | 'balance'
  | 'borrowerContract'
  | 'borrowerContract__createdAt'
  | 'borrowerContract__id'
  | 'id'
  | 'interestAccruedAsOf'
  | 'interestApr'
  | 'interestAprDecimal'
  | 'isEligibleForRewards'
  | 'lastFullPaymentTime'
  | 'lateFeeApr'
  | 'limit'
  | 'maxLimit'
  | 'nextDueTime'
  | 'termEndTime'
  | 'termStartTime'
  | 'tranchedPool'
  | 'tranchedPool__actualSeniorPoolInvestment'
  | 'tranchedPool__address'
  | 'tranchedPool__balance'
  | 'tranchedPool__createdAt'
  | 'tranchedPool__creditLineAddress'
  | 'tranchedPool__drawdownsPaused'
  | 'tranchedPool__estimatedLeverageRatio'
  | 'tranchedPool__estimatedSeniorPoolContribution'
  | 'tranchedPool__estimatedTotalAssets'
  | 'tranchedPool__fundableAt'
  | 'tranchedPool__fundingLimit'
  | 'tranchedPool__id'
  | 'tranchedPool__initialInterestOwed'
  | 'tranchedPool__interestAccruedAsOf'
  | 'tranchedPool__interestAmountRepaid'
  | 'tranchedPool__interestRate'
  | 'tranchedPool__interestRateBigInt'
  | 'tranchedPool__interestWrittenDown'
  | 'tranchedPool__isPaused'
  | 'tranchedPool__isV1StyleDeal'
  | 'tranchedPool__juniorDeposited'
  | 'tranchedPool__juniorFeePercent'
  | 'tranchedPool__lateFeeRate'
  | 'tranchedPool__nextDueTime'
  | 'tranchedPool__numBackers'
  | 'tranchedPool__numRepayments'
  | 'tranchedPool__principalAmount'
  | 'tranchedPool__principalAmountRepaid'
  | 'tranchedPool__principalWrittenDown'
  | 'tranchedPool__rawGfiApy'
  | 'tranchedPool__remainingCapacity'
  | 'tranchedPool__repaymentFrequency'
  | 'tranchedPool__reserveFeePercent'
  | 'tranchedPool__termEndTime'
  | 'tranchedPool__termInSeconds'
  | 'tranchedPool__termStartTime'
  | 'tranchedPool__totalDeposited'
  | 'tranchedPool__usdcApy'
  | 'tranchedPool__version'
  | 'version';

export type CurvePool = {
  __typename?: 'CurvePool';
  estimatedCurveStakingApyRaw: Scalars['BigDecimal'];
  usdPerLpToken: Scalars['BigDecimal'];
};

export type Deal = {
  __typename?: 'Deal';
  agreement?: Maybe<Scalars['String']>;
  borrower: Borrower;
  category: Scalars['String'];
  collateralAssets?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  creditMemos?: Maybe<Array<Deal_CreditMemos>>;
  dataroom?: Maybe<Scalars['String']>;
  dealType?: Maybe<Deal_DealType>;
  defaultInterestRate?: Maybe<Scalars['Float']>;
  details?: Maybe<Scalars['JSON']>;
  documents?: Maybe<Array<Deal_Documents>>;
  dueDiligenceContact?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  highlights?: Maybe<Array<Deal_Highlights>>;
  id: Scalars['String'];
  name: Scalars['String'];
  offChainCapitalPriority?: Maybe<Deal_OffChainCapitalPriority>;
  onChainCapitalPriority?: Maybe<Deal_OnChainCapitalPriority>;
  overview: Scalars['JSON'];
  securitiesAndRecourse?: Maybe<Deal_SecuritiesAndRecourse>;
  transactionStructure?: Maybe<Media>;
  updatedAt: Scalars['DateTime'];
};


export type DealCollateralAssetsArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type DealDetailsArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type DealOverviewArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type DealTransactionStructureArgs = {
  where?: InputMaybe<Deal_TransactionStructure_Where>;
};

export type Deal_CreditMemos = {
  __typename?: 'Deal_CreditMemos';
  content?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  executiveSummaryUrl?: Maybe<Scalars['String']>;
  fullMemoUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Media>;
};


export type Deal_CreditMemosThumbnailArgs = {
  where?: InputMaybe<Deal_CreditMemos_Thumbnail_Where>;
};

export type Deal_CreditMemos_Thumbnail_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_FileNameOverride_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Deal_CreditMemos_Thumbnail_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Large__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Large__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Large__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Large__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Large__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Large__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Medium__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Medium__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Medium__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Medium__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Medium__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Medium__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_CreditMemos_Thumbnail_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos_Thumbnail_Where = {
  AND?: InputMaybe<Array<InputMaybe<Deal_CreditMemos_Thumbnail_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Deal_CreditMemos_Thumbnail_Where_Or>>>;
  alt?: InputMaybe<Deal_CreditMemos_Thumbnail_Alt_Operator>;
  fileNameOverride?: InputMaybe<Deal_CreditMemos_Thumbnail_FileNameOverride_Operator>;
  filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Filename_Operator>;
  filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Filesize_Operator>;
  height?: InputMaybe<Deal_CreditMemos_Thumbnail_Height_Operator>;
  id?: InputMaybe<Deal_CreditMemos_Thumbnail_Id_Operator>;
  mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Deal_CreditMemos_Thumbnail_Url_Operator>;
  width?: InputMaybe<Deal_CreditMemos_Thumbnail_Width_Operator>;
};

export type Deal_CreditMemos_Thumbnail_Where_And = {
  alt?: InputMaybe<Deal_CreditMemos_Thumbnail_Alt_Operator>;
  fileNameOverride?: InputMaybe<Deal_CreditMemos_Thumbnail_FileNameOverride_Operator>;
  filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Filename_Operator>;
  filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Filesize_Operator>;
  height?: InputMaybe<Deal_CreditMemos_Thumbnail_Height_Operator>;
  id?: InputMaybe<Deal_CreditMemos_Thumbnail_Id_Operator>;
  mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Deal_CreditMemos_Thumbnail_Url_Operator>;
  width?: InputMaybe<Deal_CreditMemos_Thumbnail_Width_Operator>;
};

export type Deal_CreditMemos_Thumbnail_Where_Or = {
  alt?: InputMaybe<Deal_CreditMemos_Thumbnail_Alt_Operator>;
  fileNameOverride?: InputMaybe<Deal_CreditMemos_Thumbnail_FileNameOverride_Operator>;
  filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Filename_Operator>;
  filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Filesize_Operator>;
  height?: InputMaybe<Deal_CreditMemos_Thumbnail_Height_Operator>;
  id?: InputMaybe<Deal_CreditMemos_Thumbnail_Id_Operator>;
  mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Deal_CreditMemos_Thumbnail_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Deal_CreditMemos_Thumbnail_Url_Operator>;
  width?: InputMaybe<Deal_CreditMemos_Thumbnail_Width_Operator>;
};

export type Deal_CreditMemos_Thumbnail_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_Documents = Document;

export type Deal_Highlights = {
  __typename?: 'Deal_Highlights';
  body?: Maybe<Scalars['JSON']>;
  heading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};


export type Deal_HighlightsBodyArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Deal_SecuritiesAndRecourse = {
  __typename?: 'Deal_SecuritiesAndRecourse';
  covenants?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['JSON']>;
  recourse?: Maybe<Deal_SecuritiesAndRecourse_Recourse>;
  recourseDescription?: Maybe<Scalars['JSON']>;
  secured?: Maybe<Deal_SecuritiesAndRecourse_Secured>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};


export type Deal_SecuritiesAndRecourseCovenantsArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type Deal_SecuritiesAndRecourseDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type Deal_SecuritiesAndRecourseRecourseDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Deal_SecuritiesAndRecourse_Recourse =
  | 'no'
  | 'yes';

export type Deal_SecuritiesAndRecourse_Secured =
  | 'no'
  | 'yes';

export type Deal_TransactionStructure_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_FileNameOverride_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Deal_TransactionStructure_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Large__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Large__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Large__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Large__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Large__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Large__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Medium__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Medium__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Medium__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Medium__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Medium__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Medium__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_TransactionStructure_Where = {
  AND?: InputMaybe<Array<InputMaybe<Deal_TransactionStructure_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Deal_TransactionStructure_Where_Or>>>;
  alt?: InputMaybe<Deal_TransactionStructure_Alt_Operator>;
  fileNameOverride?: InputMaybe<Deal_TransactionStructure_FileNameOverride_Operator>;
  filename?: InputMaybe<Deal_TransactionStructure_Filename_Operator>;
  filesize?: InputMaybe<Deal_TransactionStructure_Filesize_Operator>;
  height?: InputMaybe<Deal_TransactionStructure_Height_Operator>;
  id?: InputMaybe<Deal_TransactionStructure_Id_Operator>;
  mimeType?: InputMaybe<Deal_TransactionStructure_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Deal_TransactionStructure_Url_Operator>;
  width?: InputMaybe<Deal_TransactionStructure_Width_Operator>;
};

export type Deal_TransactionStructure_Where_And = {
  alt?: InputMaybe<Deal_TransactionStructure_Alt_Operator>;
  fileNameOverride?: InputMaybe<Deal_TransactionStructure_FileNameOverride_Operator>;
  filename?: InputMaybe<Deal_TransactionStructure_Filename_Operator>;
  filesize?: InputMaybe<Deal_TransactionStructure_Filesize_Operator>;
  height?: InputMaybe<Deal_TransactionStructure_Height_Operator>;
  id?: InputMaybe<Deal_TransactionStructure_Id_Operator>;
  mimeType?: InputMaybe<Deal_TransactionStructure_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Deal_TransactionStructure_Url_Operator>;
  width?: InputMaybe<Deal_TransactionStructure_Width_Operator>;
};

export type Deal_TransactionStructure_Where_Or = {
  alt?: InputMaybe<Deal_TransactionStructure_Alt_Operator>;
  fileNameOverride?: InputMaybe<Deal_TransactionStructure_FileNameOverride_Operator>;
  filename?: InputMaybe<Deal_TransactionStructure_Filename_Operator>;
  filesize?: InputMaybe<Deal_TransactionStructure_Filesize_Operator>;
  height?: InputMaybe<Deal_TransactionStructure_Height_Operator>;
  id?: InputMaybe<Deal_TransactionStructure_Id_Operator>;
  mimeType?: InputMaybe<Deal_TransactionStructure_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Deal_TransactionStructure_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Deal_TransactionStructure_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Deal_TransactionStructure_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Deal_TransactionStructure_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Deal_TransactionStructure_Url_Operator>;
  width?: InputMaybe<Deal_TransactionStructure_Width_Operator>;
};

export type Deal_TransactionStructure_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_Agreement_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_Borrower_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_Category_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CollateralAssets_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Deal_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Deal_CreditMemos__Content_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Deal_CreditMemos__Date_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Deal_CreditMemos__ExecutiveSummaryUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos__FullMemoUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos__Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos__Subtitle_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_CreditMemos__Thumbnail_Operator = {
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Deal_Dataroom_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_DealType =
  | 'multitranche'
  | 'unitranche';

export type Deal_DealType_Input =
  | 'multitranche'
  | 'unitranche';

export type Deal_DealType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Deal_DealType_Input>>>;
  equals?: InputMaybe<Deal_DealType_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Deal_DealType_Input>>>;
  not_equals?: InputMaybe<Deal_DealType_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Deal_DealType_Input>>>;
};

export type Deal_DefaultInterestRate_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_Details_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Deal_DueDiligenceContact_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_Hidden_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Deal_Highlights__Body_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Deal_Highlights__Heading_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_Highlights__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Deal_Name_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_OffChainCapitalPriority =
  | 'junior'
  | 'senior';

export type Deal_OffChainCapitalPriority_Input =
  | 'junior'
  | 'senior';

export type Deal_OffChainCapitalPriority_Operator = {
  all?: InputMaybe<Array<InputMaybe<Deal_OffChainCapitalPriority_Input>>>;
  equals?: InputMaybe<Deal_OffChainCapitalPriority_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Deal_OffChainCapitalPriority_Input>>>;
  not_equals?: InputMaybe<Deal_OffChainCapitalPriority_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Deal_OffChainCapitalPriority_Input>>>;
};

export type Deal_OnChainCapitalPriority =
  | 'junior'
  | 'senior';

export type Deal_OnChainCapitalPriority_Input =
  | 'junior'
  | 'senior';

export type Deal_OnChainCapitalPriority_Operator = {
  all?: InputMaybe<Array<InputMaybe<Deal_OnChainCapitalPriority_Input>>>;
  equals?: InputMaybe<Deal_OnChainCapitalPriority_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Deal_OnChainCapitalPriority_Input>>>;
  not_equals?: InputMaybe<Deal_OnChainCapitalPriority_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Deal_OnChainCapitalPriority_Input>>>;
};

export type Deal_Overview_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Deal_SecuritiesAndRecourse__Covenants_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Deal_SecuritiesAndRecourse__Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Deal_SecuritiesAndRecourse__RecourseDescription_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Deal_SecuritiesAndRecourse__Recourse_Input =
  | 'no'
  | 'yes';

export type Deal_SecuritiesAndRecourse__Recourse_Operator = {
  all?: InputMaybe<Array<InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Input>>>;
  equals?: InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Input>>>;
  not_equals?: InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Input>>>;
};

export type Deal_SecuritiesAndRecourse__Secured_Input =
  | 'no'
  | 'yes';

export type Deal_SecuritiesAndRecourse__Secured_Operator = {
  all?: InputMaybe<Array<InputMaybe<Deal_SecuritiesAndRecourse__Secured_Input>>>;
  equals?: InputMaybe<Deal_SecuritiesAndRecourse__Secured_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Deal_SecuritiesAndRecourse__Secured_Input>>>;
  not_equals?: InputMaybe<Deal_SecuritiesAndRecourse__Secured_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Deal_SecuritiesAndRecourse__Secured_Input>>>;
};

export type Deal_SecuritiesAndRecourse__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Deal_SecuritiesAndRecourse__Value_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Deal_TransactionStructure_Operator = {
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Deal_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Deal_Where = {
  AND?: InputMaybe<Array<InputMaybe<Deal_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Deal_Where_Or>>>;
  agreement?: InputMaybe<Deal_Agreement_Operator>;
  borrower?: InputMaybe<Deal_Borrower_Operator>;
  category?: InputMaybe<Deal_Category_Operator>;
  collateralAssets?: InputMaybe<Deal_CollateralAssets_Operator>;
  createdAt?: InputMaybe<Deal_CreatedAt_Operator>;
  creditMemos__content?: InputMaybe<Deal_CreditMemos__Content_Operator>;
  creditMemos__date?: InputMaybe<Deal_CreditMemos__Date_Operator>;
  creditMemos__executiveSummaryUrl?: InputMaybe<Deal_CreditMemos__ExecutiveSummaryUrl_Operator>;
  creditMemos__fullMemoUrl?: InputMaybe<Deal_CreditMemos__FullMemoUrl_Operator>;
  creditMemos__id?: InputMaybe<Deal_CreditMemos__Id_Operator>;
  creditMemos__name?: InputMaybe<Deal_CreditMemos__Name_Operator>;
  creditMemos__subtitle?: InputMaybe<Deal_CreditMemos__Subtitle_Operator>;
  creditMemos__thumbnail?: InputMaybe<Deal_CreditMemos__Thumbnail_Operator>;
  dataroom?: InputMaybe<Deal_Dataroom_Operator>;
  dealType?: InputMaybe<Deal_DealType_Operator>;
  defaultInterestRate?: InputMaybe<Deal_DefaultInterestRate_Operator>;
  details?: InputMaybe<Deal_Details_Operator>;
  dueDiligenceContact?: InputMaybe<Deal_DueDiligenceContact_Operator>;
  hidden?: InputMaybe<Deal_Hidden_Operator>;
  highlights__body?: InputMaybe<Deal_Highlights__Body_Operator>;
  highlights__heading?: InputMaybe<Deal_Highlights__Heading_Operator>;
  highlights__id?: InputMaybe<Deal_Highlights__Id_Operator>;
  id?: InputMaybe<Deal_Id_Operator>;
  name?: InputMaybe<Deal_Name_Operator>;
  offChainCapitalPriority?: InputMaybe<Deal_OffChainCapitalPriority_Operator>;
  onChainCapitalPriority?: InputMaybe<Deal_OnChainCapitalPriority_Operator>;
  overview?: InputMaybe<Deal_Overview_Operator>;
  securitiesAndRecourse__covenants?: InputMaybe<Deal_SecuritiesAndRecourse__Covenants_Operator>;
  securitiesAndRecourse__description?: InputMaybe<Deal_SecuritiesAndRecourse__Description_Operator>;
  securitiesAndRecourse__recourse?: InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Operator>;
  securitiesAndRecourse__recourseDescription?: InputMaybe<Deal_SecuritiesAndRecourse__RecourseDescription_Operator>;
  securitiesAndRecourse__secured?: InputMaybe<Deal_SecuritiesAndRecourse__Secured_Operator>;
  securitiesAndRecourse__type?: InputMaybe<Deal_SecuritiesAndRecourse__Type_Operator>;
  securitiesAndRecourse__value?: InputMaybe<Deal_SecuritiesAndRecourse__Value_Operator>;
  transactionStructure?: InputMaybe<Deal_TransactionStructure_Operator>;
  updatedAt?: InputMaybe<Deal_UpdatedAt_Operator>;
};

export type Deal_Where_And = {
  agreement?: InputMaybe<Deal_Agreement_Operator>;
  borrower?: InputMaybe<Deal_Borrower_Operator>;
  category?: InputMaybe<Deal_Category_Operator>;
  collateralAssets?: InputMaybe<Deal_CollateralAssets_Operator>;
  createdAt?: InputMaybe<Deal_CreatedAt_Operator>;
  creditMemos__content?: InputMaybe<Deal_CreditMemos__Content_Operator>;
  creditMemos__date?: InputMaybe<Deal_CreditMemos__Date_Operator>;
  creditMemos__executiveSummaryUrl?: InputMaybe<Deal_CreditMemos__ExecutiveSummaryUrl_Operator>;
  creditMemos__fullMemoUrl?: InputMaybe<Deal_CreditMemos__FullMemoUrl_Operator>;
  creditMemos__id?: InputMaybe<Deal_CreditMemos__Id_Operator>;
  creditMemos__name?: InputMaybe<Deal_CreditMemos__Name_Operator>;
  creditMemos__subtitle?: InputMaybe<Deal_CreditMemos__Subtitle_Operator>;
  creditMemos__thumbnail?: InputMaybe<Deal_CreditMemos__Thumbnail_Operator>;
  dataroom?: InputMaybe<Deal_Dataroom_Operator>;
  dealType?: InputMaybe<Deal_DealType_Operator>;
  defaultInterestRate?: InputMaybe<Deal_DefaultInterestRate_Operator>;
  details?: InputMaybe<Deal_Details_Operator>;
  dueDiligenceContact?: InputMaybe<Deal_DueDiligenceContact_Operator>;
  hidden?: InputMaybe<Deal_Hidden_Operator>;
  highlights__body?: InputMaybe<Deal_Highlights__Body_Operator>;
  highlights__heading?: InputMaybe<Deal_Highlights__Heading_Operator>;
  highlights__id?: InputMaybe<Deal_Highlights__Id_Operator>;
  id?: InputMaybe<Deal_Id_Operator>;
  name?: InputMaybe<Deal_Name_Operator>;
  offChainCapitalPriority?: InputMaybe<Deal_OffChainCapitalPriority_Operator>;
  onChainCapitalPriority?: InputMaybe<Deal_OnChainCapitalPriority_Operator>;
  overview?: InputMaybe<Deal_Overview_Operator>;
  securitiesAndRecourse__covenants?: InputMaybe<Deal_SecuritiesAndRecourse__Covenants_Operator>;
  securitiesAndRecourse__description?: InputMaybe<Deal_SecuritiesAndRecourse__Description_Operator>;
  securitiesAndRecourse__recourse?: InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Operator>;
  securitiesAndRecourse__recourseDescription?: InputMaybe<Deal_SecuritiesAndRecourse__RecourseDescription_Operator>;
  securitiesAndRecourse__secured?: InputMaybe<Deal_SecuritiesAndRecourse__Secured_Operator>;
  securitiesAndRecourse__type?: InputMaybe<Deal_SecuritiesAndRecourse__Type_Operator>;
  securitiesAndRecourse__value?: InputMaybe<Deal_SecuritiesAndRecourse__Value_Operator>;
  transactionStructure?: InputMaybe<Deal_TransactionStructure_Operator>;
  updatedAt?: InputMaybe<Deal_UpdatedAt_Operator>;
};

export type Deal_Where_Or = {
  agreement?: InputMaybe<Deal_Agreement_Operator>;
  borrower?: InputMaybe<Deal_Borrower_Operator>;
  category?: InputMaybe<Deal_Category_Operator>;
  collateralAssets?: InputMaybe<Deal_CollateralAssets_Operator>;
  createdAt?: InputMaybe<Deal_CreatedAt_Operator>;
  creditMemos__content?: InputMaybe<Deal_CreditMemos__Content_Operator>;
  creditMemos__date?: InputMaybe<Deal_CreditMemos__Date_Operator>;
  creditMemos__executiveSummaryUrl?: InputMaybe<Deal_CreditMemos__ExecutiveSummaryUrl_Operator>;
  creditMemos__fullMemoUrl?: InputMaybe<Deal_CreditMemos__FullMemoUrl_Operator>;
  creditMemos__id?: InputMaybe<Deal_CreditMemos__Id_Operator>;
  creditMemos__name?: InputMaybe<Deal_CreditMemos__Name_Operator>;
  creditMemos__subtitle?: InputMaybe<Deal_CreditMemos__Subtitle_Operator>;
  creditMemos__thumbnail?: InputMaybe<Deal_CreditMemos__Thumbnail_Operator>;
  dataroom?: InputMaybe<Deal_Dataroom_Operator>;
  dealType?: InputMaybe<Deal_DealType_Operator>;
  defaultInterestRate?: InputMaybe<Deal_DefaultInterestRate_Operator>;
  details?: InputMaybe<Deal_Details_Operator>;
  dueDiligenceContact?: InputMaybe<Deal_DueDiligenceContact_Operator>;
  hidden?: InputMaybe<Deal_Hidden_Operator>;
  highlights__body?: InputMaybe<Deal_Highlights__Body_Operator>;
  highlights__heading?: InputMaybe<Deal_Highlights__Heading_Operator>;
  highlights__id?: InputMaybe<Deal_Highlights__Id_Operator>;
  id?: InputMaybe<Deal_Id_Operator>;
  name?: InputMaybe<Deal_Name_Operator>;
  offChainCapitalPriority?: InputMaybe<Deal_OffChainCapitalPriority_Operator>;
  onChainCapitalPriority?: InputMaybe<Deal_OnChainCapitalPriority_Operator>;
  overview?: InputMaybe<Deal_Overview_Operator>;
  securitiesAndRecourse__covenants?: InputMaybe<Deal_SecuritiesAndRecourse__Covenants_Operator>;
  securitiesAndRecourse__description?: InputMaybe<Deal_SecuritiesAndRecourse__Description_Operator>;
  securitiesAndRecourse__recourse?: InputMaybe<Deal_SecuritiesAndRecourse__Recourse_Operator>;
  securitiesAndRecourse__recourseDescription?: InputMaybe<Deal_SecuritiesAndRecourse__RecourseDescription_Operator>;
  securitiesAndRecourse__secured?: InputMaybe<Deal_SecuritiesAndRecourse__Secured_Operator>;
  securitiesAndRecourse__type?: InputMaybe<Deal_SecuritiesAndRecourse__Type_Operator>;
  securitiesAndRecourse__value?: InputMaybe<Deal_SecuritiesAndRecourse__Value_Operator>;
  transactionStructure?: InputMaybe<Deal_TransactionStructure_Operator>;
  updatedAt?: InputMaybe<Deal_UpdatedAt_Operator>;
};

export type Deals = {
  __typename?: 'Deals';
  docs?: Maybe<Array<Maybe<Deal>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type DirectGfiGrant = GfiGrant & {
  __typename?: 'DirectGfiGrant';
  amount: Scalars['BigInt'];
  directSource: DirectGrantSource;
  id: Scalars['ID'];
  index: Scalars['Int'];
  isAccepted: Scalars['Boolean'];
  proof: Array<Scalars['String']>;
  reason: GrantReason;
};

export type DirectGrantSource =
  | 'BACKER_MERKLE_DIRECT_DISTRIBUTOR'
  | 'MERKLE_DIRECT_DISTRIBUTOR';

export type Document = {
  __typename?: 'Document';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  file?: Maybe<Media>;
  id?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type DocumentFileArgs = {
  where?: InputMaybe<Document_File_Where>;
};

export type Document_File_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_FileNameOverride_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Document_File_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Large__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Large__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Large__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Large__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Large__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Large__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Medium__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Medium__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Medium__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Medium__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Medium__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Medium__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Document_File_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Document_File_Where = {
  AND?: InputMaybe<Array<InputMaybe<Document_File_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Document_File_Where_Or>>>;
  alt?: InputMaybe<Document_File_Alt_Operator>;
  fileNameOverride?: InputMaybe<Document_File_FileNameOverride_Operator>;
  filename?: InputMaybe<Document_File_Filename_Operator>;
  filesize?: InputMaybe<Document_File_Filesize_Operator>;
  height?: InputMaybe<Document_File_Height_Operator>;
  id?: InputMaybe<Document_File_Id_Operator>;
  mimeType?: InputMaybe<Document_File_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Document_File_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Document_File_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Document_File_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Document_File_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Document_File_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Document_File_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Document_File_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Document_File_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Document_File_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Document_File_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Document_File_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Document_File_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Document_File_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Document_File_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Document_File_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Document_File_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Document_File_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Document_File_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Document_File_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Document_File_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Document_File_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Document_File_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Document_File_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Document_File_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Document_File_Url_Operator>;
  width?: InputMaybe<Document_File_Width_Operator>;
};

export type Document_File_Where_And = {
  alt?: InputMaybe<Document_File_Alt_Operator>;
  fileNameOverride?: InputMaybe<Document_File_FileNameOverride_Operator>;
  filename?: InputMaybe<Document_File_Filename_Operator>;
  filesize?: InputMaybe<Document_File_Filesize_Operator>;
  height?: InputMaybe<Document_File_Height_Operator>;
  id?: InputMaybe<Document_File_Id_Operator>;
  mimeType?: InputMaybe<Document_File_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Document_File_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Document_File_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Document_File_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Document_File_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Document_File_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Document_File_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Document_File_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Document_File_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Document_File_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Document_File_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Document_File_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Document_File_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Document_File_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Document_File_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Document_File_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Document_File_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Document_File_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Document_File_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Document_File_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Document_File_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Document_File_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Document_File_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Document_File_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Document_File_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Document_File_Url_Operator>;
  width?: InputMaybe<Document_File_Width_Operator>;
};

export type Document_File_Where_Or = {
  alt?: InputMaybe<Document_File_Alt_Operator>;
  fileNameOverride?: InputMaybe<Document_File_FileNameOverride_Operator>;
  filename?: InputMaybe<Document_File_Filename_Operator>;
  filesize?: InputMaybe<Document_File_Filesize_Operator>;
  height?: InputMaybe<Document_File_Height_Operator>;
  id?: InputMaybe<Document_File_Id_Operator>;
  mimeType?: InputMaybe<Document_File_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<Document_File_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<Document_File_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<Document_File_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<Document_File_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<Document_File_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<Document_File_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<Document_File_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<Document_File_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<Document_File_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<Document_File_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<Document_File_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<Document_File_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<Document_File_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<Document_File_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<Document_File_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<Document_File_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<Document_File_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<Document_File_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<Document_File_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<Document_File_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<Document_File_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<Document_File_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<Document_File_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<Document_File_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<Document_File_Url_Operator>;
  width?: InputMaybe<Document_File_Width_Operator>;
};

export type Document_File_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type FiatAmount = {
  __typename?: 'FiatAmount';
  amount: Scalars['Float'];
  symbol: SupportedFiat;
};

export type GfiGrant = {
  amount: Scalars['BigInt'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  proof: Array<Scalars['String']>;
  reason: GrantReason;
};

export type GfiPrice = {
  __typename?: 'GfiPrice';
  lastUpdated: Scalars['Int'];
  /** Note that the cache ID for this type is price.symbol. Remember to always select it to avoid cache problems */
  price: FiatAmount;
};

export type GrantReason =
  | 'ADVISOR'
  | 'BACKER'
  | 'CONTRIBUTOR'
  | 'FLIGHT_ACADEMY'
  | 'FLIGHT_ACADEMY_AND_LIQUIDITY_PROVIDER'
  | 'GOLDFINCH_INVESTMENT'
  | 'LIQUIDITY_PROVIDER';

export type IndirectGfiGrant = GfiGrant & {
  __typename?: 'IndirectGfiGrant';
  amount: Scalars['BigInt'];
  cliffLength: Scalars['BigInt'];
  end: Scalars['BigInt'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  indirectSource: IndirectGrantSource;
  proof: Array<Scalars['String']>;
  reason: GrantReason;
  start: Scalars['BigInt'];
  vested: Scalars['BigInt'];
  vestingInterval: Scalars['BigInt'];
  vestingLength: Scalars['BigInt'];
};

export type IndirectGrantSource =
  | 'BACKER_MERKLE_DISTRIBUTOR'
  | 'MERKLE_DISTRIBUTOR';

export type JuniorTrancheInfo = TrancheInfo & {
  __typename?: 'JuniorTrancheInfo';
  id: Scalars['ID'];
  interestSharePrice: Scalars['BigInt'];
  loan: Loan;
  lockedUntil: Scalars['BigInt'];
  principalDeposited: Scalars['BigInt'];
  principalSharePrice: Scalars['BigInt'];
  trancheId: Scalars['BigInt'];
  tranchedPool: TranchedPool;
};

export type JuniorTrancheInfo_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<JuniorTrancheInfo_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  interestSharePrice?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_gt?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_gte?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestSharePrice_lt?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_lte?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_not?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  loan?: InputMaybe<Scalars['String']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_ends_with?: InputMaybe<Scalars['String']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_gt?: InputMaybe<Scalars['String']>;
  loan_gte?: InputMaybe<Scalars['String']>;
  loan_in?: InputMaybe<Array<Scalars['String']>>;
  loan_lt?: InputMaybe<Scalars['String']>;
  loan_lte?: InputMaybe<Scalars['String']>;
  loan_not?: InputMaybe<Scalars['String']>;
  loan_not_contains?: InputMaybe<Scalars['String']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  loan_starts_with?: InputMaybe<Scalars['String']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']>;
  lockedUntil?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_gt?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_gte?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lockedUntil_lt?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_lte?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_not?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<JuniorTrancheInfo_Filter>>>;
  principalDeposited?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_gt?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_gte?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalDeposited_lt?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_lte?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_not?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalSharePrice?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_gt?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_gte?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalSharePrice_lt?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_lte?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_not?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  trancheId?: InputMaybe<Scalars['BigInt']>;
  trancheId_gt?: InputMaybe<Scalars['BigInt']>;
  trancheId_gte?: InputMaybe<Scalars['BigInt']>;
  trancheId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  trancheId_lt?: InputMaybe<Scalars['BigInt']>;
  trancheId_lte?: InputMaybe<Scalars['BigInt']>;
  trancheId_not?: InputMaybe<Scalars['BigInt']>;
  trancheId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tranchedPool?: InputMaybe<Scalars['String']>;
  tranchedPool_?: InputMaybe<TranchedPool_Filter>;
  tranchedPool_contains?: InputMaybe<Scalars['String']>;
  tranchedPool_contains_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_ends_with?: InputMaybe<Scalars['String']>;
  tranchedPool_ends_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_gt?: InputMaybe<Scalars['String']>;
  tranchedPool_gte?: InputMaybe<Scalars['String']>;
  tranchedPool_in?: InputMaybe<Array<Scalars['String']>>;
  tranchedPool_lt?: InputMaybe<Scalars['String']>;
  tranchedPool_lte?: InputMaybe<Scalars['String']>;
  tranchedPool_not?: InputMaybe<Scalars['String']>;
  tranchedPool_not_contains?: InputMaybe<Scalars['String']>;
  tranchedPool_not_contains_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_not_ends_with?: InputMaybe<Scalars['String']>;
  tranchedPool_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_not_in?: InputMaybe<Array<Scalars['String']>>;
  tranchedPool_not_starts_with?: InputMaybe<Scalars['String']>;
  tranchedPool_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_starts_with?: InputMaybe<Scalars['String']>;
  tranchedPool_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type JuniorTrancheInfo_OrderBy =
  | 'id'
  | 'interestSharePrice'
  | 'loan'
  | 'loan__address'
  | 'loan__balance'
  | 'loan__createdAt'
  | 'loan__creditLineAddress'
  | 'loan__drawdownsPaused'
  | 'loan__fundableAt'
  | 'loan__fundingLimit'
  | 'loan__id'
  | 'loan__initialInterestOwed'
  | 'loan__interestAmountRepaid'
  | 'loan__interestRate'
  | 'loan__interestRateBigInt'
  | 'loan__interestWrittenDown'
  | 'loan__isPaused'
  | 'loan__lateFeeRate'
  | 'loan__numBackers'
  | 'loan__numRepayments'
  | 'loan__principalAmount'
  | 'loan__principalAmountRepaid'
  | 'loan__principalWrittenDown'
  | 'loan__rawGfiApy'
  | 'loan__remainingCapacity'
  | 'loan__repaymentFrequency'
  | 'loan__termEndTime'
  | 'loan__termInSeconds'
  | 'loan__termStartTime'
  | 'loan__totalDeposited'
  | 'loan__usdcApy'
  | 'lockedUntil'
  | 'principalDeposited'
  | 'principalSharePrice'
  | 'trancheId'
  | 'tranchedPool'
  | 'tranchedPool__actualSeniorPoolInvestment'
  | 'tranchedPool__address'
  | 'tranchedPool__balance'
  | 'tranchedPool__createdAt'
  | 'tranchedPool__creditLineAddress'
  | 'tranchedPool__drawdownsPaused'
  | 'tranchedPool__estimatedLeverageRatio'
  | 'tranchedPool__estimatedSeniorPoolContribution'
  | 'tranchedPool__estimatedTotalAssets'
  | 'tranchedPool__fundableAt'
  | 'tranchedPool__fundingLimit'
  | 'tranchedPool__id'
  | 'tranchedPool__initialInterestOwed'
  | 'tranchedPool__interestAccruedAsOf'
  | 'tranchedPool__interestAmountRepaid'
  | 'tranchedPool__interestRate'
  | 'tranchedPool__interestRateBigInt'
  | 'tranchedPool__interestWrittenDown'
  | 'tranchedPool__isPaused'
  | 'tranchedPool__isV1StyleDeal'
  | 'tranchedPool__juniorDeposited'
  | 'tranchedPool__juniorFeePercent'
  | 'tranchedPool__lateFeeRate'
  | 'tranchedPool__nextDueTime'
  | 'tranchedPool__numBackers'
  | 'tranchedPool__numRepayments'
  | 'tranchedPool__principalAmount'
  | 'tranchedPool__principalAmountRepaid'
  | 'tranchedPool__principalWrittenDown'
  | 'tranchedPool__rawGfiApy'
  | 'tranchedPool__remainingCapacity'
  | 'tranchedPool__repaymentFrequency'
  | 'tranchedPool__reserveFeePercent'
  | 'tranchedPool__termEndTime'
  | 'tranchedPool__termInSeconds'
  | 'tranchedPool__termStartTime'
  | 'tranchedPool__totalDeposited'
  | 'tranchedPool__usdcApy'
  | 'tranchedPool__version';

export type KycStatus = {
  __typename?: 'KycStatus';
  accreditationStatus?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  identityStatus?: Maybe<Scalars['String']>;
  kycProvider?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type Loan = {
  address: Scalars['Bytes'];
  allowedUidTypes: Array<UidType>;
  backers: Array<User>;
  balance: Scalars['BigInt'];
  borrowerContract: BorrowerContract;
  borrowerLogo?: Maybe<Scalars['String']>;
  borrowerName: Scalars['String'];
  createdAt: Scalars['Int'];
  creditLineAddress: Scalars['Bytes'];
  delinquency: LoanDelinquency;
  drawdownsPaused: Scalars['Boolean'];
  fundableAt: Scalars['Int'];
  fundingLimit: Scalars['BigInt'];
  id: Scalars['ID'];
  /** The amount of interest determined to be owed to this pool, calculated at the very beginning */
  initialInterestOwed: Scalars['BigInt'];
  interestAmountRepaid: Scalars['BigInt'];
  interestRate: Scalars['BigDecimal'];
  interestRateBigInt: Scalars['BigInt'];
  interestWrittenDown: Scalars['BigInt'];
  isAfterTermEndTime: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  lateFeeRate: Scalars['BigDecimal'];
  name: Scalars['String'];
  numBackers: Scalars['Int'];
  numRepayments: Scalars['Int'];
  principalAmount: Scalars['BigInt'];
  principalAmountRepaid: Scalars['BigInt'];
  principalWrittenDown: Scalars['BigInt'];
  rawGfiApy: Scalars['BigDecimal'];
  remainingCapacity: Scalars['BigInt'];
  repaymentFrequency: RepaymentFrequency;
  repaymentSchedule: Array<ScheduledRepayment>;
  termEndTime: Scalars['BigInt'];
  termInSeconds: Scalars['Int'];
  termStartTime: Scalars['BigInt'];
  tokens: Array<PoolToken>;
  totalDeposited: Scalars['BigInt'];
  usdcApy: Scalars['BigDecimal'];
};


export type LoanBackersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<User_Filter>;
};


export type LoanRepaymentScheduleArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ScheduledRepayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledRepayment_Filter>;
};


export type LoanTokensArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PoolToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PoolToken_Filter>;
};

export type LoanDelinquency =
  | 'CURRENT'
  | 'GRACE_PERIOD'
  | 'LATE';

export type LoanPhase =
  | 'DrawdownPeriod'
  | 'Funding'
  | 'InProgress'
  | 'Prefunding';

export type Loan_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['Bytes']>;
  address_contains?: InputMaybe<Scalars['Bytes']>;
  address_gt?: InputMaybe<Scalars['Bytes']>;
  address_gte?: InputMaybe<Scalars['Bytes']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_lt?: InputMaybe<Scalars['Bytes']>;
  address_lte?: InputMaybe<Scalars['Bytes']>;
  address_not?: InputMaybe<Scalars['Bytes']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  allowedUidTypes?: InputMaybe<Array<UidType>>;
  allowedUidTypes_contains?: InputMaybe<Array<UidType>>;
  allowedUidTypes_not?: InputMaybe<Array<UidType>>;
  allowedUidTypes_not_contains?: InputMaybe<Array<UidType>>;
  and?: InputMaybe<Array<InputMaybe<Loan_Filter>>>;
  backers?: InputMaybe<Array<Scalars['String']>>;
  backers_?: InputMaybe<User_Filter>;
  backers_contains?: InputMaybe<Array<Scalars['String']>>;
  backers_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  backers_not?: InputMaybe<Array<Scalars['String']>>;
  backers_not_contains?: InputMaybe<Array<Scalars['String']>>;
  backers_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  balance?: InputMaybe<Scalars['BigInt']>;
  balance_gt?: InputMaybe<Scalars['BigInt']>;
  balance_gte?: InputMaybe<Scalars['BigInt']>;
  balance_in?: InputMaybe<Array<Scalars['BigInt']>>;
  balance_lt?: InputMaybe<Scalars['BigInt']>;
  balance_lte?: InputMaybe<Scalars['BigInt']>;
  balance_not?: InputMaybe<Scalars['BigInt']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  borrowerContract?: InputMaybe<Scalars['String']>;
  borrowerContract_?: InputMaybe<BorrowerContract_Filter>;
  borrowerContract_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_gt?: InputMaybe<Scalars['String']>;
  borrowerContract_gte?: InputMaybe<Scalars['String']>;
  borrowerContract_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_lt?: InputMaybe<Scalars['String']>;
  borrowerContract_lte?: InputMaybe<Scalars['String']>;
  borrowerContract_not?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_not_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with_nocase?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Int']>;
  createdAt_gt?: InputMaybe<Scalars['Int']>;
  createdAt_gte?: InputMaybe<Scalars['Int']>;
  createdAt_in?: InputMaybe<Array<Scalars['Int']>>;
  createdAt_lt?: InputMaybe<Scalars['Int']>;
  createdAt_lte?: InputMaybe<Scalars['Int']>;
  createdAt_not?: InputMaybe<Scalars['Int']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  creditLineAddress?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_contains?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_gt?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_gte?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  creditLineAddress_lt?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_lte?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  drawdownsPaused?: InputMaybe<Scalars['Boolean']>;
  drawdownsPaused_in?: InputMaybe<Array<Scalars['Boolean']>>;
  drawdownsPaused_not?: InputMaybe<Scalars['Boolean']>;
  drawdownsPaused_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  fundableAt?: InputMaybe<Scalars['Int']>;
  fundableAt_gt?: InputMaybe<Scalars['Int']>;
  fundableAt_gte?: InputMaybe<Scalars['Int']>;
  fundableAt_in?: InputMaybe<Array<Scalars['Int']>>;
  fundableAt_lt?: InputMaybe<Scalars['Int']>;
  fundableAt_lte?: InputMaybe<Scalars['Int']>;
  fundableAt_not?: InputMaybe<Scalars['Int']>;
  fundableAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  fundingLimit?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_gt?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_gte?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fundingLimit_lt?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_lte?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_not?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  initialInterestOwed?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_gt?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_gte?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  initialInterestOwed_lt?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_lte?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_not?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAmountRepaid?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_gt?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_gte?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAmountRepaid_lt?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_lte?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_not?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRate?: InputMaybe<Scalars['BigDecimal']>;
  interestRateBigInt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_gt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_gte?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRateBigInt_lt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_lte?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_not?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_not?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestWrittenDown?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_gt?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_gte?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestWrittenDown_lt?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_lte?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_not?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPaused_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isPaused_not?: InputMaybe<Scalars['Boolean']>;
  isPaused_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  lateFeeRate?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  lateFeeRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_not?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  numBackers?: InputMaybe<Scalars['Int']>;
  numBackers_gt?: InputMaybe<Scalars['Int']>;
  numBackers_gte?: InputMaybe<Scalars['Int']>;
  numBackers_in?: InputMaybe<Array<Scalars['Int']>>;
  numBackers_lt?: InputMaybe<Scalars['Int']>;
  numBackers_lte?: InputMaybe<Scalars['Int']>;
  numBackers_not?: InputMaybe<Scalars['Int']>;
  numBackers_not_in?: InputMaybe<Array<Scalars['Int']>>;
  numRepayments?: InputMaybe<Scalars['Int']>;
  numRepayments_gt?: InputMaybe<Scalars['Int']>;
  numRepayments_gte?: InputMaybe<Scalars['Int']>;
  numRepayments_in?: InputMaybe<Array<Scalars['Int']>>;
  numRepayments_lt?: InputMaybe<Scalars['Int']>;
  numRepayments_lte?: InputMaybe<Scalars['Int']>;
  numRepayments_not?: InputMaybe<Scalars['Int']>;
  numRepayments_not_in?: InputMaybe<Array<Scalars['Int']>>;
  or?: InputMaybe<Array<InputMaybe<Loan_Filter>>>;
  principalAmount?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_gt?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_gte?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmountRepaid_lt?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_lte?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_not?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmount_gt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_gte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmount_lt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_lte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalWrittenDown?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_gt?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_gte?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalWrittenDown_lt?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_lte?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_not?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rawGfiApy?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_gt?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_gte?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  rawGfiApy_lt?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_lte?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_not?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  remainingCapacity?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_gt?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_gte?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_in?: InputMaybe<Array<Scalars['BigInt']>>;
  remainingCapacity_lt?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_lte?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_not?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  repaymentFrequency?: InputMaybe<RepaymentFrequency>;
  repaymentFrequency_in?: InputMaybe<Array<RepaymentFrequency>>;
  repaymentFrequency_not?: InputMaybe<RepaymentFrequency>;
  repaymentFrequency_not_in?: InputMaybe<Array<RepaymentFrequency>>;
  repaymentSchedule?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_?: InputMaybe<ScheduledRepayment_Filter>;
  repaymentSchedule_contains?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not_contains?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  termEndTime?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termEndTime_lt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_lte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termInSeconds?: InputMaybe<Scalars['Int']>;
  termInSeconds_gt?: InputMaybe<Scalars['Int']>;
  termInSeconds_gte?: InputMaybe<Scalars['Int']>;
  termInSeconds_in?: InputMaybe<Array<Scalars['Int']>>;
  termInSeconds_lt?: InputMaybe<Scalars['Int']>;
  termInSeconds_lte?: InputMaybe<Scalars['Int']>;
  termInSeconds_not?: InputMaybe<Scalars['Int']>;
  termInSeconds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  termStartTime?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termStartTime_lt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_lte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tokens?: InputMaybe<Array<Scalars['String']>>;
  tokens_?: InputMaybe<PoolToken_Filter>;
  tokens_contains?: InputMaybe<Array<Scalars['String']>>;
  tokens_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  tokens_not?: InputMaybe<Array<Scalars['String']>>;
  tokens_not_contains?: InputMaybe<Array<Scalars['String']>>;
  tokens_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  totalDeposited?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_gt?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_gte?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalDeposited_lt?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_lte?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_not?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcApy?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_gt?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_gte?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  usdcApy_lt?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_lte?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_not?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
};

export type Loan_OrderBy =
  | 'address'
  | 'allowedUidTypes'
  | 'backers'
  | 'balance'
  | 'borrowerContract'
  | 'borrowerContract__createdAt'
  | 'borrowerContract__id'
  | 'createdAt'
  | 'creditLineAddress'
  | 'drawdownsPaused'
  | 'fundableAt'
  | 'fundingLimit'
  | 'id'
  | 'initialInterestOwed'
  | 'interestAmountRepaid'
  | 'interestRate'
  | 'interestRateBigInt'
  | 'interestWrittenDown'
  | 'isPaused'
  | 'lateFeeRate'
  | 'numBackers'
  | 'numRepayments'
  | 'principalAmount'
  | 'principalAmountRepaid'
  | 'principalWrittenDown'
  | 'rawGfiApy'
  | 'remainingCapacity'
  | 'repaymentFrequency'
  | 'repaymentSchedule'
  | 'termEndTime'
  | 'termInSeconds'
  | 'termStartTime'
  | 'tokens'
  | 'totalDeposited'
  | 'usdcApy';

export type Media = {
  __typename?: 'Media';
  alt?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fileNameOverride?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  sizes?: Maybe<Media_Sizes>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Media_Sizes = {
  __typename?: 'Media_Sizes';
  large?: Maybe<Media_Sizes_Large>;
  medium?: Maybe<Media_Sizes_Medium>;
  portrait?: Maybe<Media_Sizes_Portrait>;
  thumbnail?: Maybe<Media_Sizes_Thumbnail>;
};

export type Media_Sizes_Large = {
  __typename?: 'Media_Sizes_Large';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Media_Sizes_Medium = {
  __typename?: 'Media_Sizes_Medium';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Media_Sizes_Portrait = {
  __typename?: 'Media_Sizes_Portrait';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Media_Sizes_Thumbnail = {
  __typename?: 'Media_Sizes_Thumbnail';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Membership = {
  __typename?: 'Membership';
  eligibleScore: Scalars['BigInt'];
  id: Scalars['ID'];
  nextEpochScore: Scalars['BigInt'];
  user: User;
};

export type MembershipEpoch = {
  __typename?: 'MembershipEpoch';
  epoch: Scalars['BigInt'];
  finalizedAt: Scalars['Int'];
  id: Scalars['ID'];
  totalRewards: Scalars['BigInt'];
};

export type MembershipEpoch_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MembershipEpoch_Filter>>>;
  epoch?: InputMaybe<Scalars['BigInt']>;
  epoch_gt?: InputMaybe<Scalars['BigInt']>;
  epoch_gte?: InputMaybe<Scalars['BigInt']>;
  epoch_in?: InputMaybe<Array<Scalars['BigInt']>>;
  epoch_lt?: InputMaybe<Scalars['BigInt']>;
  epoch_lte?: InputMaybe<Scalars['BigInt']>;
  epoch_not?: InputMaybe<Scalars['BigInt']>;
  epoch_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  finalizedAt?: InputMaybe<Scalars['Int']>;
  finalizedAt_gt?: InputMaybe<Scalars['Int']>;
  finalizedAt_gte?: InputMaybe<Scalars['Int']>;
  finalizedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  finalizedAt_lt?: InputMaybe<Scalars['Int']>;
  finalizedAt_lte?: InputMaybe<Scalars['Int']>;
  finalizedAt_not?: InputMaybe<Scalars['Int']>;
  finalizedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<MembershipEpoch_Filter>>>;
  totalRewards?: InputMaybe<Scalars['BigInt']>;
  totalRewards_gt?: InputMaybe<Scalars['BigInt']>;
  totalRewards_gte?: InputMaybe<Scalars['BigInt']>;
  totalRewards_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalRewards_lt?: InputMaybe<Scalars['BigInt']>;
  totalRewards_lte?: InputMaybe<Scalars['BigInt']>;
  totalRewards_not?: InputMaybe<Scalars['BigInt']>;
  totalRewards_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type MembershipEpoch_OrderBy =
  | 'epoch'
  | 'finalizedAt'
  | 'id'
  | 'totalRewards';

export type MembershipRewardDisbursement = {
  __typename?: 'MembershipRewardDisbursement';
  allocatedAt: Scalars['Int'];
  epoch: Scalars['BigInt'];
  id: Scalars['ID'];
  rewards: Scalars['BigInt'];
  user: User;
};

export type MembershipRewardDisbursement_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  allocatedAt?: InputMaybe<Scalars['Int']>;
  allocatedAt_gt?: InputMaybe<Scalars['Int']>;
  allocatedAt_gte?: InputMaybe<Scalars['Int']>;
  allocatedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  allocatedAt_lt?: InputMaybe<Scalars['Int']>;
  allocatedAt_lte?: InputMaybe<Scalars['Int']>;
  allocatedAt_not?: InputMaybe<Scalars['Int']>;
  allocatedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  and?: InputMaybe<Array<InputMaybe<MembershipRewardDisbursement_Filter>>>;
  epoch?: InputMaybe<Scalars['BigInt']>;
  epoch_gt?: InputMaybe<Scalars['BigInt']>;
  epoch_gte?: InputMaybe<Scalars['BigInt']>;
  epoch_in?: InputMaybe<Array<Scalars['BigInt']>>;
  epoch_lt?: InputMaybe<Scalars['BigInt']>;
  epoch_lte?: InputMaybe<Scalars['BigInt']>;
  epoch_not?: InputMaybe<Scalars['BigInt']>;
  epoch_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<MembershipRewardDisbursement_Filter>>>;
  rewards?: InputMaybe<Scalars['BigInt']>;
  rewards_gt?: InputMaybe<Scalars['BigInt']>;
  rewards_gte?: InputMaybe<Scalars['BigInt']>;
  rewards_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rewards_lt?: InputMaybe<Scalars['BigInt']>;
  rewards_lte?: InputMaybe<Scalars['BigInt']>;
  rewards_not?: InputMaybe<Scalars['BigInt']>;
  rewards_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type MembershipRewardDisbursement_OrderBy =
  | 'allocatedAt'
  | 'epoch'
  | 'id'
  | 'rewards'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

export type MembershipRoster = {
  __typename?: 'MembershipRoster';
  eligibleScoreTotal: Scalars['BigInt'];
  id: Scalars['ID'];
  lastCheckpointedInEpoch: Scalars['BigInt'];
  members: Array<Membership>;
  nextEpochScoreTotal: Scalars['BigInt'];
};


export type MembershipRosterMembersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Membership_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Membership_Filter>;
};

export type MembershipRoster_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<MembershipRoster_Filter>>>;
  eligibleScoreTotal?: InputMaybe<Scalars['BigInt']>;
  eligibleScoreTotal_gt?: InputMaybe<Scalars['BigInt']>;
  eligibleScoreTotal_gte?: InputMaybe<Scalars['BigInt']>;
  eligibleScoreTotal_in?: InputMaybe<Array<Scalars['BigInt']>>;
  eligibleScoreTotal_lt?: InputMaybe<Scalars['BigInt']>;
  eligibleScoreTotal_lte?: InputMaybe<Scalars['BigInt']>;
  eligibleScoreTotal_not?: InputMaybe<Scalars['BigInt']>;
  eligibleScoreTotal_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  lastCheckpointedInEpoch?: InputMaybe<Scalars['BigInt']>;
  lastCheckpointedInEpoch_gt?: InputMaybe<Scalars['BigInt']>;
  lastCheckpointedInEpoch_gte?: InputMaybe<Scalars['BigInt']>;
  lastCheckpointedInEpoch_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lastCheckpointedInEpoch_lt?: InputMaybe<Scalars['BigInt']>;
  lastCheckpointedInEpoch_lte?: InputMaybe<Scalars['BigInt']>;
  lastCheckpointedInEpoch_not?: InputMaybe<Scalars['BigInt']>;
  lastCheckpointedInEpoch_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  members?: InputMaybe<Array<Scalars['String']>>;
  members_?: InputMaybe<Membership_Filter>;
  members_contains?: InputMaybe<Array<Scalars['String']>>;
  members_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  members_not?: InputMaybe<Array<Scalars['String']>>;
  members_not_contains?: InputMaybe<Array<Scalars['String']>>;
  members_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  nextEpochScoreTotal?: InputMaybe<Scalars['BigInt']>;
  nextEpochScoreTotal_gt?: InputMaybe<Scalars['BigInt']>;
  nextEpochScoreTotal_gte?: InputMaybe<Scalars['BigInt']>;
  nextEpochScoreTotal_in?: InputMaybe<Array<Scalars['BigInt']>>;
  nextEpochScoreTotal_lt?: InputMaybe<Scalars['BigInt']>;
  nextEpochScoreTotal_lte?: InputMaybe<Scalars['BigInt']>;
  nextEpochScoreTotal_not?: InputMaybe<Scalars['BigInt']>;
  nextEpochScoreTotal_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<MembershipRoster_Filter>>>;
};

export type MembershipRoster_OrderBy =
  | 'eligibleScoreTotal'
  | 'id'
  | 'lastCheckpointedInEpoch'
  | 'members'
  | 'nextEpochScoreTotal';

export type Membership_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Membership_Filter>>>;
  eligibleScore?: InputMaybe<Scalars['BigInt']>;
  eligibleScore_gt?: InputMaybe<Scalars['BigInt']>;
  eligibleScore_gte?: InputMaybe<Scalars['BigInt']>;
  eligibleScore_in?: InputMaybe<Array<Scalars['BigInt']>>;
  eligibleScore_lt?: InputMaybe<Scalars['BigInt']>;
  eligibleScore_lte?: InputMaybe<Scalars['BigInt']>;
  eligibleScore_not?: InputMaybe<Scalars['BigInt']>;
  eligibleScore_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  nextEpochScore?: InputMaybe<Scalars['BigInt']>;
  nextEpochScore_gt?: InputMaybe<Scalars['BigInt']>;
  nextEpochScore_gte?: InputMaybe<Scalars['BigInt']>;
  nextEpochScore_in?: InputMaybe<Array<Scalars['BigInt']>>;
  nextEpochScore_lt?: InputMaybe<Scalars['BigInt']>;
  nextEpochScore_lte?: InputMaybe<Scalars['BigInt']>;
  nextEpochScore_not?: InputMaybe<Scalars['BigInt']>;
  nextEpochScore_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<Membership_Filter>>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type Membership_OrderBy =
  | 'eligibleScore'
  | 'id'
  | 'nextEpochScore'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

/** Defines the order direction, either ascending or descending */
export type OrderDirection =
  | 'asc'
  | 'desc';

export type PoolToken = {
  __typename?: 'PoolToken';
  /** Only applicable to Pool Tokens that belong to a Callable Loan. This will be always `null` for other loan types. */
  callDueAt?: Maybe<Scalars['Int']>;
  /** Only applicable to Pool Tokens that belong to a Callable Loan. This will be always `null` for other loan types. */
  calledAt?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  interestRedeemable: Scalars['BigInt'];
  interestRedeemed: Scalars['BigInt'];
  /** Only applicable to Pool Tokens that belong to a Callable Loan. This will be always `false` for other loan types. */
  isCapitalCalled: Scalars['Boolean'];
  loan: Loan;
  mintedAt: Scalars['BigInt'];
  principalAmount: Scalars['BigInt'];
  principalRedeemable: Scalars['BigInt'];
  principalRedeemed: Scalars['BigInt'];
  rewardsClaimable: Scalars['BigInt'];
  rewardsClaimed: Scalars['BigInt'];
  /** Refers to the rewards that are received from LP rewards matching */
  stakingRewardsClaimable: Scalars['BigInt'];
  /** Refers to the rewards that are received from LP rewards matching */
  stakingRewardsClaimed: Scalars['BigInt'];
  tranche: Scalars['BigInt'];
  user: User;
  vaultedAsset?: Maybe<VaultedPoolToken>;
};

export type PoolToken_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<PoolToken_Filter>>>;
  callDueAt?: InputMaybe<Scalars['Int']>;
  callDueAt_gt?: InputMaybe<Scalars['Int']>;
  callDueAt_gte?: InputMaybe<Scalars['Int']>;
  callDueAt_in?: InputMaybe<Array<Scalars['Int']>>;
  callDueAt_lt?: InputMaybe<Scalars['Int']>;
  callDueAt_lte?: InputMaybe<Scalars['Int']>;
  callDueAt_not?: InputMaybe<Scalars['Int']>;
  callDueAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  calledAt?: InputMaybe<Scalars['Int']>;
  calledAt_gt?: InputMaybe<Scalars['Int']>;
  calledAt_gte?: InputMaybe<Scalars['Int']>;
  calledAt_in?: InputMaybe<Array<Scalars['Int']>>;
  calledAt_lt?: InputMaybe<Scalars['Int']>;
  calledAt_lte?: InputMaybe<Scalars['Int']>;
  calledAt_not?: InputMaybe<Scalars['Int']>;
  calledAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  interestRedeemable?: InputMaybe<Scalars['BigInt']>;
  interestRedeemable_gt?: InputMaybe<Scalars['BigInt']>;
  interestRedeemable_gte?: InputMaybe<Scalars['BigInt']>;
  interestRedeemable_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRedeemable_lt?: InputMaybe<Scalars['BigInt']>;
  interestRedeemable_lte?: InputMaybe<Scalars['BigInt']>;
  interestRedeemable_not?: InputMaybe<Scalars['BigInt']>;
  interestRedeemable_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRedeemed?: InputMaybe<Scalars['BigInt']>;
  interestRedeemed_gt?: InputMaybe<Scalars['BigInt']>;
  interestRedeemed_gte?: InputMaybe<Scalars['BigInt']>;
  interestRedeemed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRedeemed_lt?: InputMaybe<Scalars['BigInt']>;
  interestRedeemed_lte?: InputMaybe<Scalars['BigInt']>;
  interestRedeemed_not?: InputMaybe<Scalars['BigInt']>;
  interestRedeemed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  isCapitalCalled?: InputMaybe<Scalars['Boolean']>;
  isCapitalCalled_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isCapitalCalled_not?: InputMaybe<Scalars['Boolean']>;
  isCapitalCalled_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  loan?: InputMaybe<Scalars['String']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_ends_with?: InputMaybe<Scalars['String']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_gt?: InputMaybe<Scalars['String']>;
  loan_gte?: InputMaybe<Scalars['String']>;
  loan_in?: InputMaybe<Array<Scalars['String']>>;
  loan_lt?: InputMaybe<Scalars['String']>;
  loan_lte?: InputMaybe<Scalars['String']>;
  loan_not?: InputMaybe<Scalars['String']>;
  loan_not_contains?: InputMaybe<Scalars['String']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  loan_starts_with?: InputMaybe<Scalars['String']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']>;
  mintedAt?: InputMaybe<Scalars['BigInt']>;
  mintedAt_gt?: InputMaybe<Scalars['BigInt']>;
  mintedAt_gte?: InputMaybe<Scalars['BigInt']>;
  mintedAt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  mintedAt_lt?: InputMaybe<Scalars['BigInt']>;
  mintedAt_lte?: InputMaybe<Scalars['BigInt']>;
  mintedAt_not?: InputMaybe<Scalars['BigInt']>;
  mintedAt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<PoolToken_Filter>>>;
  principalAmount?: InputMaybe<Scalars['BigInt']>;
  principalAmount_gt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_gte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmount_lt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_lte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalRedeemed?: InputMaybe<Scalars['BigInt']>;
  principalRedeemed_gt?: InputMaybe<Scalars['BigInt']>;
  principalRedeemed_gte?: InputMaybe<Scalars['BigInt']>;
  principalRedeemed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalRedeemed_lt?: InputMaybe<Scalars['BigInt']>;
  principalRedeemed_lte?: InputMaybe<Scalars['BigInt']>;
  principalRedeemed_not?: InputMaybe<Scalars['BigInt']>;
  principalRedeemed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rewardsClaimable?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimable_gt?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimable_gte?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimable_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rewardsClaimable_lt?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimable_lte?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimable_not?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimable_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rewardsClaimed?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimed_gt?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimed_gte?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rewardsClaimed_lt?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimed_lte?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimed_not?: InputMaybe<Scalars['BigInt']>;
  rewardsClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  stakingRewardsClaimable?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimable_gt?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimable_gte?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimable_in?: InputMaybe<Array<Scalars['BigInt']>>;
  stakingRewardsClaimable_lt?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimable_lte?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimable_not?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimable_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  stakingRewardsClaimed?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimed_gt?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimed_gte?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  stakingRewardsClaimed_lt?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimed_lte?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimed_not?: InputMaybe<Scalars['BigInt']>;
  stakingRewardsClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tranche?: InputMaybe<Scalars['BigInt']>;
  tranche_gt?: InputMaybe<Scalars['BigInt']>;
  tranche_gte?: InputMaybe<Scalars['BigInt']>;
  tranche_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tranche_lt?: InputMaybe<Scalars['BigInt']>;
  tranche_lte?: InputMaybe<Scalars['BigInt']>;
  tranche_not?: InputMaybe<Scalars['BigInt']>;
  tranche_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset?: InputMaybe<Scalars['String']>;
  vaultedAsset_?: InputMaybe<VaultedPoolToken_Filter>;
  vaultedAsset_contains?: InputMaybe<Scalars['String']>;
  vaultedAsset_contains_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_ends_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_ends_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_gt?: InputMaybe<Scalars['String']>;
  vaultedAsset_gte?: InputMaybe<Scalars['String']>;
  vaultedAsset_in?: InputMaybe<Array<Scalars['String']>>;
  vaultedAsset_lt?: InputMaybe<Scalars['String']>;
  vaultedAsset_lte?: InputMaybe<Scalars['String']>;
  vaultedAsset_not?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_contains?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_contains_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_ends_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_in?: InputMaybe<Array<Scalars['String']>>;
  vaultedAsset_not_starts_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_starts_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type PoolToken_OrderBy =
  | 'callDueAt'
  | 'calledAt'
  | 'id'
  | 'interestRedeemable'
  | 'interestRedeemed'
  | 'isCapitalCalled'
  | 'loan'
  | 'loan__address'
  | 'loan__balance'
  | 'loan__createdAt'
  | 'loan__creditLineAddress'
  | 'loan__drawdownsPaused'
  | 'loan__fundableAt'
  | 'loan__fundingLimit'
  | 'loan__id'
  | 'loan__initialInterestOwed'
  | 'loan__interestAmountRepaid'
  | 'loan__interestRate'
  | 'loan__interestRateBigInt'
  | 'loan__interestWrittenDown'
  | 'loan__isPaused'
  | 'loan__lateFeeRate'
  | 'loan__numBackers'
  | 'loan__numRepayments'
  | 'loan__principalAmount'
  | 'loan__principalAmountRepaid'
  | 'loan__principalWrittenDown'
  | 'loan__rawGfiApy'
  | 'loan__remainingCapacity'
  | 'loan__repaymentFrequency'
  | 'loan__termEndTime'
  | 'loan__termInSeconds'
  | 'loan__termStartTime'
  | 'loan__totalDeposited'
  | 'loan__usdcApy'
  | 'mintedAt'
  | 'principalAmount'
  | 'principalRedeemed'
  | 'rewardsClaimable'
  | 'rewardsClaimed'
  | 'stakingRewardsClaimable'
  | 'stakingRewardsClaimed'
  | 'tranche'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType'
  | 'vaultedAsset'
  | 'vaultedAsset__id'
  | 'vaultedAsset__usdcEquivalent'
  | 'vaultedAsset__vaultedAt';

/** Captures protocol-wide data */
export type Protocol = {
  __typename?: 'Protocol';
  defaultRate: Scalars['BigDecimal'];
  id: Scalars['ID'];
  loans: Array<Loan>;
  numLoans: Scalars['Int'];
  totalDrawdowns: Scalars['BigInt'];
  totalInterestCollected: Scalars['BigInt'];
  totalPrincipalCollected: Scalars['BigInt'];
  totalReserveCollected: Scalars['BigInt'];
  totalWritedowns: Scalars['BigInt'];
};


/** Captures protocol-wide data */
export type ProtocolLoansArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Loan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Loan_Filter>;
};

export type Protocol_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Protocol_Filter>>>;
  defaultRate?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  defaultRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_not?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  loans?: InputMaybe<Array<Scalars['String']>>;
  loans_?: InputMaybe<Loan_Filter>;
  loans_contains?: InputMaybe<Array<Scalars['String']>>;
  loans_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  loans_not?: InputMaybe<Array<Scalars['String']>>;
  loans_not_contains?: InputMaybe<Array<Scalars['String']>>;
  loans_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  numLoans?: InputMaybe<Scalars['Int']>;
  numLoans_gt?: InputMaybe<Scalars['Int']>;
  numLoans_gte?: InputMaybe<Scalars['Int']>;
  numLoans_in?: InputMaybe<Array<Scalars['Int']>>;
  numLoans_lt?: InputMaybe<Scalars['Int']>;
  numLoans_lte?: InputMaybe<Scalars['Int']>;
  numLoans_not?: InputMaybe<Scalars['Int']>;
  numLoans_not_in?: InputMaybe<Array<Scalars['Int']>>;
  or?: InputMaybe<Array<InputMaybe<Protocol_Filter>>>;
  totalDrawdowns?: InputMaybe<Scalars['BigInt']>;
  totalDrawdowns_gt?: InputMaybe<Scalars['BigInt']>;
  totalDrawdowns_gte?: InputMaybe<Scalars['BigInt']>;
  totalDrawdowns_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalDrawdowns_lt?: InputMaybe<Scalars['BigInt']>;
  totalDrawdowns_lte?: InputMaybe<Scalars['BigInt']>;
  totalDrawdowns_not?: InputMaybe<Scalars['BigInt']>;
  totalDrawdowns_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalInterestCollected?: InputMaybe<Scalars['BigInt']>;
  totalInterestCollected_gt?: InputMaybe<Scalars['BigInt']>;
  totalInterestCollected_gte?: InputMaybe<Scalars['BigInt']>;
  totalInterestCollected_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalInterestCollected_lt?: InputMaybe<Scalars['BigInt']>;
  totalInterestCollected_lte?: InputMaybe<Scalars['BigInt']>;
  totalInterestCollected_not?: InputMaybe<Scalars['BigInt']>;
  totalInterestCollected_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalPrincipalCollected?: InputMaybe<Scalars['BigInt']>;
  totalPrincipalCollected_gt?: InputMaybe<Scalars['BigInt']>;
  totalPrincipalCollected_gte?: InputMaybe<Scalars['BigInt']>;
  totalPrincipalCollected_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalPrincipalCollected_lt?: InputMaybe<Scalars['BigInt']>;
  totalPrincipalCollected_lte?: InputMaybe<Scalars['BigInt']>;
  totalPrincipalCollected_not?: InputMaybe<Scalars['BigInt']>;
  totalPrincipalCollected_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalReserveCollected?: InputMaybe<Scalars['BigInt']>;
  totalReserveCollected_gt?: InputMaybe<Scalars['BigInt']>;
  totalReserveCollected_gte?: InputMaybe<Scalars['BigInt']>;
  totalReserveCollected_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalReserveCollected_lt?: InputMaybe<Scalars['BigInt']>;
  totalReserveCollected_lte?: InputMaybe<Scalars['BigInt']>;
  totalReserveCollected_not?: InputMaybe<Scalars['BigInt']>;
  totalReserveCollected_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalWritedowns?: InputMaybe<Scalars['BigInt']>;
  totalWritedowns_gt?: InputMaybe<Scalars['BigInt']>;
  totalWritedowns_gte?: InputMaybe<Scalars['BigInt']>;
  totalWritedowns_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalWritedowns_lt?: InputMaybe<Scalars['BigInt']>;
  totalWritedowns_lte?: InputMaybe<Scalars['BigInt']>;
  totalWritedowns_not?: InputMaybe<Scalars['BigInt']>;
  totalWritedowns_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type Protocol_OrderBy =
  | 'defaultRate'
  | 'id'
  | 'loans'
  | 'numLoans'
  | 'totalDrawdowns'
  | 'totalInterestCollected'
  | 'totalPrincipalCollected'
  | 'totalReserveCollected'
  | 'totalWritedowns';

export type Query = {
  __typename?: 'Query';
  Borrower?: Maybe<Borrower>;
  Borrowers?: Maybe<Borrowers>;
  Deal?: Maybe<Deal>;
  Deals?: Maybe<Deals>;
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  backerRewardsData?: Maybe<BackerRewardsData>;
  backerRewardsDatas: Array<BackerRewardsData>;
  borrowerContract?: Maybe<BorrowerContract>;
  borrowerContracts: Array<BorrowerContract>;
  callableLoan?: Maybe<CallableLoan>;
  callableLoans: Array<CallableLoan>;
  communityRewardsToken?: Maybe<CommunityRewardsToken>;
  communityRewardsTokens: Array<CommunityRewardsToken>;
  creditLine?: Maybe<CreditLine>;
  creditLines: Array<CreditLine>;
  currentBlock: BlockInfo;
  curvePool: CurvePool;
  gfiPrice: GfiPrice;
  isVerificationModalOpen: Scalars['Boolean'];
  isWalletModalOpen: Scalars['Boolean'];
  juniorTrancheInfo?: Maybe<JuniorTrancheInfo>;
  juniorTrancheInfos: Array<JuniorTrancheInfo>;
  loan?: Maybe<Loan>;
  loans: Array<Loan>;
  membership?: Maybe<Membership>;
  membershipEpoch?: Maybe<MembershipEpoch>;
  membershipEpoches: Array<MembershipEpoch>;
  membershipRewardDisbursement?: Maybe<MembershipRewardDisbursement>;
  membershipRewardDisbursements: Array<MembershipRewardDisbursement>;
  membershipRoster?: Maybe<MembershipRoster>;
  membershipRosters: Array<MembershipRoster>;
  memberships: Array<Membership>;
  poolToken?: Maybe<PoolToken>;
  poolTokens: Array<PoolToken>;
  protocol?: Maybe<Protocol>;
  protocols: Array<Protocol>;
  scheduledRepayment?: Maybe<ScheduledRepayment>;
  scheduledRepayments: Array<ScheduledRepayment>;
  seniorPool?: Maybe<SeniorPool>;
  seniorPoolStakedPosition?: Maybe<SeniorPoolStakedPosition>;
  seniorPoolStakedPositions: Array<SeniorPoolStakedPosition>;
  seniorPoolWithdrawalDisbursement?: Maybe<SeniorPoolWithdrawalDisbursement>;
  seniorPoolWithdrawalDisbursementPostponement?: Maybe<SeniorPoolWithdrawalDisbursementPostponement>;
  seniorPoolWithdrawalDisbursementPostponements: Array<SeniorPoolWithdrawalDisbursementPostponement>;
  seniorPoolWithdrawalDisbursements: Array<SeniorPoolWithdrawalDisbursement>;
  seniorPoolWithdrawalEpoch?: Maybe<SeniorPoolWithdrawalEpoch>;
  seniorPoolWithdrawalEpoches: Array<SeniorPoolWithdrawalEpoch>;
  seniorPoolWithdrawalRequest?: Maybe<SeniorPoolWithdrawalRequest>;
  seniorPoolWithdrawalRequestRoster?: Maybe<SeniorPoolWithdrawalRequestRoster>;
  seniorPoolWithdrawalRequestRosters: Array<SeniorPoolWithdrawalRequestRoster>;
  seniorPoolWithdrawalRequests: Array<SeniorPoolWithdrawalRequest>;
  seniorPools: Array<SeniorPool>;
  seniorTrancheInfo?: Maybe<SeniorTrancheInfo>;
  seniorTrancheInfos: Array<SeniorTrancheInfo>;
  stakingRewardsData?: Maybe<StakingRewardsData>;
  stakingRewardsDatas: Array<StakingRewardsData>;
  trancheInfo?: Maybe<TrancheInfo>;
  trancheInfos: Array<TrancheInfo>;
  tranchedPool?: Maybe<TranchedPool>;
  tranchedPools: Array<TranchedPool>;
  transaction?: Maybe<Transaction>;
  transactions: Array<Transaction>;
  user?: Maybe<User>;
  users: Array<User>;
  vaultedGfi?: Maybe<VaultedGfi>;
  vaultedGfis: Array<VaultedGfi>;
  vaultedPoolToken?: Maybe<VaultedPoolToken>;
  vaultedPoolTokens: Array<VaultedPoolToken>;
  vaultedStakedPosition?: Maybe<VaultedStakedPosition>;
  vaultedStakedPositions: Array<VaultedStakedPosition>;
  viewer: Viewer;
  zap?: Maybe<Zap>;
  zaps: Array<Zap>;
};


export type QueryBorrowerArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryBorrowersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Borrower_Where>;
};


export type QueryDealArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryDealsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Deal_Where>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryBackerRewardsDataArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBackerRewardsDatasArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BackerRewardsData_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<BackerRewardsData_Filter>;
};


export type QueryBorrowerContractArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryBorrowerContractsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BorrowerContract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<BorrowerContract_Filter>;
};


export type QueryCallableLoanArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCallableLoansArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CallableLoan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CallableLoan_Filter>;
};


export type QueryCommunityRewardsTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCommunityRewardsTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CommunityRewardsToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CommunityRewardsToken_Filter>;
};


export type QueryCreditLineArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryCreditLinesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CreditLine_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<CreditLine_Filter>;
};


export type QueryGfiPriceArgs = {
  fiat: SupportedFiat;
};


export type QueryJuniorTrancheInfoArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryJuniorTrancheInfosArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<JuniorTrancheInfo_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<JuniorTrancheInfo_Filter>;
};


export type QueryLoanArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLoansArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Loan_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Loan_Filter>;
};


export type QueryMembershipArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMembershipEpochArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMembershipEpochesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MembershipEpoch_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MembershipEpoch_Filter>;
};


export type QueryMembershipRewardDisbursementArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMembershipRewardDisbursementsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MembershipRewardDisbursement_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MembershipRewardDisbursement_Filter>;
};


export type QueryMembershipRosterArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryMembershipRostersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MembershipRoster_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<MembershipRoster_Filter>;
};


export type QueryMembershipsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Membership_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Membership_Filter>;
};


export type QueryPoolTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryPoolTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PoolToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<PoolToken_Filter>;
};


export type QueryProtocolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryProtocolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Protocol_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Protocol_Filter>;
};


export type QueryScheduledRepaymentArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryScheduledRepaymentsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ScheduledRepayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ScheduledRepayment_Filter>;
};


export type QuerySeniorPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorPoolStakedPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorPoolStakedPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolStakedPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorPoolStakedPosition_Filter>;
};


export type QuerySeniorPoolWithdrawalDisbursementArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorPoolWithdrawalDisbursementPostponementArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorPoolWithdrawalDisbursementPostponementsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolWithdrawalDisbursementPostponement_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorPoolWithdrawalDisbursementPostponement_Filter>;
};


export type QuerySeniorPoolWithdrawalDisbursementsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolWithdrawalDisbursement_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorPoolWithdrawalDisbursement_Filter>;
};


export type QuerySeniorPoolWithdrawalEpochArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorPoolWithdrawalEpochesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolWithdrawalEpoch_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorPoolWithdrawalEpoch_Filter>;
};


export type QuerySeniorPoolWithdrawalRequestArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorPoolWithdrawalRequestRosterArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorPoolWithdrawalRequestRostersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolWithdrawalRequestRoster_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorPoolWithdrawalRequestRoster_Filter>;
};


export type QuerySeniorPoolWithdrawalRequestsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolWithdrawalRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorPoolWithdrawalRequest_Filter>;
};


export type QuerySeniorPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorPool_Filter>;
};


export type QuerySeniorTrancheInfoArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerySeniorTrancheInfosArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorTrancheInfo_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<SeniorTrancheInfo_Filter>;
};


export type QueryStakingRewardsDataArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryStakingRewardsDatasArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<StakingRewardsData_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<StakingRewardsData_Filter>;
};


export type QueryTrancheInfoArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTrancheInfosArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TrancheInfo_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TrancheInfo_Filter>;
};


export type QueryTranchedPoolArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTranchedPoolsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TranchedPool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<TranchedPool_Filter>;
};


export type QueryTransactionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryTransactionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Transaction_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Transaction_Filter>;
};


export type QueryUserArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryUsersArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<User_Filter>;
};


export type QueryVaultedGfiArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryVaultedGfisArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VaultedGfi_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<VaultedGfi_Filter>;
};


export type QueryVaultedPoolTokenArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryVaultedPoolTokensArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VaultedPoolToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<VaultedPoolToken_Filter>;
};


export type QueryVaultedStakedPositionArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryVaultedStakedPositionsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VaultedStakedPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<VaultedStakedPosition_Filter>;
};


export type QueryZapArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryZapsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Zap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Zap_Filter>;
};

export type RepaymentFrequency =
  | 'ANNUALLY'
  | 'BIWEEKLY'
  | 'DAILY'
  | 'HALFLY'
  | 'MONTHLY'
  | 'QUARTERLY'
  | 'WEEKLY';

export type ScheduledRepayment = {
  __typename?: 'ScheduledRepayment';
  estimatedPaymentDate: Scalars['Int'];
  id: Scalars['ID'];
  interest: Scalars['BigInt'];
  loan: Loan;
  paymentPeriod: Scalars['Int'];
  principal: Scalars['BigInt'];
};

export type ScheduledRepayment_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ScheduledRepayment_Filter>>>;
  estimatedPaymentDate?: InputMaybe<Scalars['Int']>;
  estimatedPaymentDate_gt?: InputMaybe<Scalars['Int']>;
  estimatedPaymentDate_gte?: InputMaybe<Scalars['Int']>;
  estimatedPaymentDate_in?: InputMaybe<Array<Scalars['Int']>>;
  estimatedPaymentDate_lt?: InputMaybe<Scalars['Int']>;
  estimatedPaymentDate_lte?: InputMaybe<Scalars['Int']>;
  estimatedPaymentDate_not?: InputMaybe<Scalars['Int']>;
  estimatedPaymentDate_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  interest?: InputMaybe<Scalars['BigInt']>;
  interest_gt?: InputMaybe<Scalars['BigInt']>;
  interest_gte?: InputMaybe<Scalars['BigInt']>;
  interest_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interest_lt?: InputMaybe<Scalars['BigInt']>;
  interest_lte?: InputMaybe<Scalars['BigInt']>;
  interest_not?: InputMaybe<Scalars['BigInt']>;
  interest_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  loan?: InputMaybe<Scalars['String']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_ends_with?: InputMaybe<Scalars['String']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_gt?: InputMaybe<Scalars['String']>;
  loan_gte?: InputMaybe<Scalars['String']>;
  loan_in?: InputMaybe<Array<Scalars['String']>>;
  loan_lt?: InputMaybe<Scalars['String']>;
  loan_lte?: InputMaybe<Scalars['String']>;
  loan_not?: InputMaybe<Scalars['String']>;
  loan_not_contains?: InputMaybe<Scalars['String']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  loan_starts_with?: InputMaybe<Scalars['String']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<InputMaybe<ScheduledRepayment_Filter>>>;
  paymentPeriod?: InputMaybe<Scalars['Int']>;
  paymentPeriod_gt?: InputMaybe<Scalars['Int']>;
  paymentPeriod_gte?: InputMaybe<Scalars['Int']>;
  paymentPeriod_in?: InputMaybe<Array<Scalars['Int']>>;
  paymentPeriod_lt?: InputMaybe<Scalars['Int']>;
  paymentPeriod_lte?: InputMaybe<Scalars['Int']>;
  paymentPeriod_not?: InputMaybe<Scalars['Int']>;
  paymentPeriod_not_in?: InputMaybe<Array<Scalars['Int']>>;
  principal?: InputMaybe<Scalars['BigInt']>;
  principal_gt?: InputMaybe<Scalars['BigInt']>;
  principal_gte?: InputMaybe<Scalars['BigInt']>;
  principal_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principal_lt?: InputMaybe<Scalars['BigInt']>;
  principal_lte?: InputMaybe<Scalars['BigInt']>;
  principal_not?: InputMaybe<Scalars['BigInt']>;
  principal_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type ScheduledRepayment_OrderBy =
  | 'estimatedPaymentDate'
  | 'id'
  | 'interest'
  | 'loan'
  | 'loan__address'
  | 'loan__balance'
  | 'loan__createdAt'
  | 'loan__creditLineAddress'
  | 'loan__drawdownsPaused'
  | 'loan__fundableAt'
  | 'loan__fundingLimit'
  | 'loan__id'
  | 'loan__initialInterestOwed'
  | 'loan__interestAmountRepaid'
  | 'loan__interestRate'
  | 'loan__interestRateBigInt'
  | 'loan__interestWrittenDown'
  | 'loan__isPaused'
  | 'loan__lateFeeRate'
  | 'loan__numBackers'
  | 'loan__numRepayments'
  | 'loan__principalAmount'
  | 'loan__principalAmountRepaid'
  | 'loan__principalWrittenDown'
  | 'loan__rawGfiApy'
  | 'loan__remainingCapacity'
  | 'loan__repaymentFrequency'
  | 'loan__termEndTime'
  | 'loan__termInSeconds'
  | 'loan__termStartTime'
  | 'loan__totalDeposited'
  | 'loan__usdcApy'
  | 'paymentPeriod'
  | 'principal';

export type SeniorPool = {
  __typename?: 'SeniorPool';
  address: Scalars['Bytes'];
  assets: Scalars['BigInt'];
  category: Scalars['String'];
  defaultRate: Scalars['BigDecimal'];
  epochEndsAt: Scalars['Int'];
  estimatedApy: Scalars['BigDecimal'];
  estimatedApyFromGfiRaw: Scalars['BigDecimal'];
  estimatedTotalInterest: Scalars['BigDecimal'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sharePrice: Scalars['BigInt'];
  totalInvested: Scalars['BigInt'];
  totalLoansOutstanding: Scalars['BigInt'];
  totalShares: Scalars['BigInt'];
  totalWrittenDown: Scalars['BigInt'];
  tranchedPools: Array<TranchedPool>;
  withdrawalCancellationFee: Scalars['BigDecimal'];
};


export type SeniorPoolTranchedPoolsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TranchedPool_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TranchedPool_Filter>;
};

export type SeniorPoolStakedPosition = {
  __typename?: 'SeniorPoolStakedPosition';
  amount: Scalars['BigInt'];
  claimable: Scalars['BigInt'];
  endTime: Scalars['BigInt'];
  granted: Scalars['BigInt'];
  id: Scalars['ID'];
  initialAmount: Scalars['BigInt'];
  positionType: StakedPositionType;
  rewardEarnRate: Scalars['BigInt'];
  /** endTime has to be queried via RPC on client due to a complication: calling positions() on the StakingRewards contract is difficult due to its signature changing over time. */
  startTime: Scalars['BigInt'];
  totalRewardsClaimed: Scalars['BigInt'];
  user: User;
  vaultedAsset?: Maybe<VaultedStakedPosition>;
};

export type SeniorPoolStakedPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<SeniorPoolStakedPosition_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  initialAmount?: InputMaybe<Scalars['BigInt']>;
  initialAmount_gt?: InputMaybe<Scalars['BigInt']>;
  initialAmount_gte?: InputMaybe<Scalars['BigInt']>;
  initialAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  initialAmount_lt?: InputMaybe<Scalars['BigInt']>;
  initialAmount_lte?: InputMaybe<Scalars['BigInt']>;
  initialAmount_not?: InputMaybe<Scalars['BigInt']>;
  initialAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorPoolStakedPosition_Filter>>>;
  positionType?: InputMaybe<StakedPositionType>;
  positionType_in?: InputMaybe<Array<StakedPositionType>>;
  positionType_not?: InputMaybe<StakedPositionType>;
  positionType_not_in?: InputMaybe<Array<StakedPositionType>>;
  startTime?: InputMaybe<Scalars['BigInt']>;
  startTime_gt?: InputMaybe<Scalars['BigInt']>;
  startTime_gte?: InputMaybe<Scalars['BigInt']>;
  startTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  startTime_lt?: InputMaybe<Scalars['BigInt']>;
  startTime_lte?: InputMaybe<Scalars['BigInt']>;
  startTime_not?: InputMaybe<Scalars['BigInt']>;
  startTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalRewardsClaimed?: InputMaybe<Scalars['BigInt']>;
  totalRewardsClaimed_gt?: InputMaybe<Scalars['BigInt']>;
  totalRewardsClaimed_gte?: InputMaybe<Scalars['BigInt']>;
  totalRewardsClaimed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalRewardsClaimed_lt?: InputMaybe<Scalars['BigInt']>;
  totalRewardsClaimed_lte?: InputMaybe<Scalars['BigInt']>;
  totalRewardsClaimed_not?: InputMaybe<Scalars['BigInt']>;
  totalRewardsClaimed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset?: InputMaybe<Scalars['String']>;
  vaultedAsset_?: InputMaybe<VaultedStakedPosition_Filter>;
  vaultedAsset_contains?: InputMaybe<Scalars['String']>;
  vaultedAsset_contains_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_ends_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_ends_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_gt?: InputMaybe<Scalars['String']>;
  vaultedAsset_gte?: InputMaybe<Scalars['String']>;
  vaultedAsset_in?: InputMaybe<Array<Scalars['String']>>;
  vaultedAsset_lt?: InputMaybe<Scalars['String']>;
  vaultedAsset_lte?: InputMaybe<Scalars['String']>;
  vaultedAsset_not?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_contains?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_contains_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_ends_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_in?: InputMaybe<Array<Scalars['String']>>;
  vaultedAsset_not_starts_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAsset_starts_with?: InputMaybe<Scalars['String']>;
  vaultedAsset_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type SeniorPoolStakedPosition_OrderBy =
  | 'amount'
  | 'id'
  | 'initialAmount'
  | 'positionType'
  | 'startTime'
  | 'totalRewardsClaimed'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType'
  | 'vaultedAsset'
  | 'vaultedAsset__id'
  | 'vaultedAsset__usdcEquivalent'
  | 'vaultedAsset__vaultedAt';

export type SeniorPoolWithdrawalDisbursement = {
  __typename?: 'SeniorPoolWithdrawalDisbursement';
  allocatedAt: Scalars['Int'];
  epoch: Scalars['BigInt'];
  fiduLiquidated: Scalars['BigInt'];
  id: Scalars['ID'];
  /** If the user has had multiple withdrawal requests submitted and fulfilled over time, it might be useful to know what tokenId this distribution was associated with. */
  tokenId: Scalars['BigInt'];
  usdcAllocated: Scalars['BigInt'];
  user: User;
};

/** This entity is created when there is no money to allocate at the end of a withdrawal epoch */
export type SeniorPoolWithdrawalDisbursementPostponement = {
  __typename?: 'SeniorPoolWithdrawalDisbursementPostponement';
  extendedEpoch: Scalars['BigInt'];
  id: Scalars['ID'];
  newEndsAt: Scalars['Int'];
  oldEndsAt: Scalars['Int'];
  tokenId: Scalars['BigInt'];
  user: User;
};

export type SeniorPoolWithdrawalDisbursementPostponement_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalDisbursementPostponement_Filter>>>;
  extendedEpoch?: InputMaybe<Scalars['BigInt']>;
  extendedEpoch_gt?: InputMaybe<Scalars['BigInt']>;
  extendedEpoch_gte?: InputMaybe<Scalars['BigInt']>;
  extendedEpoch_in?: InputMaybe<Array<Scalars['BigInt']>>;
  extendedEpoch_lt?: InputMaybe<Scalars['BigInt']>;
  extendedEpoch_lte?: InputMaybe<Scalars['BigInt']>;
  extendedEpoch_not?: InputMaybe<Scalars['BigInt']>;
  extendedEpoch_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  newEndsAt?: InputMaybe<Scalars['Int']>;
  newEndsAt_gt?: InputMaybe<Scalars['Int']>;
  newEndsAt_gte?: InputMaybe<Scalars['Int']>;
  newEndsAt_in?: InputMaybe<Array<Scalars['Int']>>;
  newEndsAt_lt?: InputMaybe<Scalars['Int']>;
  newEndsAt_lte?: InputMaybe<Scalars['Int']>;
  newEndsAt_not?: InputMaybe<Scalars['Int']>;
  newEndsAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  oldEndsAt?: InputMaybe<Scalars['Int']>;
  oldEndsAt_gt?: InputMaybe<Scalars['Int']>;
  oldEndsAt_gte?: InputMaybe<Scalars['Int']>;
  oldEndsAt_in?: InputMaybe<Array<Scalars['Int']>>;
  oldEndsAt_lt?: InputMaybe<Scalars['Int']>;
  oldEndsAt_lte?: InputMaybe<Scalars['Int']>;
  oldEndsAt_not?: InputMaybe<Scalars['Int']>;
  oldEndsAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalDisbursementPostponement_Filter>>>;
  tokenId?: InputMaybe<Scalars['BigInt']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type SeniorPoolWithdrawalDisbursementPostponement_OrderBy =
  | 'extendedEpoch'
  | 'id'
  | 'newEndsAt'
  | 'oldEndsAt'
  | 'tokenId'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

export type SeniorPoolWithdrawalDisbursement_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  allocatedAt?: InputMaybe<Scalars['Int']>;
  allocatedAt_gt?: InputMaybe<Scalars['Int']>;
  allocatedAt_gte?: InputMaybe<Scalars['Int']>;
  allocatedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  allocatedAt_lt?: InputMaybe<Scalars['Int']>;
  allocatedAt_lte?: InputMaybe<Scalars['Int']>;
  allocatedAt_not?: InputMaybe<Scalars['Int']>;
  allocatedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  and?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalDisbursement_Filter>>>;
  epoch?: InputMaybe<Scalars['BigInt']>;
  epoch_gt?: InputMaybe<Scalars['BigInt']>;
  epoch_gte?: InputMaybe<Scalars['BigInt']>;
  epoch_in?: InputMaybe<Array<Scalars['BigInt']>>;
  epoch_lt?: InputMaybe<Scalars['BigInt']>;
  epoch_lte?: InputMaybe<Scalars['BigInt']>;
  epoch_not?: InputMaybe<Scalars['BigInt']>;
  epoch_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduLiquidated?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_gt?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_gte?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduLiquidated_lt?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_lte?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_not?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalDisbursement_Filter>>>;
  tokenId?: InputMaybe<Scalars['BigInt']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcAllocated?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_gt?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_gte?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcAllocated_lt?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_lte?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_not?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type SeniorPoolWithdrawalDisbursement_OrderBy =
  | 'allocatedAt'
  | 'epoch'
  | 'fiduLiquidated'
  | 'id'
  | 'tokenId'
  | 'usdcAllocated'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

export type SeniorPoolWithdrawalEpoch = {
  __typename?: 'SeniorPoolWithdrawalEpoch';
  endsAt: Scalars['Int'];
  epoch: Scalars['BigInt'];
  fiduLiquidated: Scalars['BigInt'];
  fiduRequested: Scalars['BigInt'];
  id: Scalars['ID'];
  usdcAllocated: Scalars['BigInt'];
};

export type SeniorPoolWithdrawalEpoch_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalEpoch_Filter>>>;
  endsAt?: InputMaybe<Scalars['Int']>;
  endsAt_gt?: InputMaybe<Scalars['Int']>;
  endsAt_gte?: InputMaybe<Scalars['Int']>;
  endsAt_in?: InputMaybe<Array<Scalars['Int']>>;
  endsAt_lt?: InputMaybe<Scalars['Int']>;
  endsAt_lte?: InputMaybe<Scalars['Int']>;
  endsAt_not?: InputMaybe<Scalars['Int']>;
  endsAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  epoch?: InputMaybe<Scalars['BigInt']>;
  epoch_gt?: InputMaybe<Scalars['BigInt']>;
  epoch_gte?: InputMaybe<Scalars['BigInt']>;
  epoch_in?: InputMaybe<Array<Scalars['BigInt']>>;
  epoch_lt?: InputMaybe<Scalars['BigInt']>;
  epoch_lte?: InputMaybe<Scalars['BigInt']>;
  epoch_not?: InputMaybe<Scalars['BigInt']>;
  epoch_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduLiquidated?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_gt?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_gte?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduLiquidated_lt?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_lte?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_not?: InputMaybe<Scalars['BigInt']>;
  fiduLiquidated_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduRequested?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_gt?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_gte?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduRequested_lt?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_lte?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_not?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalEpoch_Filter>>>;
  usdcAllocated?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_gt?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_gte?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcAllocated_lt?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_lte?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_not?: InputMaybe<Scalars['BigInt']>;
  usdcAllocated_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type SeniorPoolWithdrawalEpoch_OrderBy =
  | 'endsAt'
  | 'epoch'
  | 'fiduLiquidated'
  | 'fiduRequested'
  | 'id'
  | 'usdcAllocated';

export type SeniorPoolWithdrawalRequest = {
  __typename?: 'SeniorPoolWithdrawalRequest';
  canceledAt?: Maybe<Scalars['Int']>;
  fiduRequested: Scalars['BigInt'];
  id: Scalars['ID'];
  increasedAt?: Maybe<Scalars['Int']>;
  /** Comes from SeniorPool.withdrawalRequest() view function, which may simulate an epoch ending if appropriate */
  previewFiduRequested: Scalars['BigInt'];
  /** Comes from SeniorPool.withdrawalRequest() view function, which may simulate an epoch ending if appropriate */
  previewUsdcWithdrawable: Scalars['BigInt'];
  requestedAt: Scalars['Int'];
  tokenId: Scalars['BigInt'];
  usdcWithdrawable: Scalars['BigInt'];
  user: User;
};

export type SeniorPoolWithdrawalRequestRoster = {
  __typename?: 'SeniorPoolWithdrawalRequestRoster';
  id: Scalars['ID'];
  requests: Array<SeniorPoolWithdrawalRequest>;
};


export type SeniorPoolWithdrawalRequestRosterRequestsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolWithdrawalRequest_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeniorPoolWithdrawalRequest_Filter>;
};

export type SeniorPoolWithdrawalRequestRoster_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalRequestRoster_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalRequestRoster_Filter>>>;
  requests?: InputMaybe<Array<Scalars['String']>>;
  requests_?: InputMaybe<SeniorPoolWithdrawalRequest_Filter>;
  requests_contains?: InputMaybe<Array<Scalars['String']>>;
  requests_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  requests_not?: InputMaybe<Array<Scalars['String']>>;
  requests_not_contains?: InputMaybe<Array<Scalars['String']>>;
  requests_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
};

export type SeniorPoolWithdrawalRequestRoster_OrderBy =
  | 'id'
  | 'requests';

export type SeniorPoolWithdrawalRequest_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalRequest_Filter>>>;
  canceledAt?: InputMaybe<Scalars['Int']>;
  canceledAt_gt?: InputMaybe<Scalars['Int']>;
  canceledAt_gte?: InputMaybe<Scalars['Int']>;
  canceledAt_in?: InputMaybe<Array<Scalars['Int']>>;
  canceledAt_lt?: InputMaybe<Scalars['Int']>;
  canceledAt_lte?: InputMaybe<Scalars['Int']>;
  canceledAt_not?: InputMaybe<Scalars['Int']>;
  canceledAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  fiduRequested?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_gt?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_gte?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduRequested_lt?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_lte?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_not?: InputMaybe<Scalars['BigInt']>;
  fiduRequested_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  increasedAt?: InputMaybe<Scalars['Int']>;
  increasedAt_gt?: InputMaybe<Scalars['Int']>;
  increasedAt_gte?: InputMaybe<Scalars['Int']>;
  increasedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  increasedAt_lt?: InputMaybe<Scalars['Int']>;
  increasedAt_lte?: InputMaybe<Scalars['Int']>;
  increasedAt_not?: InputMaybe<Scalars['Int']>;
  increasedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorPoolWithdrawalRequest_Filter>>>;
  requestedAt?: InputMaybe<Scalars['Int']>;
  requestedAt_gt?: InputMaybe<Scalars['Int']>;
  requestedAt_gte?: InputMaybe<Scalars['Int']>;
  requestedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  requestedAt_lt?: InputMaybe<Scalars['Int']>;
  requestedAt_lte?: InputMaybe<Scalars['Int']>;
  requestedAt_not?: InputMaybe<Scalars['Int']>;
  requestedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  tokenId?: InputMaybe<Scalars['BigInt']>;
  tokenId_gt?: InputMaybe<Scalars['BigInt']>;
  tokenId_gte?: InputMaybe<Scalars['BigInt']>;
  tokenId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tokenId_lt?: InputMaybe<Scalars['BigInt']>;
  tokenId_lte?: InputMaybe<Scalars['BigInt']>;
  tokenId_not?: InputMaybe<Scalars['BigInt']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcWithdrawable?: InputMaybe<Scalars['BigInt']>;
  usdcWithdrawable_gt?: InputMaybe<Scalars['BigInt']>;
  usdcWithdrawable_gte?: InputMaybe<Scalars['BigInt']>;
  usdcWithdrawable_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcWithdrawable_lt?: InputMaybe<Scalars['BigInt']>;
  usdcWithdrawable_lte?: InputMaybe<Scalars['BigInt']>;
  usdcWithdrawable_not?: InputMaybe<Scalars['BigInt']>;
  usdcWithdrawable_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type SeniorPoolWithdrawalRequest_OrderBy =
  | 'canceledAt'
  | 'fiduRequested'
  | 'id'
  | 'increasedAt'
  | 'requestedAt'
  | 'tokenId'
  | 'usdcWithdrawable'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

export type SeniorPool_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  address?: InputMaybe<Scalars['Bytes']>;
  address_contains?: InputMaybe<Scalars['Bytes']>;
  address_gt?: InputMaybe<Scalars['Bytes']>;
  address_gte?: InputMaybe<Scalars['Bytes']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_lt?: InputMaybe<Scalars['Bytes']>;
  address_lte?: InputMaybe<Scalars['Bytes']>;
  address_not?: InputMaybe<Scalars['Bytes']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  and?: InputMaybe<Array<InputMaybe<SeniorPool_Filter>>>;
  assets?: InputMaybe<Scalars['BigInt']>;
  assets_gt?: InputMaybe<Scalars['BigInt']>;
  assets_gte?: InputMaybe<Scalars['BigInt']>;
  assets_in?: InputMaybe<Array<Scalars['BigInt']>>;
  assets_lt?: InputMaybe<Scalars['BigInt']>;
  assets_lte?: InputMaybe<Scalars['BigInt']>;
  assets_not?: InputMaybe<Scalars['BigInt']>;
  assets_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  defaultRate?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  defaultRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_not?: InputMaybe<Scalars['BigDecimal']>;
  defaultRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedApy?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApyFromGfiRaw?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApyFromGfiRaw_gt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApyFromGfiRaw_gte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApyFromGfiRaw_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedApyFromGfiRaw_lt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApyFromGfiRaw_lte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApyFromGfiRaw_not?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApyFromGfiRaw_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedApy_gt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApy_gte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApy_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedApy_lt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApy_lte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApy_not?: InputMaybe<Scalars['BigDecimal']>;
  estimatedApy_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedTotalInterest?: InputMaybe<Scalars['BigDecimal']>;
  estimatedTotalInterest_gt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedTotalInterest_gte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedTotalInterest_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedTotalInterest_lt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedTotalInterest_lte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedTotalInterest_not?: InputMaybe<Scalars['BigDecimal']>;
  estimatedTotalInterest_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorPool_Filter>>>;
  sharePrice?: InputMaybe<Scalars['BigInt']>;
  sharePrice_gt?: InputMaybe<Scalars['BigInt']>;
  sharePrice_gte?: InputMaybe<Scalars['BigInt']>;
  sharePrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  sharePrice_lt?: InputMaybe<Scalars['BigInt']>;
  sharePrice_lte?: InputMaybe<Scalars['BigInt']>;
  sharePrice_not?: InputMaybe<Scalars['BigInt']>;
  sharePrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalInvested?: InputMaybe<Scalars['BigInt']>;
  totalInvested_gt?: InputMaybe<Scalars['BigInt']>;
  totalInvested_gte?: InputMaybe<Scalars['BigInt']>;
  totalInvested_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalInvested_lt?: InputMaybe<Scalars['BigInt']>;
  totalInvested_lte?: InputMaybe<Scalars['BigInt']>;
  totalInvested_not?: InputMaybe<Scalars['BigInt']>;
  totalInvested_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalLoansOutstanding?: InputMaybe<Scalars['BigInt']>;
  totalLoansOutstanding_gt?: InputMaybe<Scalars['BigInt']>;
  totalLoansOutstanding_gte?: InputMaybe<Scalars['BigInt']>;
  totalLoansOutstanding_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalLoansOutstanding_lt?: InputMaybe<Scalars['BigInt']>;
  totalLoansOutstanding_lte?: InputMaybe<Scalars['BigInt']>;
  totalLoansOutstanding_not?: InputMaybe<Scalars['BigInt']>;
  totalLoansOutstanding_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalShares?: InputMaybe<Scalars['BigInt']>;
  totalShares_gt?: InputMaybe<Scalars['BigInt']>;
  totalShares_gte?: InputMaybe<Scalars['BigInt']>;
  totalShares_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalShares_lt?: InputMaybe<Scalars['BigInt']>;
  totalShares_lte?: InputMaybe<Scalars['BigInt']>;
  totalShares_not?: InputMaybe<Scalars['BigInt']>;
  totalShares_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalWrittenDown?: InputMaybe<Scalars['BigInt']>;
  totalWrittenDown_gt?: InputMaybe<Scalars['BigInt']>;
  totalWrittenDown_gte?: InputMaybe<Scalars['BigInt']>;
  totalWrittenDown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalWrittenDown_lt?: InputMaybe<Scalars['BigInt']>;
  totalWrittenDown_lte?: InputMaybe<Scalars['BigInt']>;
  totalWrittenDown_not?: InputMaybe<Scalars['BigInt']>;
  totalWrittenDown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tranchedPools?: InputMaybe<Array<Scalars['String']>>;
  tranchedPools_?: InputMaybe<TranchedPool_Filter>;
  tranchedPools_contains?: InputMaybe<Array<Scalars['String']>>;
  tranchedPools_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  tranchedPools_not?: InputMaybe<Array<Scalars['String']>>;
  tranchedPools_not_contains?: InputMaybe<Array<Scalars['String']>>;
  tranchedPools_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  withdrawalCancellationFee?: InputMaybe<Scalars['BigDecimal']>;
  withdrawalCancellationFee_gt?: InputMaybe<Scalars['BigDecimal']>;
  withdrawalCancellationFee_gte?: InputMaybe<Scalars['BigDecimal']>;
  withdrawalCancellationFee_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  withdrawalCancellationFee_lt?: InputMaybe<Scalars['BigDecimal']>;
  withdrawalCancellationFee_lte?: InputMaybe<Scalars['BigDecimal']>;
  withdrawalCancellationFee_not?: InputMaybe<Scalars['BigDecimal']>;
  withdrawalCancellationFee_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
};

export type SeniorPool_OrderBy =
  | 'address'
  | 'assets'
  | 'defaultRate'
  | 'estimatedApy'
  | 'estimatedApyFromGfiRaw'
  | 'estimatedTotalInterest'
  | 'id'
  | 'sharePrice'
  | 'totalInvested'
  | 'totalLoansOutstanding'
  | 'totalShares'
  | 'totalWrittenDown'
  | 'tranchedPools'
  | 'withdrawalCancellationFee';

export type SeniorTrancheInfo = TrancheInfo & {
  __typename?: 'SeniorTrancheInfo';
  id: Scalars['ID'];
  interestSharePrice: Scalars['BigInt'];
  loan: Loan;
  lockedUntil: Scalars['BigInt'];
  principalDeposited: Scalars['BigInt'];
  principalSharePrice: Scalars['BigInt'];
  trancheId: Scalars['BigInt'];
  tranchedPool: TranchedPool;
};

export type SeniorTrancheInfo_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SeniorTrancheInfo_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  interestSharePrice?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_gt?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_gte?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestSharePrice_lt?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_lte?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_not?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  loan?: InputMaybe<Scalars['String']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_ends_with?: InputMaybe<Scalars['String']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_gt?: InputMaybe<Scalars['String']>;
  loan_gte?: InputMaybe<Scalars['String']>;
  loan_in?: InputMaybe<Array<Scalars['String']>>;
  loan_lt?: InputMaybe<Scalars['String']>;
  loan_lte?: InputMaybe<Scalars['String']>;
  loan_not?: InputMaybe<Scalars['String']>;
  loan_not_contains?: InputMaybe<Scalars['String']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  loan_starts_with?: InputMaybe<Scalars['String']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']>;
  lockedUntil?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_gt?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_gte?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lockedUntil_lt?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_lte?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_not?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<SeniorTrancheInfo_Filter>>>;
  principalDeposited?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_gt?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_gte?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalDeposited_lt?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_lte?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_not?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalSharePrice?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_gt?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_gte?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalSharePrice_lt?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_lte?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_not?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  trancheId?: InputMaybe<Scalars['BigInt']>;
  trancheId_gt?: InputMaybe<Scalars['BigInt']>;
  trancheId_gte?: InputMaybe<Scalars['BigInt']>;
  trancheId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  trancheId_lt?: InputMaybe<Scalars['BigInt']>;
  trancheId_lte?: InputMaybe<Scalars['BigInt']>;
  trancheId_not?: InputMaybe<Scalars['BigInt']>;
  trancheId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tranchedPool?: InputMaybe<Scalars['String']>;
  tranchedPool_?: InputMaybe<TranchedPool_Filter>;
  tranchedPool_contains?: InputMaybe<Scalars['String']>;
  tranchedPool_contains_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_ends_with?: InputMaybe<Scalars['String']>;
  tranchedPool_ends_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_gt?: InputMaybe<Scalars['String']>;
  tranchedPool_gte?: InputMaybe<Scalars['String']>;
  tranchedPool_in?: InputMaybe<Array<Scalars['String']>>;
  tranchedPool_lt?: InputMaybe<Scalars['String']>;
  tranchedPool_lte?: InputMaybe<Scalars['String']>;
  tranchedPool_not?: InputMaybe<Scalars['String']>;
  tranchedPool_not_contains?: InputMaybe<Scalars['String']>;
  tranchedPool_not_contains_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_not_ends_with?: InputMaybe<Scalars['String']>;
  tranchedPool_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_not_in?: InputMaybe<Array<Scalars['String']>>;
  tranchedPool_not_starts_with?: InputMaybe<Scalars['String']>;
  tranchedPool_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_starts_with?: InputMaybe<Scalars['String']>;
  tranchedPool_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type SeniorTrancheInfo_OrderBy =
  | 'id'
  | 'interestSharePrice'
  | 'loan'
  | 'loan__address'
  | 'loan__balance'
  | 'loan__createdAt'
  | 'loan__creditLineAddress'
  | 'loan__drawdownsPaused'
  | 'loan__fundableAt'
  | 'loan__fundingLimit'
  | 'loan__id'
  | 'loan__initialInterestOwed'
  | 'loan__interestAmountRepaid'
  | 'loan__interestRate'
  | 'loan__interestRateBigInt'
  | 'loan__interestWrittenDown'
  | 'loan__isPaused'
  | 'loan__lateFeeRate'
  | 'loan__numBackers'
  | 'loan__numRepayments'
  | 'loan__principalAmount'
  | 'loan__principalAmountRepaid'
  | 'loan__principalWrittenDown'
  | 'loan__rawGfiApy'
  | 'loan__remainingCapacity'
  | 'loan__repaymentFrequency'
  | 'loan__termEndTime'
  | 'loan__termInSeconds'
  | 'loan__termStartTime'
  | 'loan__totalDeposited'
  | 'loan__usdcApy'
  | 'lockedUntil'
  | 'principalDeposited'
  | 'principalSharePrice'
  | 'trancheId'
  | 'tranchedPool'
  | 'tranchedPool__actualSeniorPoolInvestment'
  | 'tranchedPool__address'
  | 'tranchedPool__balance'
  | 'tranchedPool__createdAt'
  | 'tranchedPool__creditLineAddress'
  | 'tranchedPool__drawdownsPaused'
  | 'tranchedPool__estimatedLeverageRatio'
  | 'tranchedPool__estimatedSeniorPoolContribution'
  | 'tranchedPool__estimatedTotalAssets'
  | 'tranchedPool__fundableAt'
  | 'tranchedPool__fundingLimit'
  | 'tranchedPool__id'
  | 'tranchedPool__initialInterestOwed'
  | 'tranchedPool__interestAccruedAsOf'
  | 'tranchedPool__interestAmountRepaid'
  | 'tranchedPool__interestRate'
  | 'tranchedPool__interestRateBigInt'
  | 'tranchedPool__interestWrittenDown'
  | 'tranchedPool__isPaused'
  | 'tranchedPool__isV1StyleDeal'
  | 'tranchedPool__juniorDeposited'
  | 'tranchedPool__juniorFeePercent'
  | 'tranchedPool__lateFeeRate'
  | 'tranchedPool__nextDueTime'
  | 'tranchedPool__numBackers'
  | 'tranchedPool__numRepayments'
  | 'tranchedPool__principalAmount'
  | 'tranchedPool__principalAmountRepaid'
  | 'tranchedPool__principalWrittenDown'
  | 'tranchedPool__rawGfiApy'
  | 'tranchedPool__remainingCapacity'
  | 'tranchedPool__repaymentFrequency'
  | 'tranchedPool__reserveFeePercent'
  | 'tranchedPool__termEndTime'
  | 'tranchedPool__termInSeconds'
  | 'tranchedPool__termStartTime'
  | 'tranchedPool__totalDeposited'
  | 'tranchedPool__usdcApy'
  | 'tranchedPool__version';

export type StakedPositionType =
  | 'CurveLP'
  | 'Fidu';

export type StakingRewardsData = {
  __typename?: 'StakingRewardsData';
  /** The earn rate is a measure per second */
  currentEarnRatePerToken: Scalars['BigInt'];
  id: Scalars['ID'];
};

export type StakingRewardsData_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<StakingRewardsData_Filter>>>;
  currentEarnRatePerToken?: InputMaybe<Scalars['BigInt']>;
  currentEarnRatePerToken_gt?: InputMaybe<Scalars['BigInt']>;
  currentEarnRatePerToken_gte?: InputMaybe<Scalars['BigInt']>;
  currentEarnRatePerToken_in?: InputMaybe<Array<Scalars['BigInt']>>;
  currentEarnRatePerToken_lt?: InputMaybe<Scalars['BigInt']>;
  currentEarnRatePerToken_lte?: InputMaybe<Scalars['BigInt']>;
  currentEarnRatePerToken_not?: InputMaybe<Scalars['BigInt']>;
  currentEarnRatePerToken_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<StakingRewardsData_Filter>>>;
};

export type StakingRewardsData_OrderBy =
  | 'currentEarnRatePerToken'
  | 'id';

export type SupportedCrypto =
  | 'CURVE_LP'
  | 'FIDU'
  | 'GFI'
  | 'USDC';

export type SupportedFiat =
  | 'USD';

export type SupportedNft =
  | 'POOL_TOKEN'
  | 'STAKING_TOKEN'
  | 'UID';

export type TeamMember = {
  __typename?: 'TeamMember';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  linkedin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};


export type TeamMemberImageArgs = {
  where?: InputMaybe<TeamMember_Image_Where>;
};

export type TeamMember_Image_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_FileNameOverride_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type TeamMember_Image_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Large__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Large__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Large__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Large__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Large__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Large__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Medium__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Medium__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Medium__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Medium__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Medium__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Medium__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Portrait__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Portrait__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Portrait__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Portrait__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Portrait__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Portrait__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Thumbnail__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Thumbnail__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Thumbnail__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Sizes__Thumbnail__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Thumbnail__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Sizes__Thumbnail__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TeamMember_Image_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamMember_Image_Where = {
  AND?: InputMaybe<Array<InputMaybe<TeamMember_Image_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<TeamMember_Image_Where_Or>>>;
  alt?: InputMaybe<TeamMember_Image_Alt_Operator>;
  fileNameOverride?: InputMaybe<TeamMember_Image_FileNameOverride_Operator>;
  filename?: InputMaybe<TeamMember_Image_Filename_Operator>;
  filesize?: InputMaybe<TeamMember_Image_Filesize_Operator>;
  height?: InputMaybe<TeamMember_Image_Height_Operator>;
  id?: InputMaybe<TeamMember_Image_Id_Operator>;
  mimeType?: InputMaybe<TeamMember_Image_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<TeamMember_Image_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<TeamMember_Image_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<TeamMember_Image_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<TeamMember_Image_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<TeamMember_Image_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<TeamMember_Image_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<TeamMember_Image_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<TeamMember_Image_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<TeamMember_Image_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<TeamMember_Image_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<TeamMember_Image_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<TeamMember_Image_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<TeamMember_Image_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<TeamMember_Image_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<TeamMember_Image_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<TeamMember_Image_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<TeamMember_Image_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<TeamMember_Image_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<TeamMember_Image_Url_Operator>;
  width?: InputMaybe<TeamMember_Image_Width_Operator>;
};

export type TeamMember_Image_Where_And = {
  alt?: InputMaybe<TeamMember_Image_Alt_Operator>;
  fileNameOverride?: InputMaybe<TeamMember_Image_FileNameOverride_Operator>;
  filename?: InputMaybe<TeamMember_Image_Filename_Operator>;
  filesize?: InputMaybe<TeamMember_Image_Filesize_Operator>;
  height?: InputMaybe<TeamMember_Image_Height_Operator>;
  id?: InputMaybe<TeamMember_Image_Id_Operator>;
  mimeType?: InputMaybe<TeamMember_Image_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<TeamMember_Image_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<TeamMember_Image_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<TeamMember_Image_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<TeamMember_Image_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<TeamMember_Image_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<TeamMember_Image_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<TeamMember_Image_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<TeamMember_Image_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<TeamMember_Image_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<TeamMember_Image_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<TeamMember_Image_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<TeamMember_Image_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<TeamMember_Image_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<TeamMember_Image_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<TeamMember_Image_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<TeamMember_Image_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<TeamMember_Image_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<TeamMember_Image_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<TeamMember_Image_Url_Operator>;
  width?: InputMaybe<TeamMember_Image_Width_Operator>;
};

export type TeamMember_Image_Where_Or = {
  alt?: InputMaybe<TeamMember_Image_Alt_Operator>;
  fileNameOverride?: InputMaybe<TeamMember_Image_FileNameOverride_Operator>;
  filename?: InputMaybe<TeamMember_Image_Filename_Operator>;
  filesize?: InputMaybe<TeamMember_Image_Filesize_Operator>;
  height?: InputMaybe<TeamMember_Image_Height_Operator>;
  id?: InputMaybe<TeamMember_Image_Id_Operator>;
  mimeType?: InputMaybe<TeamMember_Image_MimeType_Operator>;
  sizes__large__filename?: InputMaybe<TeamMember_Image_Sizes__Large__Filename_Operator>;
  sizes__large__filesize?: InputMaybe<TeamMember_Image_Sizes__Large__Filesize_Operator>;
  sizes__large__height?: InputMaybe<TeamMember_Image_Sizes__Large__Height_Operator>;
  sizes__large__mimeType?: InputMaybe<TeamMember_Image_Sizes__Large__MimeType_Operator>;
  sizes__large__url?: InputMaybe<TeamMember_Image_Sizes__Large__Url_Operator>;
  sizes__large__width?: InputMaybe<TeamMember_Image_Sizes__Large__Width_Operator>;
  sizes__medium__filename?: InputMaybe<TeamMember_Image_Sizes__Medium__Filename_Operator>;
  sizes__medium__filesize?: InputMaybe<TeamMember_Image_Sizes__Medium__Filesize_Operator>;
  sizes__medium__height?: InputMaybe<TeamMember_Image_Sizes__Medium__Height_Operator>;
  sizes__medium__mimeType?: InputMaybe<TeamMember_Image_Sizes__Medium__MimeType_Operator>;
  sizes__medium__url?: InputMaybe<TeamMember_Image_Sizes__Medium__Url_Operator>;
  sizes__medium__width?: InputMaybe<TeamMember_Image_Sizes__Medium__Width_Operator>;
  sizes__portrait__filename?: InputMaybe<TeamMember_Image_Sizes__Portrait__Filename_Operator>;
  sizes__portrait__filesize?: InputMaybe<TeamMember_Image_Sizes__Portrait__Filesize_Operator>;
  sizes__portrait__height?: InputMaybe<TeamMember_Image_Sizes__Portrait__Height_Operator>;
  sizes__portrait__mimeType?: InputMaybe<TeamMember_Image_Sizes__Portrait__MimeType_Operator>;
  sizes__portrait__url?: InputMaybe<TeamMember_Image_Sizes__Portrait__Url_Operator>;
  sizes__portrait__width?: InputMaybe<TeamMember_Image_Sizes__Portrait__Width_Operator>;
  sizes__thumbnail__filename?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Filename_Operator>;
  sizes__thumbnail__filesize?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Filesize_Operator>;
  sizes__thumbnail__height?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Height_Operator>;
  sizes__thumbnail__mimeType?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__MimeType_Operator>;
  sizes__thumbnail__url?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Url_Operator>;
  sizes__thumbnail__width?: InputMaybe<TeamMember_Image_Sizes__Thumbnail__Width_Operator>;
  url?: InputMaybe<TeamMember_Image_Url_Operator>;
  width?: InputMaybe<TeamMember_Image_Width_Operator>;
};

export type TeamMember_Image_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type TrancheInfo = {
  id: Scalars['ID'];
  interestSharePrice: Scalars['BigInt'];
  loan: Loan;
  lockedUntil: Scalars['BigInt'];
  principalDeposited: Scalars['BigInt'];
  principalSharePrice: Scalars['BigInt'];
  trancheId: Scalars['BigInt'];
};

export type TrancheInfo_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<TrancheInfo_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  interestSharePrice?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_gt?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_gte?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestSharePrice_lt?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_lte?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_not?: InputMaybe<Scalars['BigInt']>;
  interestSharePrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  loan?: InputMaybe<Scalars['String']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_ends_with?: InputMaybe<Scalars['String']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_gt?: InputMaybe<Scalars['String']>;
  loan_gte?: InputMaybe<Scalars['String']>;
  loan_in?: InputMaybe<Array<Scalars['String']>>;
  loan_lt?: InputMaybe<Scalars['String']>;
  loan_lte?: InputMaybe<Scalars['String']>;
  loan_not?: InputMaybe<Scalars['String']>;
  loan_not_contains?: InputMaybe<Scalars['String']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  loan_starts_with?: InputMaybe<Scalars['String']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']>;
  lockedUntil?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_gt?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_gte?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lockedUntil_lt?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_lte?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_not?: InputMaybe<Scalars['BigInt']>;
  lockedUntil_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  or?: InputMaybe<Array<InputMaybe<TrancheInfo_Filter>>>;
  principalDeposited?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_gt?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_gte?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalDeposited_lt?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_lte?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_not?: InputMaybe<Scalars['BigInt']>;
  principalDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalSharePrice?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_gt?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_gte?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalSharePrice_lt?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_lte?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_not?: InputMaybe<Scalars['BigInt']>;
  principalSharePrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  trancheId?: InputMaybe<Scalars['BigInt']>;
  trancheId_gt?: InputMaybe<Scalars['BigInt']>;
  trancheId_gte?: InputMaybe<Scalars['BigInt']>;
  trancheId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  trancheId_lt?: InputMaybe<Scalars['BigInt']>;
  trancheId_lte?: InputMaybe<Scalars['BigInt']>;
  trancheId_not?: InputMaybe<Scalars['BigInt']>;
  trancheId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type TrancheInfo_OrderBy =
  | 'id'
  | 'interestSharePrice'
  | 'loan'
  | 'loan__address'
  | 'loan__balance'
  | 'loan__createdAt'
  | 'loan__creditLineAddress'
  | 'loan__drawdownsPaused'
  | 'loan__fundableAt'
  | 'loan__fundingLimit'
  | 'loan__id'
  | 'loan__initialInterestOwed'
  | 'loan__interestAmountRepaid'
  | 'loan__interestRate'
  | 'loan__interestRateBigInt'
  | 'loan__interestWrittenDown'
  | 'loan__isPaused'
  | 'loan__lateFeeRate'
  | 'loan__numBackers'
  | 'loan__numRepayments'
  | 'loan__principalAmount'
  | 'loan__principalAmountRepaid'
  | 'loan__principalWrittenDown'
  | 'loan__rawGfiApy'
  | 'loan__remainingCapacity'
  | 'loan__repaymentFrequency'
  | 'loan__termEndTime'
  | 'loan__termInSeconds'
  | 'loan__termStartTime'
  | 'loan__totalDeposited'
  | 'loan__usdcApy'
  | 'lockedUntil'
  | 'principalDeposited'
  | 'principalSharePrice'
  | 'trancheId';

export type TranchedPool = Loan & {
  __typename?: 'TranchedPool';
  /** A null value indicates there have been no senior pool contributions to the pool yet */
  actualSeniorPoolInvestment?: Maybe<Scalars['BigInt']>;
  address: Scalars['Bytes'];
  allowedUidTypes: Array<UidType>;
  backers: Array<User>;
  balance: Scalars['BigInt'];
  borrowerContract: BorrowerContract;
  borrowerLogo?: Maybe<Scalars['String']>;
  borrowerName: Scalars['String'];
  collectedPaymentBalance: Scalars['BigInt'];
  createdAt: Scalars['Int'];
  creditLine: CreditLine;
  creditLineAddress: Scalars['Bytes'];
  delinquency: LoanDelinquency;
  drawdownsPaused: Scalars['Boolean'];
  estimatedLeverageRatio?: Maybe<Scalars['BigDecimal']>;
  /** This number is only becomes non-zero after the senior pool invests in a pool, which happens after the junior portion is locked */
  estimatedSeniorPoolContribution: Scalars['BigInt'];
  estimatedTotalAssets: Scalars['BigInt'];
  fundableAt: Scalars['Int'];
  fundingLimit: Scalars['BigInt'];
  id: Scalars['ID'];
  /** The amount of interest determined to be owed to this pool, calculated at the very beginning */
  initialInterestOwed: Scalars['BigInt'];
  interestAccruedAsOf: Scalars['BigInt'];
  interestAmountRepaid: Scalars['BigInt'];
  interestOwed: Scalars['BigInt'];
  interestRate: Scalars['BigDecimal'];
  interestRateBigInt: Scalars['BigInt'];
  interestWrittenDown: Scalars['BigInt'];
  isAfterTermEndTime: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  /** Set to true for tranched pools that were created before the advent of junior/senior tranches. These pools have junior investment only, and they are considered legacy */
  isV1StyleDeal: Scalars['Boolean'];
  juniorDeposited: Scalars['BigInt'];
  juniorFeePercent: Scalars['BigInt'];
  juniorTranches: Array<JuniorTrancheInfo>;
  lateFeeRate: Scalars['BigDecimal'];
  name: Scalars['String'];
  nextDueTime: Scalars['BigInt'];
  numBackers: Scalars['Int'];
  numRepayments: Scalars['Int'];
  principalAmount: Scalars['BigInt'];
  principalAmountRepaid: Scalars['BigInt'];
  principalWrittenDown: Scalars['BigInt'];
  rawGfiApy: Scalars['BigDecimal'];
  remainingCapacity: Scalars['BigInt'];
  repaymentFrequency: RepaymentFrequency;
  repaymentSchedule: Array<ScheduledRepayment>;
  reserveFeePercent: Scalars['BigInt'];
  seniorTranches: Array<SeniorTrancheInfo>;
  termEndTime: Scalars['BigInt'];
  termInSeconds: Scalars['Int'];
  termStartTime: Scalars['BigInt'];
  tokens: Array<PoolToken>;
  totalDeposited: Scalars['BigInt'];
  usdcApy: Scalars['BigDecimal'];
  version: TranchedPoolCreditLineVersion;
};


export type TranchedPoolBackersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<User_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<User_Filter>;
};


export type TranchedPoolJuniorTranchesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<JuniorTrancheInfo_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<JuniorTrancheInfo_Filter>;
};


export type TranchedPoolRepaymentScheduleArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ScheduledRepayment_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledRepayment_Filter>;
};


export type TranchedPoolSeniorTranchesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorTrancheInfo_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeniorTrancheInfo_Filter>;
};


export type TranchedPoolTokensArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PoolToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PoolToken_Filter>;
};

export type TranchedPoolCreditLineVersion =
  | 'BEFORE_V2_2'
  | 'V2_2';

export type TranchedPool_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  actualSeniorPoolInvestment?: InputMaybe<Scalars['BigInt']>;
  actualSeniorPoolInvestment_gt?: InputMaybe<Scalars['BigInt']>;
  actualSeniorPoolInvestment_gte?: InputMaybe<Scalars['BigInt']>;
  actualSeniorPoolInvestment_in?: InputMaybe<Array<Scalars['BigInt']>>;
  actualSeniorPoolInvestment_lt?: InputMaybe<Scalars['BigInt']>;
  actualSeniorPoolInvestment_lte?: InputMaybe<Scalars['BigInt']>;
  actualSeniorPoolInvestment_not?: InputMaybe<Scalars['BigInt']>;
  actualSeniorPoolInvestment_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  address?: InputMaybe<Scalars['Bytes']>;
  address_contains?: InputMaybe<Scalars['Bytes']>;
  address_gt?: InputMaybe<Scalars['Bytes']>;
  address_gte?: InputMaybe<Scalars['Bytes']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_lt?: InputMaybe<Scalars['Bytes']>;
  address_lte?: InputMaybe<Scalars['Bytes']>;
  address_not?: InputMaybe<Scalars['Bytes']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  allowedUidTypes?: InputMaybe<Array<UidType>>;
  allowedUidTypes_contains?: InputMaybe<Array<UidType>>;
  allowedUidTypes_not?: InputMaybe<Array<UidType>>;
  allowedUidTypes_not_contains?: InputMaybe<Array<UidType>>;
  and?: InputMaybe<Array<InputMaybe<TranchedPool_Filter>>>;
  backers?: InputMaybe<Array<Scalars['String']>>;
  backers_?: InputMaybe<User_Filter>;
  backers_contains?: InputMaybe<Array<Scalars['String']>>;
  backers_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  backers_not?: InputMaybe<Array<Scalars['String']>>;
  backers_not_contains?: InputMaybe<Array<Scalars['String']>>;
  backers_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  balance?: InputMaybe<Scalars['BigInt']>;
  balance_gt?: InputMaybe<Scalars['BigInt']>;
  balance_gte?: InputMaybe<Scalars['BigInt']>;
  balance_in?: InputMaybe<Array<Scalars['BigInt']>>;
  balance_lt?: InputMaybe<Scalars['BigInt']>;
  balance_lte?: InputMaybe<Scalars['BigInt']>;
  balance_not?: InputMaybe<Scalars['BigInt']>;
  balance_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  borrowerContract?: InputMaybe<Scalars['String']>;
  borrowerContract_?: InputMaybe<BorrowerContract_Filter>;
  borrowerContract_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_gt?: InputMaybe<Scalars['String']>;
  borrowerContract_gte?: InputMaybe<Scalars['String']>;
  borrowerContract_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_lt?: InputMaybe<Scalars['String']>;
  borrowerContract_lte?: InputMaybe<Scalars['String']>;
  borrowerContract_not?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains?: InputMaybe<Scalars['String']>;
  borrowerContract_not_contains_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_not_in?: InputMaybe<Array<Scalars['String']>>;
  borrowerContract_not_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with?: InputMaybe<Scalars['String']>;
  borrowerContract_starts_with_nocase?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Int']>;
  createdAt_gt?: InputMaybe<Scalars['Int']>;
  createdAt_gte?: InputMaybe<Scalars['Int']>;
  createdAt_in?: InputMaybe<Array<Scalars['Int']>>;
  createdAt_lt?: InputMaybe<Scalars['Int']>;
  createdAt_lte?: InputMaybe<Scalars['Int']>;
  createdAt_not?: InputMaybe<Scalars['Int']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  creditLine?: InputMaybe<Scalars['String']>;
  creditLineAddress?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_contains?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_gt?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_gte?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_in?: InputMaybe<Array<Scalars['Bytes']>>;
  creditLineAddress_lt?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_lte?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not_contains?: InputMaybe<Scalars['Bytes']>;
  creditLineAddress_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  creditLine_?: InputMaybe<CreditLine_Filter>;
  creditLine_contains?: InputMaybe<Scalars['String']>;
  creditLine_contains_nocase?: InputMaybe<Scalars['String']>;
  creditLine_ends_with?: InputMaybe<Scalars['String']>;
  creditLine_ends_with_nocase?: InputMaybe<Scalars['String']>;
  creditLine_gt?: InputMaybe<Scalars['String']>;
  creditLine_gte?: InputMaybe<Scalars['String']>;
  creditLine_in?: InputMaybe<Array<Scalars['String']>>;
  creditLine_lt?: InputMaybe<Scalars['String']>;
  creditLine_lte?: InputMaybe<Scalars['String']>;
  creditLine_not?: InputMaybe<Scalars['String']>;
  creditLine_not_contains?: InputMaybe<Scalars['String']>;
  creditLine_not_contains_nocase?: InputMaybe<Scalars['String']>;
  creditLine_not_ends_with?: InputMaybe<Scalars['String']>;
  creditLine_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  creditLine_not_in?: InputMaybe<Array<Scalars['String']>>;
  creditLine_not_starts_with?: InputMaybe<Scalars['String']>;
  creditLine_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  creditLine_starts_with?: InputMaybe<Scalars['String']>;
  creditLine_starts_with_nocase?: InputMaybe<Scalars['String']>;
  drawdownsPaused?: InputMaybe<Scalars['Boolean']>;
  drawdownsPaused_in?: InputMaybe<Array<Scalars['Boolean']>>;
  drawdownsPaused_not?: InputMaybe<Scalars['Boolean']>;
  drawdownsPaused_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  estimatedLeverageRatio?: InputMaybe<Scalars['BigDecimal']>;
  estimatedLeverageRatio_gt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedLeverageRatio_gte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedLeverageRatio_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedLeverageRatio_lt?: InputMaybe<Scalars['BigDecimal']>;
  estimatedLeverageRatio_lte?: InputMaybe<Scalars['BigDecimal']>;
  estimatedLeverageRatio_not?: InputMaybe<Scalars['BigDecimal']>;
  estimatedLeverageRatio_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  estimatedSeniorPoolContribution?: InputMaybe<Scalars['BigInt']>;
  estimatedSeniorPoolContribution_gt?: InputMaybe<Scalars['BigInt']>;
  estimatedSeniorPoolContribution_gte?: InputMaybe<Scalars['BigInt']>;
  estimatedSeniorPoolContribution_in?: InputMaybe<Array<Scalars['BigInt']>>;
  estimatedSeniorPoolContribution_lt?: InputMaybe<Scalars['BigInt']>;
  estimatedSeniorPoolContribution_lte?: InputMaybe<Scalars['BigInt']>;
  estimatedSeniorPoolContribution_not?: InputMaybe<Scalars['BigInt']>;
  estimatedSeniorPoolContribution_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  estimatedTotalAssets?: InputMaybe<Scalars['BigInt']>;
  estimatedTotalAssets_gt?: InputMaybe<Scalars['BigInt']>;
  estimatedTotalAssets_gte?: InputMaybe<Scalars['BigInt']>;
  estimatedTotalAssets_in?: InputMaybe<Array<Scalars['BigInt']>>;
  estimatedTotalAssets_lt?: InputMaybe<Scalars['BigInt']>;
  estimatedTotalAssets_lte?: InputMaybe<Scalars['BigInt']>;
  estimatedTotalAssets_not?: InputMaybe<Scalars['BigInt']>;
  estimatedTotalAssets_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fundableAt?: InputMaybe<Scalars['Int']>;
  fundableAt_gt?: InputMaybe<Scalars['Int']>;
  fundableAt_gte?: InputMaybe<Scalars['Int']>;
  fundableAt_in?: InputMaybe<Array<Scalars['Int']>>;
  fundableAt_lt?: InputMaybe<Scalars['Int']>;
  fundableAt_lte?: InputMaybe<Scalars['Int']>;
  fundableAt_not?: InputMaybe<Scalars['Int']>;
  fundableAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
  fundingLimit?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_gt?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_gte?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fundingLimit_lt?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_lte?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_not?: InputMaybe<Scalars['BigInt']>;
  fundingLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  initialInterestOwed?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_gt?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_gte?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  initialInterestOwed_lt?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_lte?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_not?: InputMaybe<Scalars['BigInt']>;
  initialInterestOwed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAccruedAsOf?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_gt?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_gte?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAccruedAsOf_lt?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_lte?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_not?: InputMaybe<Scalars['BigInt']>;
  interestAccruedAsOf_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAmountRepaid?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_gt?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_gte?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestAmountRepaid_lt?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_lte?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_not?: InputMaybe<Scalars['BigInt']>;
  interestAmountRepaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRate?: InputMaybe<Scalars['BigDecimal']>;
  interestRateBigInt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_gt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_gte?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRateBigInt_lt?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_lte?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_not?: InputMaybe<Scalars['BigInt']>;
  interestRateBigInt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_not?: InputMaybe<Scalars['BigDecimal']>;
  interestRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  interestWrittenDown?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_gt?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_gte?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  interestWrittenDown_lt?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_lte?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_not?: InputMaybe<Scalars['BigInt']>;
  interestWrittenDown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  isPaused?: InputMaybe<Scalars['Boolean']>;
  isPaused_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isPaused_not?: InputMaybe<Scalars['Boolean']>;
  isPaused_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isV1StyleDeal?: InputMaybe<Scalars['Boolean']>;
  isV1StyleDeal_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isV1StyleDeal_not?: InputMaybe<Scalars['Boolean']>;
  isV1StyleDeal_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  juniorDeposited?: InputMaybe<Scalars['BigInt']>;
  juniorDeposited_gt?: InputMaybe<Scalars['BigInt']>;
  juniorDeposited_gte?: InputMaybe<Scalars['BigInt']>;
  juniorDeposited_in?: InputMaybe<Array<Scalars['BigInt']>>;
  juniorDeposited_lt?: InputMaybe<Scalars['BigInt']>;
  juniorDeposited_lte?: InputMaybe<Scalars['BigInt']>;
  juniorDeposited_not?: InputMaybe<Scalars['BigInt']>;
  juniorDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  juniorFeePercent?: InputMaybe<Scalars['BigInt']>;
  juniorFeePercent_gt?: InputMaybe<Scalars['BigInt']>;
  juniorFeePercent_gte?: InputMaybe<Scalars['BigInt']>;
  juniorFeePercent_in?: InputMaybe<Array<Scalars['BigInt']>>;
  juniorFeePercent_lt?: InputMaybe<Scalars['BigInt']>;
  juniorFeePercent_lte?: InputMaybe<Scalars['BigInt']>;
  juniorFeePercent_not?: InputMaybe<Scalars['BigInt']>;
  juniorFeePercent_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  juniorTranches_?: InputMaybe<JuniorTrancheInfo_Filter>;
  lateFeeRate?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_gt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_gte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  lateFeeRate_lt?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_lte?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_not?: InputMaybe<Scalars['BigDecimal']>;
  lateFeeRate_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  nextDueTime?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_gt?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_gte?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  nextDueTime_lt?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_lte?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_not?: InputMaybe<Scalars['BigInt']>;
  nextDueTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  numBackers?: InputMaybe<Scalars['Int']>;
  numBackers_gt?: InputMaybe<Scalars['Int']>;
  numBackers_gte?: InputMaybe<Scalars['Int']>;
  numBackers_in?: InputMaybe<Array<Scalars['Int']>>;
  numBackers_lt?: InputMaybe<Scalars['Int']>;
  numBackers_lte?: InputMaybe<Scalars['Int']>;
  numBackers_not?: InputMaybe<Scalars['Int']>;
  numBackers_not_in?: InputMaybe<Array<Scalars['Int']>>;
  numRepayments?: InputMaybe<Scalars['Int']>;
  numRepayments_gt?: InputMaybe<Scalars['Int']>;
  numRepayments_gte?: InputMaybe<Scalars['Int']>;
  numRepayments_in?: InputMaybe<Array<Scalars['Int']>>;
  numRepayments_lt?: InputMaybe<Scalars['Int']>;
  numRepayments_lte?: InputMaybe<Scalars['Int']>;
  numRepayments_not?: InputMaybe<Scalars['Int']>;
  numRepayments_not_in?: InputMaybe<Array<Scalars['Int']>>;
  or?: InputMaybe<Array<InputMaybe<TranchedPool_Filter>>>;
  principalAmount?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_gt?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_gte?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmountRepaid_lt?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_lte?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_not?: InputMaybe<Scalars['BigInt']>;
  principalAmountRepaid_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmount_gt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_gte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalAmount_lt?: InputMaybe<Scalars['BigInt']>;
  principalAmount_lte?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not?: InputMaybe<Scalars['BigInt']>;
  principalAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalWrittenDown?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_gt?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_gte?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_in?: InputMaybe<Array<Scalars['BigInt']>>;
  principalWrittenDown_lt?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_lte?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_not?: InputMaybe<Scalars['BigInt']>;
  principalWrittenDown_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  rawGfiApy?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_gt?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_gte?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  rawGfiApy_lt?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_lte?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_not?: InputMaybe<Scalars['BigDecimal']>;
  rawGfiApy_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  remainingCapacity?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_gt?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_gte?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_in?: InputMaybe<Array<Scalars['BigInt']>>;
  remainingCapacity_lt?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_lte?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_not?: InputMaybe<Scalars['BigInt']>;
  remainingCapacity_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  repaymentFrequency?: InputMaybe<RepaymentFrequency>;
  repaymentFrequency_in?: InputMaybe<Array<RepaymentFrequency>>;
  repaymentFrequency_not?: InputMaybe<RepaymentFrequency>;
  repaymentFrequency_not_in?: InputMaybe<Array<RepaymentFrequency>>;
  repaymentSchedule?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_?: InputMaybe<ScheduledRepayment_Filter>;
  repaymentSchedule_contains?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not_contains?: InputMaybe<Array<Scalars['String']>>;
  repaymentSchedule_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  reserveFeePercent?: InputMaybe<Scalars['BigInt']>;
  reserveFeePercent_gt?: InputMaybe<Scalars['BigInt']>;
  reserveFeePercent_gte?: InputMaybe<Scalars['BigInt']>;
  reserveFeePercent_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reserveFeePercent_lt?: InputMaybe<Scalars['BigInt']>;
  reserveFeePercent_lte?: InputMaybe<Scalars['BigInt']>;
  reserveFeePercent_not?: InputMaybe<Scalars['BigInt']>;
  reserveFeePercent_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  seniorTranches_?: InputMaybe<SeniorTrancheInfo_Filter>;
  termEndTime?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_gte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termEndTime_lt?: InputMaybe<Scalars['BigInt']>;
  termEndTime_lte?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not?: InputMaybe<Scalars['BigInt']>;
  termEndTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termInSeconds?: InputMaybe<Scalars['Int']>;
  termInSeconds_gt?: InputMaybe<Scalars['Int']>;
  termInSeconds_gte?: InputMaybe<Scalars['Int']>;
  termInSeconds_in?: InputMaybe<Array<Scalars['Int']>>;
  termInSeconds_lt?: InputMaybe<Scalars['Int']>;
  termInSeconds_lte?: InputMaybe<Scalars['Int']>;
  termInSeconds_not?: InputMaybe<Scalars['Int']>;
  termInSeconds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  termStartTime?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_gte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  termStartTime_lt?: InputMaybe<Scalars['BigInt']>;
  termStartTime_lte?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not?: InputMaybe<Scalars['BigInt']>;
  termStartTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tokens?: InputMaybe<Array<Scalars['String']>>;
  tokens_?: InputMaybe<PoolToken_Filter>;
  tokens_contains?: InputMaybe<Array<Scalars['String']>>;
  tokens_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  tokens_not?: InputMaybe<Array<Scalars['String']>>;
  tokens_not_contains?: InputMaybe<Array<Scalars['String']>>;
  tokens_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  totalDeposited?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_gt?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_gte?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalDeposited_lt?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_lte?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_not?: InputMaybe<Scalars['BigInt']>;
  totalDeposited_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcApy?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_gt?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_gte?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  usdcApy_lt?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_lte?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_not?: InputMaybe<Scalars['BigDecimal']>;
  usdcApy_not_in?: InputMaybe<Array<Scalars['BigDecimal']>>;
  version?: InputMaybe<TranchedPoolCreditLineVersion>;
  version_in?: InputMaybe<Array<TranchedPoolCreditLineVersion>>;
  version_not?: InputMaybe<TranchedPoolCreditLineVersion>;
  version_not_in?: InputMaybe<Array<TranchedPoolCreditLineVersion>>;
};

export type TranchedPool_OrderBy =
  | 'actualSeniorPoolInvestment'
  | 'address'
  | 'allowedUidTypes'
  | 'backers'
  | 'balance'
  | 'borrowerContract'
  | 'borrowerContract__createdAt'
  | 'borrowerContract__id'
  | 'createdAt'
  | 'creditLine'
  | 'creditLineAddress'
  | 'creditLine__balance'
  | 'creditLine__id'
  | 'creditLine__interestAccruedAsOf'
  | 'creditLine__interestApr'
  | 'creditLine__interestAprDecimal'
  | 'creditLine__isEligibleForRewards'
  | 'creditLine__lastFullPaymentTime'
  | 'creditLine__lateFeeApr'
  | 'creditLine__limit'
  | 'creditLine__maxLimit'
  | 'creditLine__nextDueTime'
  | 'creditLine__termEndTime'
  | 'creditLine__termStartTime'
  | 'creditLine__version'
  | 'drawdownsPaused'
  | 'estimatedLeverageRatio'
  | 'estimatedSeniorPoolContribution'
  | 'estimatedTotalAssets'
  | 'fundableAt'
  | 'fundingLimit'
  | 'id'
  | 'initialInterestOwed'
  | 'interestAccruedAsOf'
  | 'interestAmountRepaid'
  | 'interestRate'
  | 'interestRateBigInt'
  | 'interestWrittenDown'
  | 'isPaused'
  | 'isV1StyleDeal'
  | 'juniorDeposited'
  | 'juniorFeePercent'
  | 'juniorTranches'
  | 'lateFeeRate'
  | 'nextDueTime'
  | 'numBackers'
  | 'numRepayments'
  | 'principalAmount'
  | 'principalAmountRepaid'
  | 'principalWrittenDown'
  | 'rawGfiApy'
  | 'remainingCapacity'
  | 'repaymentFrequency'
  | 'repaymentSchedule'
  | 'reserveFeePercent'
  | 'seniorTranches'
  | 'termEndTime'
  | 'termInSeconds'
  | 'termStartTime'
  | 'tokens'
  | 'totalDeposited'
  | 'usdcApy'
  | 'version';

export type Transaction = {
  __typename?: 'Transaction';
  blockNumber: Scalars['Int'];
  category: TransactionCategory;
  fiduPrice?: Maybe<Scalars['BigInt']>;
  /** This is a concatenation of transaction hash with log index. One transaction can result in more than one of this entity. */
  id: Scalars['ID'];
  loan?: Maybe<Loan>;
  receivedAmount?: Maybe<Scalars['BigInt']>;
  receivedNftId?: Maybe<Scalars['String']>;
  receivedNftType?: Maybe<SupportedNft>;
  receivedToken?: Maybe<SupportedCrypto>;
  sentAmount?: Maybe<Scalars['BigInt']>;
  sentNftId?: Maybe<Scalars['String']>;
  sentNftType?: Maybe<SupportedNft>;
  sentToken?: Maybe<SupportedCrypto>;
  timestamp: Scalars['Int'];
  transactionHash: Scalars['Bytes'];
  user: User;
};

export type TransactionCategory =
  | 'BACKER_REWARDS_CLAIMED'
  | 'CALL_REQUEST_SUBMITTED'
  | 'COMMUNITY_REWARDS_CLAIMED'
  | 'CURVE_FIDU_BUY'
  | 'CURVE_FIDU_SELL'
  | 'MEMBERSHIP_CAPITAL_DEPOSIT'
  | 'MEMBERSHIP_CAPITAL_WITHDRAWAL'
  | 'MEMBERSHIP_GFI_DEPOSIT'
  | 'MEMBERSHIP_GFI_WITHDRAWAL'
  | 'MEMBERSHIP_REWARDS_CLAIMED'
  | 'SENIOR_POOL_ADD_TO_WITHDRAWAL_REQUEST'
  | 'SENIOR_POOL_CANCEL_WITHDRAWAL_REQUEST'
  | 'SENIOR_POOL_DEPOSIT'
  | 'SENIOR_POOL_DEPOSIT_AND_STAKE'
  | 'SENIOR_POOL_DISTRIBUTION'
  | 'SENIOR_POOL_REDEMPTION'
  | 'SENIOR_POOL_STAKE'
  | 'SENIOR_POOL_UNSTAKE'
  | 'SENIOR_POOL_UNSTAKE_AND_WITHDRAWAL'
  | 'SENIOR_POOL_WITHDRAWAL'
  | 'SENIOR_POOL_WITHDRAWAL_REQUEST'
  | 'STAKING_REWARDS_CLAIMED'
  | 'TRANCHED_POOL_DEPOSIT'
  | 'TRANCHED_POOL_DRAWDOWN'
  | 'TRANCHED_POOL_REPAYMENT'
  | 'TRANCHED_POOL_WITHDRAWAL'
  | 'UID_MINTED';

export type Transaction_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Transaction_Filter>>>;
  blockNumber?: InputMaybe<Scalars['Int']>;
  blockNumber_gt?: InputMaybe<Scalars['Int']>;
  blockNumber_gte?: InputMaybe<Scalars['Int']>;
  blockNumber_in?: InputMaybe<Array<Scalars['Int']>>;
  blockNumber_lt?: InputMaybe<Scalars['Int']>;
  blockNumber_lte?: InputMaybe<Scalars['Int']>;
  blockNumber_not?: InputMaybe<Scalars['Int']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['Int']>>;
  category?: InputMaybe<TransactionCategory>;
  category_in?: InputMaybe<Array<TransactionCategory>>;
  category_not?: InputMaybe<TransactionCategory>;
  category_not_in?: InputMaybe<Array<TransactionCategory>>;
  fiduPrice?: InputMaybe<Scalars['BigInt']>;
  fiduPrice_gt?: InputMaybe<Scalars['BigInt']>;
  fiduPrice_gte?: InputMaybe<Scalars['BigInt']>;
  fiduPrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fiduPrice_lt?: InputMaybe<Scalars['BigInt']>;
  fiduPrice_lte?: InputMaybe<Scalars['BigInt']>;
  fiduPrice_not?: InputMaybe<Scalars['BigInt']>;
  fiduPrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  loan?: InputMaybe<Scalars['String']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_ends_with?: InputMaybe<Scalars['String']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_gt?: InputMaybe<Scalars['String']>;
  loan_gte?: InputMaybe<Scalars['String']>;
  loan_in?: InputMaybe<Array<Scalars['String']>>;
  loan_lt?: InputMaybe<Scalars['String']>;
  loan_lte?: InputMaybe<Scalars['String']>;
  loan_not?: InputMaybe<Scalars['String']>;
  loan_not_contains?: InputMaybe<Scalars['String']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  loan_starts_with?: InputMaybe<Scalars['String']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<InputMaybe<Transaction_Filter>>>;
  receivedAmount?: InputMaybe<Scalars['BigInt']>;
  receivedAmount_gt?: InputMaybe<Scalars['BigInt']>;
  receivedAmount_gte?: InputMaybe<Scalars['BigInt']>;
  receivedAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  receivedAmount_lt?: InputMaybe<Scalars['BigInt']>;
  receivedAmount_lte?: InputMaybe<Scalars['BigInt']>;
  receivedAmount_not?: InputMaybe<Scalars['BigInt']>;
  receivedAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  receivedNftId?: InputMaybe<Scalars['String']>;
  receivedNftId_contains?: InputMaybe<Scalars['String']>;
  receivedNftId_contains_nocase?: InputMaybe<Scalars['String']>;
  receivedNftId_ends_with?: InputMaybe<Scalars['String']>;
  receivedNftId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  receivedNftId_gt?: InputMaybe<Scalars['String']>;
  receivedNftId_gte?: InputMaybe<Scalars['String']>;
  receivedNftId_in?: InputMaybe<Array<Scalars['String']>>;
  receivedNftId_lt?: InputMaybe<Scalars['String']>;
  receivedNftId_lte?: InputMaybe<Scalars['String']>;
  receivedNftId_not?: InputMaybe<Scalars['String']>;
  receivedNftId_not_contains?: InputMaybe<Scalars['String']>;
  receivedNftId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  receivedNftId_not_ends_with?: InputMaybe<Scalars['String']>;
  receivedNftId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  receivedNftId_not_in?: InputMaybe<Array<Scalars['String']>>;
  receivedNftId_not_starts_with?: InputMaybe<Scalars['String']>;
  receivedNftId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  receivedNftId_starts_with?: InputMaybe<Scalars['String']>;
  receivedNftId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  receivedNftType?: InputMaybe<SupportedNft>;
  receivedNftType_in?: InputMaybe<Array<SupportedNft>>;
  receivedNftType_not?: InputMaybe<SupportedNft>;
  receivedNftType_not_in?: InputMaybe<Array<SupportedNft>>;
  receivedToken?: InputMaybe<SupportedCrypto>;
  receivedToken_in?: InputMaybe<Array<SupportedCrypto>>;
  receivedToken_not?: InputMaybe<SupportedCrypto>;
  receivedToken_not_in?: InputMaybe<Array<SupportedCrypto>>;
  sentAmount?: InputMaybe<Scalars['BigInt']>;
  sentAmount_gt?: InputMaybe<Scalars['BigInt']>;
  sentAmount_gte?: InputMaybe<Scalars['BigInt']>;
  sentAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  sentAmount_lt?: InputMaybe<Scalars['BigInt']>;
  sentAmount_lte?: InputMaybe<Scalars['BigInt']>;
  sentAmount_not?: InputMaybe<Scalars['BigInt']>;
  sentAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  sentNftId?: InputMaybe<Scalars['String']>;
  sentNftId_contains?: InputMaybe<Scalars['String']>;
  sentNftId_contains_nocase?: InputMaybe<Scalars['String']>;
  sentNftId_ends_with?: InputMaybe<Scalars['String']>;
  sentNftId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  sentNftId_gt?: InputMaybe<Scalars['String']>;
  sentNftId_gte?: InputMaybe<Scalars['String']>;
  sentNftId_in?: InputMaybe<Array<Scalars['String']>>;
  sentNftId_lt?: InputMaybe<Scalars['String']>;
  sentNftId_lte?: InputMaybe<Scalars['String']>;
  sentNftId_not?: InputMaybe<Scalars['String']>;
  sentNftId_not_contains?: InputMaybe<Scalars['String']>;
  sentNftId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  sentNftId_not_ends_with?: InputMaybe<Scalars['String']>;
  sentNftId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  sentNftId_not_in?: InputMaybe<Array<Scalars['String']>>;
  sentNftId_not_starts_with?: InputMaybe<Scalars['String']>;
  sentNftId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  sentNftId_starts_with?: InputMaybe<Scalars['String']>;
  sentNftId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  sentNftType?: InputMaybe<SupportedNft>;
  sentNftType_in?: InputMaybe<Array<SupportedNft>>;
  sentNftType_not?: InputMaybe<SupportedNft>;
  sentNftType_not_in?: InputMaybe<Array<SupportedNft>>;
  sentToken?: InputMaybe<SupportedCrypto>;
  sentToken_in?: InputMaybe<Array<SupportedCrypto>>;
  sentToken_not?: InputMaybe<SupportedCrypto>;
  sentToken_not_in?: InputMaybe<Array<SupportedCrypto>>;
  timestamp?: InputMaybe<Scalars['Int']>;
  timestamp_gt?: InputMaybe<Scalars['Int']>;
  timestamp_gte?: InputMaybe<Scalars['Int']>;
  timestamp_in?: InputMaybe<Array<Scalars['Int']>>;
  timestamp_lt?: InputMaybe<Scalars['Int']>;
  timestamp_lte?: InputMaybe<Scalars['Int']>;
  timestamp_not?: InputMaybe<Scalars['Int']>;
  timestamp_not_in?: InputMaybe<Array<Scalars['Int']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type Transaction_OrderBy =
  | 'blockNumber'
  | 'category'
  | 'fiduPrice'
  | 'id'
  | 'loan'
  | 'loan__address'
  | 'loan__balance'
  | 'loan__createdAt'
  | 'loan__creditLineAddress'
  | 'loan__drawdownsPaused'
  | 'loan__fundableAt'
  | 'loan__fundingLimit'
  | 'loan__id'
  | 'loan__initialInterestOwed'
  | 'loan__interestAmountRepaid'
  | 'loan__interestRate'
  | 'loan__interestRateBigInt'
  | 'loan__interestWrittenDown'
  | 'loan__isPaused'
  | 'loan__lateFeeRate'
  | 'loan__numBackers'
  | 'loan__numRepayments'
  | 'loan__principalAmount'
  | 'loan__principalAmountRepaid'
  | 'loan__principalWrittenDown'
  | 'loan__rawGfiApy'
  | 'loan__remainingCapacity'
  | 'loan__repaymentFrequency'
  | 'loan__termEndTime'
  | 'loan__termInSeconds'
  | 'loan__termStartTime'
  | 'loan__totalDeposited'
  | 'loan__usdcApy'
  | 'receivedAmount'
  | 'receivedNftId'
  | 'receivedNftType'
  | 'receivedToken'
  | 'sentAmount'
  | 'sentNftId'
  | 'sentNftType'
  | 'sentToken'
  | 'timestamp'
  | 'transactionHash'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

export type UidType =
  | 'NON_US_ENTITY'
  | 'NON_US_INDIVIDUAL'
  | 'US_ACCREDITED_INDIVIDUAL'
  | 'US_ENTITY'
  | 'US_NON_ACCREDITED_INDIVIDUAL';

export type User = {
  __typename?: 'User';
  ENSAvatar?: Maybe<Scalars['String']>;
  ENSName?: Maybe<Scalars['String']>;
  borrowerContracts: Array<BorrowerContract>;
  claimableFromLendEastBackstop: Scalars['UsdcAmount'];
  claimableFromStratosBackstop: Scalars['UsdcAmount'];
  communityRewardsTokens: Array<CommunityRewardsToken>;
  id: Scalars['ID'];
  isGoListed: Scalars['Boolean'];
  poolTokens: Array<PoolToken>;
  seniorPoolStakedPositions: Array<SeniorPoolStakedPosition>;
  transactions: Array<Transaction>;
  uidType?: Maybe<UidType>;
  vaultedPoolTokens: Array<VaultedPoolToken>;
  vaultedStakedPositions: Array<VaultedStakedPosition>;
  zaps: Array<Zap>;
};


export type UserBorrowerContractsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BorrowerContract_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BorrowerContract_Filter>;
};


export type UserCommunityRewardsTokensArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CommunityRewardsToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommunityRewardsToken_Filter>;
};


export type UserPoolTokensArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PoolToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PoolToken_Filter>;
};


export type UserSeniorPoolStakedPositionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SeniorPoolStakedPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeniorPoolStakedPosition_Filter>;
};


export type UserTransactionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Transaction_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Transaction_Filter>;
};


export type UserVaultedPoolTokensArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VaultedPoolToken_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VaultedPoolToken_Filter>;
};


export type UserVaultedStakedPositionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VaultedStakedPosition_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VaultedStakedPosition_Filter>;
};


export type UserZapsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Zap_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Zap_Filter>;
};

export type User_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  borrowerContracts_?: InputMaybe<BorrowerContract_Filter>;
  communityRewardsTokens_?: InputMaybe<CommunityRewardsToken_Filter>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  isGoListed?: InputMaybe<Scalars['Boolean']>;
  isGoListed_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isGoListed_not?: InputMaybe<Scalars['Boolean']>;
  isGoListed_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  or?: InputMaybe<Array<InputMaybe<User_Filter>>>;
  poolTokens?: InputMaybe<Array<Scalars['String']>>;
  poolTokens_?: InputMaybe<PoolToken_Filter>;
  poolTokens_contains?: InputMaybe<Array<Scalars['String']>>;
  poolTokens_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  poolTokens_not?: InputMaybe<Array<Scalars['String']>>;
  poolTokens_not_contains?: InputMaybe<Array<Scalars['String']>>;
  poolTokens_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  seniorPoolStakedPositions_?: InputMaybe<SeniorPoolStakedPosition_Filter>;
  transactions_?: InputMaybe<Transaction_Filter>;
  uidType?: InputMaybe<UidType>;
  uidType_in?: InputMaybe<Array<UidType>>;
  uidType_not?: InputMaybe<UidType>;
  uidType_not_in?: InputMaybe<Array<UidType>>;
  vaultedPoolTokens_?: InputMaybe<VaultedPoolToken_Filter>;
  vaultedStakedPositions_?: InputMaybe<VaultedStakedPosition_Filter>;
  zaps_?: InputMaybe<Zap_Filter>;
};

export type User_OrderBy =
  | 'borrowerContracts'
  | 'communityRewardsTokens'
  | 'id'
  | 'isGoListed'
  | 'poolTokens'
  | 'seniorPoolStakedPositions'
  | 'transactions'
  | 'uidType'
  | 'vaultedPoolTokens'
  | 'vaultedStakedPositions'
  | 'zaps';

export type VaultedGfi = {
  __typename?: 'VaultedGfi';
  amount: Scalars['BigInt'];
  id: Scalars['ID'];
  user: User;
  vaultedAt: Scalars['Int'];
};

export type VaultedGfi_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<VaultedGfi_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<VaultedGfi_Filter>>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAt?: InputMaybe<Scalars['Int']>;
  vaultedAt_gt?: InputMaybe<Scalars['Int']>;
  vaultedAt_gte?: InputMaybe<Scalars['Int']>;
  vaultedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  vaultedAt_lt?: InputMaybe<Scalars['Int']>;
  vaultedAt_lte?: InputMaybe<Scalars['Int']>;
  vaultedAt_not?: InputMaybe<Scalars['Int']>;
  vaultedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
};

export type VaultedGfi_OrderBy =
  | 'amount'
  | 'id'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType'
  | 'vaultedAt';

export type VaultedPoolToken = {
  __typename?: 'VaultedPoolToken';
  id: Scalars['ID'];
  loan: Loan;
  poolToken: PoolToken;
  usdcEquivalent: Scalars['BigInt'];
  user: User;
  vaultedAt: Scalars['Int'];
};

export type VaultedPoolToken_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<VaultedPoolToken_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  loan?: InputMaybe<Scalars['String']>;
  loan_?: InputMaybe<Loan_Filter>;
  loan_contains?: InputMaybe<Scalars['String']>;
  loan_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_ends_with?: InputMaybe<Scalars['String']>;
  loan_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_gt?: InputMaybe<Scalars['String']>;
  loan_gte?: InputMaybe<Scalars['String']>;
  loan_in?: InputMaybe<Array<Scalars['String']>>;
  loan_lt?: InputMaybe<Scalars['String']>;
  loan_lte?: InputMaybe<Scalars['String']>;
  loan_not?: InputMaybe<Scalars['String']>;
  loan_not_contains?: InputMaybe<Scalars['String']>;
  loan_not_contains_nocase?: InputMaybe<Scalars['String']>;
  loan_not_ends_with?: InputMaybe<Scalars['String']>;
  loan_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  loan_not_in?: InputMaybe<Array<Scalars['String']>>;
  loan_not_starts_with?: InputMaybe<Scalars['String']>;
  loan_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  loan_starts_with?: InputMaybe<Scalars['String']>;
  loan_starts_with_nocase?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<InputMaybe<VaultedPoolToken_Filter>>>;
  poolToken?: InputMaybe<Scalars['String']>;
  poolToken_?: InputMaybe<PoolToken_Filter>;
  poolToken_contains?: InputMaybe<Scalars['String']>;
  poolToken_contains_nocase?: InputMaybe<Scalars['String']>;
  poolToken_ends_with?: InputMaybe<Scalars['String']>;
  poolToken_ends_with_nocase?: InputMaybe<Scalars['String']>;
  poolToken_gt?: InputMaybe<Scalars['String']>;
  poolToken_gte?: InputMaybe<Scalars['String']>;
  poolToken_in?: InputMaybe<Array<Scalars['String']>>;
  poolToken_lt?: InputMaybe<Scalars['String']>;
  poolToken_lte?: InputMaybe<Scalars['String']>;
  poolToken_not?: InputMaybe<Scalars['String']>;
  poolToken_not_contains?: InputMaybe<Scalars['String']>;
  poolToken_not_contains_nocase?: InputMaybe<Scalars['String']>;
  poolToken_not_ends_with?: InputMaybe<Scalars['String']>;
  poolToken_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  poolToken_not_in?: InputMaybe<Array<Scalars['String']>>;
  poolToken_not_starts_with?: InputMaybe<Scalars['String']>;
  poolToken_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  poolToken_starts_with?: InputMaybe<Scalars['String']>;
  poolToken_starts_with_nocase?: InputMaybe<Scalars['String']>;
  usdcEquivalent?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_gt?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_gte?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcEquivalent_lt?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_lte?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_not?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAt?: InputMaybe<Scalars['Int']>;
  vaultedAt_gt?: InputMaybe<Scalars['Int']>;
  vaultedAt_gte?: InputMaybe<Scalars['Int']>;
  vaultedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  vaultedAt_lt?: InputMaybe<Scalars['Int']>;
  vaultedAt_lte?: InputMaybe<Scalars['Int']>;
  vaultedAt_not?: InputMaybe<Scalars['Int']>;
  vaultedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
};

export type VaultedPoolToken_OrderBy =
  | 'id'
  | 'loan'
  | 'loan__address'
  | 'loan__balance'
  | 'loan__createdAt'
  | 'loan__creditLineAddress'
  | 'loan__drawdownsPaused'
  | 'loan__fundableAt'
  | 'loan__fundingLimit'
  | 'loan__id'
  | 'loan__initialInterestOwed'
  | 'loan__interestAmountRepaid'
  | 'loan__interestRate'
  | 'loan__interestRateBigInt'
  | 'loan__interestWrittenDown'
  | 'loan__isPaused'
  | 'loan__lateFeeRate'
  | 'loan__numBackers'
  | 'loan__numRepayments'
  | 'loan__principalAmount'
  | 'loan__principalAmountRepaid'
  | 'loan__principalWrittenDown'
  | 'loan__rawGfiApy'
  | 'loan__remainingCapacity'
  | 'loan__repaymentFrequency'
  | 'loan__termEndTime'
  | 'loan__termInSeconds'
  | 'loan__termStartTime'
  | 'loan__totalDeposited'
  | 'loan__usdcApy'
  | 'poolToken'
  | 'poolToken__callDueAt'
  | 'poolToken__calledAt'
  | 'poolToken__id'
  | 'poolToken__interestRedeemable'
  | 'poolToken__interestRedeemed'
  | 'poolToken__isCapitalCalled'
  | 'poolToken__mintedAt'
  | 'poolToken__principalAmount'
  | 'poolToken__principalRedeemed'
  | 'poolToken__rewardsClaimable'
  | 'poolToken__rewardsClaimed'
  | 'poolToken__stakingRewardsClaimable'
  | 'poolToken__stakingRewardsClaimed'
  | 'poolToken__tranche'
  | 'usdcEquivalent'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType'
  | 'vaultedAt';

export type VaultedStakedPosition = {
  __typename?: 'VaultedStakedPosition';
  id: Scalars['ID'];
  seniorPoolStakedPosition: SeniorPoolStakedPosition;
  usdcEquivalent: Scalars['BigInt'];
  user: User;
  vaultedAt: Scalars['Int'];
};

export type VaultedStakedPosition_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<VaultedStakedPosition_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<VaultedStakedPosition_Filter>>>;
  seniorPoolStakedPosition?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_?: InputMaybe<SeniorPoolStakedPosition_Filter>;
  seniorPoolStakedPosition_contains?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_contains_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_ends_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_ends_with_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_gt?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_gte?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_in?: InputMaybe<Array<Scalars['String']>>;
  seniorPoolStakedPosition_lt?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_lte?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_contains?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_contains_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_ends_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_in?: InputMaybe<Array<Scalars['String']>>;
  seniorPoolStakedPosition_not_starts_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_starts_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_starts_with_nocase?: InputMaybe<Scalars['String']>;
  usdcEquivalent?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_gt?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_gte?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_in?: InputMaybe<Array<Scalars['BigInt']>>;
  usdcEquivalent_lt?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_lte?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_not?: InputMaybe<Scalars['BigInt']>;
  usdcEquivalent_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vaultedAt?: InputMaybe<Scalars['Int']>;
  vaultedAt_gt?: InputMaybe<Scalars['Int']>;
  vaultedAt_gte?: InputMaybe<Scalars['Int']>;
  vaultedAt_in?: InputMaybe<Array<Scalars['Int']>>;
  vaultedAt_lt?: InputMaybe<Scalars['Int']>;
  vaultedAt_lte?: InputMaybe<Scalars['Int']>;
  vaultedAt_not?: InputMaybe<Scalars['Int']>;
  vaultedAt_not_in?: InputMaybe<Array<Scalars['Int']>>;
};

export type VaultedStakedPosition_OrderBy =
  | 'id'
  | 'seniorPoolStakedPosition'
  | 'seniorPoolStakedPosition__amount'
  | 'seniorPoolStakedPosition__id'
  | 'seniorPoolStakedPosition__initialAmount'
  | 'seniorPoolStakedPosition__positionType'
  | 'seniorPoolStakedPosition__startTime'
  | 'seniorPoolStakedPosition__totalRewardsClaimed'
  | 'usdcEquivalent'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType'
  | 'vaultedAt';

export type Viewer = {
  __typename?: 'Viewer';
  account?: Maybe<Scalars['String']>;
  accruedMembershipRewardsThisEpoch?: Maybe<Scalars['FiduAmount']>;
  claimableMembershipRewards?: Maybe<Scalars['FiduAmount']>;
  curveLpBalance?: Maybe<Scalars['CurveLpAmount']>;
  fiduBalance?: Maybe<Scalars['FiduAmount']>;
  gfiBalance?: Maybe<Scalars['GfiAmount']>;
  gfiGrants: Array<GfiGrant>;
  kycStatus?: Maybe<KycStatus>;
  usdcBalance?: Maybe<Scalars['UsdcAmount']>;
};


export type ViewerAccountArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Zap = {
  __typename?: 'Zap';
  amount: Scalars['BigInt'];
  /** Note that the ID of a Zap is the same as the ID of the (tranched) pool token it's tied to. Makes it easy to find a Zap corresponding to a pool token. */
  id: Scalars['ID'];
  poolToken: PoolToken;
  seniorPoolStakedPosition: SeniorPoolStakedPosition;
  tranchedPool: TranchedPool;
  user: User;
};

export type Zap_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<Zap_Filter>>>;
  id?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  or?: InputMaybe<Array<InputMaybe<Zap_Filter>>>;
  poolToken?: InputMaybe<Scalars['String']>;
  poolToken_?: InputMaybe<PoolToken_Filter>;
  poolToken_contains?: InputMaybe<Scalars['String']>;
  poolToken_contains_nocase?: InputMaybe<Scalars['String']>;
  poolToken_ends_with?: InputMaybe<Scalars['String']>;
  poolToken_ends_with_nocase?: InputMaybe<Scalars['String']>;
  poolToken_gt?: InputMaybe<Scalars['String']>;
  poolToken_gte?: InputMaybe<Scalars['String']>;
  poolToken_in?: InputMaybe<Array<Scalars['String']>>;
  poolToken_lt?: InputMaybe<Scalars['String']>;
  poolToken_lte?: InputMaybe<Scalars['String']>;
  poolToken_not?: InputMaybe<Scalars['String']>;
  poolToken_not_contains?: InputMaybe<Scalars['String']>;
  poolToken_not_contains_nocase?: InputMaybe<Scalars['String']>;
  poolToken_not_ends_with?: InputMaybe<Scalars['String']>;
  poolToken_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  poolToken_not_in?: InputMaybe<Array<Scalars['String']>>;
  poolToken_not_starts_with?: InputMaybe<Scalars['String']>;
  poolToken_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  poolToken_starts_with?: InputMaybe<Scalars['String']>;
  poolToken_starts_with_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_?: InputMaybe<SeniorPoolStakedPosition_Filter>;
  seniorPoolStakedPosition_contains?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_contains_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_ends_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_ends_with_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_gt?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_gte?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_in?: InputMaybe<Array<Scalars['String']>>;
  seniorPoolStakedPosition_lt?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_lte?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_contains?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_contains_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_ends_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_in?: InputMaybe<Array<Scalars['String']>>;
  seniorPoolStakedPosition_not_starts_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_starts_with?: InputMaybe<Scalars['String']>;
  seniorPoolStakedPosition_starts_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool?: InputMaybe<Scalars['String']>;
  tranchedPool_?: InputMaybe<TranchedPool_Filter>;
  tranchedPool_contains?: InputMaybe<Scalars['String']>;
  tranchedPool_contains_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_ends_with?: InputMaybe<Scalars['String']>;
  tranchedPool_ends_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_gt?: InputMaybe<Scalars['String']>;
  tranchedPool_gte?: InputMaybe<Scalars['String']>;
  tranchedPool_in?: InputMaybe<Array<Scalars['String']>>;
  tranchedPool_lt?: InputMaybe<Scalars['String']>;
  tranchedPool_lte?: InputMaybe<Scalars['String']>;
  tranchedPool_not?: InputMaybe<Scalars['String']>;
  tranchedPool_not_contains?: InputMaybe<Scalars['String']>;
  tranchedPool_not_contains_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_not_ends_with?: InputMaybe<Scalars['String']>;
  tranchedPool_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_not_in?: InputMaybe<Array<Scalars['String']>>;
  tranchedPool_not_starts_with?: InputMaybe<Scalars['String']>;
  tranchedPool_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  tranchedPool_starts_with?: InputMaybe<Scalars['String']>;
  tranchedPool_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
  user_?: InputMaybe<User_Filter>;
  user_contains?: InputMaybe<Scalars['String']>;
  user_contains_nocase?: InputMaybe<Scalars['String']>;
  user_ends_with?: InputMaybe<Scalars['String']>;
  user_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_gt?: InputMaybe<Scalars['String']>;
  user_gte?: InputMaybe<Scalars['String']>;
  user_in?: InputMaybe<Array<Scalars['String']>>;
  user_lt?: InputMaybe<Scalars['String']>;
  user_lte?: InputMaybe<Scalars['String']>;
  user_not?: InputMaybe<Scalars['String']>;
  user_not_contains?: InputMaybe<Scalars['String']>;
  user_not_contains_nocase?: InputMaybe<Scalars['String']>;
  user_not_ends_with?: InputMaybe<Scalars['String']>;
  user_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  user_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_not_starts_with?: InputMaybe<Scalars['String']>;
  user_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  user_starts_with?: InputMaybe<Scalars['String']>;
  user_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export type Zap_OrderBy =
  | 'amount'
  | 'id'
  | 'poolToken'
  | 'poolToken__callDueAt'
  | 'poolToken__calledAt'
  | 'poolToken__id'
  | 'poolToken__interestRedeemable'
  | 'poolToken__interestRedeemed'
  | 'poolToken__isCapitalCalled'
  | 'poolToken__mintedAt'
  | 'poolToken__principalAmount'
  | 'poolToken__principalRedeemed'
  | 'poolToken__rewardsClaimable'
  | 'poolToken__rewardsClaimed'
  | 'poolToken__stakingRewardsClaimable'
  | 'poolToken__stakingRewardsClaimed'
  | 'poolToken__tranche'
  | 'seniorPoolStakedPosition'
  | 'seniorPoolStakedPosition__amount'
  | 'seniorPoolStakedPosition__id'
  | 'seniorPoolStakedPosition__initialAmount'
  | 'seniorPoolStakedPosition__positionType'
  | 'seniorPoolStakedPosition__startTime'
  | 'seniorPoolStakedPosition__totalRewardsClaimed'
  | 'tranchedPool'
  | 'tranchedPool__actualSeniorPoolInvestment'
  | 'tranchedPool__address'
  | 'tranchedPool__balance'
  | 'tranchedPool__createdAt'
  | 'tranchedPool__creditLineAddress'
  | 'tranchedPool__drawdownsPaused'
  | 'tranchedPool__estimatedLeverageRatio'
  | 'tranchedPool__estimatedSeniorPoolContribution'
  | 'tranchedPool__estimatedTotalAssets'
  | 'tranchedPool__fundableAt'
  | 'tranchedPool__fundingLimit'
  | 'tranchedPool__id'
  | 'tranchedPool__initialInterestOwed'
  | 'tranchedPool__interestAccruedAsOf'
  | 'tranchedPool__interestAmountRepaid'
  | 'tranchedPool__interestRate'
  | 'tranchedPool__interestRateBigInt'
  | 'tranchedPool__interestWrittenDown'
  | 'tranchedPool__isPaused'
  | 'tranchedPool__isV1StyleDeal'
  | 'tranchedPool__juniorDeposited'
  | 'tranchedPool__juniorFeePercent'
  | 'tranchedPool__lateFeeRate'
  | 'tranchedPool__nextDueTime'
  | 'tranchedPool__numBackers'
  | 'tranchedPool__numRepayments'
  | 'tranchedPool__principalAmount'
  | 'tranchedPool__principalAmountRepaid'
  | 'tranchedPool__principalWrittenDown'
  | 'tranchedPool__rawGfiApy'
  | 'tranchedPool__remainingCapacity'
  | 'tranchedPool__repaymentFrequency'
  | 'tranchedPool__reserveFeePercent'
  | 'tranchedPool__termEndTime'
  | 'tranchedPool__termInSeconds'
  | 'tranchedPool__termStartTime'
  | 'tranchedPool__totalDeposited'
  | 'tranchedPool__usdcApy'
  | 'tranchedPool__version'
  | 'user'
  | 'user__id'
  | 'user__isGoListed'
  | 'user__uidType';

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']>;
  /** The block number */
  number: Scalars['Int'];
  /** The hash of the parent block */
  parentHash?: Maybe<Scalars['Bytes']>;
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean'];
};

export type _SubgraphErrorPolicy_ =
  /** Data will be returned even if the subgraph has indexing errors */
  | 'allow'
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  | 'deny';

export type HighlightGridFieldsFragment = { __typename?: 'Deal_Highlights', heading?: string | null, body?: any | null };

export type AccountStatusQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type AccountStatusQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, uidType?: UidType | null, isGoListed: boolean } | null };

export type CurrentUserWalletInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWalletInfoQuery = { __typename?: 'Query', gfiPrice: { __typename?: 'GfiPrice', price: { __typename?: 'FiatAmount', amount: number, symbol: SupportedFiat } }, viewer: { __typename?: 'Viewer', usdcBalance?: CryptoAmount<"USDC"> | null, gfiBalance?: CryptoAmount<"GFI"> | null } };

export type StatusCheckStepQueryVariables = Exact<{
  account: Scalars['ID'];
}>;


export type StatusCheckStepQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, uidType?: UidType | null } | null };

type RepaymentStatusLoanFields_CallableLoan_Fragment = { __typename?: 'CallableLoan', id: string, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, delinquency: LoanDelinquency };

type RepaymentStatusLoanFields_TranchedPool_Fragment = { __typename?: 'TranchedPool', id: string, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, delinquency: LoanDelinquency };

export type RepaymentStatusLoanFieldsFragment = RepaymentStatusLoanFields_CallableLoan_Fragment | RepaymentStatusLoanFields_TranchedPool_Fragment;

type FundingStatusLoanFields_CallableLoan_Fragment = { __typename?: 'CallableLoan', id: string, remainingCapacity: TheGraph_BigInt, fundableAt: number, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt };

type FundingStatusLoanFields_TranchedPool_Fragment = { __typename?: 'TranchedPool', id: string, remainingCapacity: TheGraph_BigInt, fundableAt: number, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt };

export type FundingStatusLoanFieldsFragment = FundingStatusLoanFields_CallableLoan_Fragment | FundingStatusLoanFields_TranchedPool_Fragment;

export type UserEligibilityFieldsFragment = { __typename?: 'User', id: string, uidType?: UidType | null, isGoListed: boolean };

export type UserUidForAnalyticsQueryVariables = Exact<{
  account: Scalars['ID'];
}>;


export type UserUidForAnalyticsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, uidType?: UidType | null } | null };

export type AccountPageQueryVariables = Exact<{
  account: Scalars['ID'];
}>;


export type AccountPageQuery = { __typename?: 'Query', user?: { __typename?: 'User', uidType?: UidType | null } | null, viewer: { __typename?: 'Viewer', kycStatus?: { __typename?: 'KycStatus', kycProvider?: string | null, status: string, identityStatus?: string | null, accreditationStatus?: string | null, countryCode?: string | null, type?: string | null } | null } };

export type KnownTokensQueryVariables = Exact<{
  account: Scalars['String'];
  merkleDistributorIndices: Array<Scalars['Int']> | Scalars['Int'];
  backerMerkleDistributorIndices: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type KnownTokensQuery = { __typename?: 'Query', ownedTokens: Array<{ __typename?: 'CommunityRewardsToken', index: number, source: CommunityRewardsTokenSource, user: { __typename?: 'User', id: string } }>, relinquishedTokens: Array<{ __typename?: 'CommunityRewardsToken', index: number, source: CommunityRewardsTokenSource }> };

export type CallableLoanCallPoolTokensFieldsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, callDueAt?: number | null };

export type CallableLoanCallPoolTokensQueryVariables = Exact<{
  loanId: Scalars['String'];
}>;


export type CallableLoanCallPoolTokensQuery = { __typename?: 'Query', poolTokens: Array<{ __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, callDueAt?: number | null }> };

export type PoolCreditLinePageQueryVariables = Exact<{
  loanId: Scalars['ID'];
}>;


export type PoolCreditLinePageQuery = { __typename?: 'Query', loan?: { __typename: 'CallableLoan', isPaused: boolean, drawdownsPaused: boolean, termInSeconds: number, interestRate: TheGraph_BigDecimal, interestRateBigInt: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, principalAmount: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, creditLineAddress: string, repaymentFrequency: RepaymentFrequency, delinquency: LoanDelinquency, isAfterTermEndTime: boolean, id: string, totalDeposited: TheGraph_BigInt, availableForDrawdown: TheGraph_BigInt, lastFullPaymentTime: number, principalAmountRepaid: TheGraph_BigInt, periodInterestDueAmount: TheGraph_BigInt, periodPrincipalDueAmount: TheGraph_BigInt, termTotalDueAmount: TheGraph_BigInt, nextDueTime: TheGraph_BigInt, loanPhase: LoanPhase, borrowerContract: { __typename?: 'BorrowerContract', id: string } } | { __typename: 'TranchedPool', isPaused: boolean, drawdownsPaused: boolean, termInSeconds: number, interestRate: TheGraph_BigDecimal, interestRateBigInt: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, principalAmount: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, creditLineAddress: string, repaymentFrequency: RepaymentFrequency, delinquency: LoanDelinquency, isAfterTermEndTime: boolean, id: string, nextDueTime: TheGraph_BigInt, interestAccruedAsOf: TheGraph_BigInt, interestOwed: TheGraph_BigInt, collectedPaymentBalance: TheGraph_BigInt, borrowerContract: { __typename?: 'BorrowerContract', id: string }, creditLine: { __typename?: 'CreditLine', id: string }, juniorTranches: Array<{ __typename?: 'JuniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt, lockedUntil: TheGraph_BigInt }>, seniorTranches: Array<{ __typename?: 'SeniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt }> } | null };

export type PoolCreditLinePageCmsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PoolCreditLinePageCmsQuery = { __typename?: 'Query', Deal?: { __typename?: 'Deal', id: string, name: string, category: string } | null };

export type LoanBorrowCardFieldsFragment = { __typename?: 'Deal', id: string, name: string, category: string };

export type TranchedPoolBorrowerAccountingFieldsFragment = { __typename?: 'TranchedPool', id: string, nextDueTime: TheGraph_BigInt, interestAccruedAsOf: TheGraph_BigInt, interestOwed: TheGraph_BigInt, collectedPaymentBalance: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, principalAmount: TheGraph_BigInt, drawdownsPaused: boolean, creditLine: { __typename?: 'CreditLine', id: string }, juniorTranches: Array<{ __typename?: 'JuniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt, lockedUntil: TheGraph_BigInt }>, seniorTranches: Array<{ __typename?: 'SeniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt }> };

export type CallableLoanBorrowerAccountingFieldsFragment = { __typename?: 'CallableLoan', id: string, totalDeposited: TheGraph_BigInt, availableForDrawdown: TheGraph_BigInt, lastFullPaymentTime: number, principalAmountRepaid: TheGraph_BigInt, delinquency: LoanDelinquency, periodInterestDueAmount: TheGraph_BigInt, periodPrincipalDueAmount: TheGraph_BigInt, termTotalDueAmount: TheGraph_BigInt, nextDueTime: TheGraph_BigInt, loanPhase: LoanPhase };

type LoanBorrowerAccountingFields_CallableLoan_Fragment = { __typename: 'CallableLoan', isPaused: boolean, drawdownsPaused: boolean, termInSeconds: number, interestRate: TheGraph_BigDecimal, interestRateBigInt: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, principalAmount: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, creditLineAddress: string, repaymentFrequency: RepaymentFrequency, delinquency: LoanDelinquency, isAfterTermEndTime: boolean, id: string, totalDeposited: TheGraph_BigInt, availableForDrawdown: TheGraph_BigInt, lastFullPaymentTime: number, principalAmountRepaid: TheGraph_BigInt, periodInterestDueAmount: TheGraph_BigInt, periodPrincipalDueAmount: TheGraph_BigInt, termTotalDueAmount: TheGraph_BigInt, nextDueTime: TheGraph_BigInt, loanPhase: LoanPhase, borrowerContract: { __typename?: 'BorrowerContract', id: string } };

type LoanBorrowerAccountingFields_TranchedPool_Fragment = { __typename: 'TranchedPool', isPaused: boolean, drawdownsPaused: boolean, termInSeconds: number, interestRate: TheGraph_BigDecimal, interestRateBigInt: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, principalAmount: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, creditLineAddress: string, repaymentFrequency: RepaymentFrequency, delinquency: LoanDelinquency, isAfterTermEndTime: boolean, id: string, nextDueTime: TheGraph_BigInt, interestAccruedAsOf: TheGraph_BigInt, interestOwed: TheGraph_BigInt, collectedPaymentBalance: TheGraph_BigInt, borrowerContract: { __typename?: 'BorrowerContract', id: string }, creditLine: { __typename?: 'CreditLine', id: string }, juniorTranches: Array<{ __typename?: 'JuniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt, lockedUntil: TheGraph_BigInt }>, seniorTranches: Array<{ __typename?: 'SeniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt }> };

export type LoanBorrowerAccountingFieldsFragment = LoanBorrowerAccountingFields_CallableLoan_Fragment | LoanBorrowerAccountingFields_TranchedPool_Fragment;

export type BorrowPageQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type BorrowPageQuery = { __typename?: 'Query', loans: Array<{ __typename: 'CallableLoan', isPaused: boolean, drawdownsPaused: boolean, termInSeconds: number, interestRate: TheGraph_BigDecimal, interestRateBigInt: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, principalAmount: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, creditLineAddress: string, repaymentFrequency: RepaymentFrequency, delinquency: LoanDelinquency, isAfterTermEndTime: boolean, id: string, totalDeposited: TheGraph_BigInt, availableForDrawdown: TheGraph_BigInt, lastFullPaymentTime: number, principalAmountRepaid: TheGraph_BigInt, periodInterestDueAmount: TheGraph_BigInt, periodPrincipalDueAmount: TheGraph_BigInt, termTotalDueAmount: TheGraph_BigInt, nextDueTime: TheGraph_BigInt, loanPhase: LoanPhase, borrowerContract: { __typename?: 'BorrowerContract', id: string } } | { __typename: 'TranchedPool', isPaused: boolean, drawdownsPaused: boolean, termInSeconds: number, interestRate: TheGraph_BigDecimal, interestRateBigInt: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, principalAmount: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, creditLineAddress: string, repaymentFrequency: RepaymentFrequency, delinquency: LoanDelinquency, isAfterTermEndTime: boolean, id: string, nextDueTime: TheGraph_BigInt, interestAccruedAsOf: TheGraph_BigInt, interestOwed: TheGraph_BigInt, collectedPaymentBalance: TheGraph_BigInt, borrowerContract: { __typename?: 'BorrowerContract', id: string }, creditLine: { __typename?: 'CreditLine', id: string }, juniorTranches: Array<{ __typename?: 'JuniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt, lockedUntil: TheGraph_BigInt }>, seniorTranches: Array<{ __typename?: 'SeniorTrancheInfo', id: string, principalSharePrice: TheGraph_BigInt, principalDeposited: TheGraph_BigInt }> }> };

export type BorrowPageCmsQueryVariables = Exact<{ [key: string]: never; }>;


export type BorrowPageCmsQuery = { __typename?: 'Query', Deals?: { __typename?: 'Deals', docs?: Array<{ __typename?: 'Deal', id: string, name: string, category: string } | null> | null } | null };

export type DashboardStakedPositionFieldsFragment = { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt };

export type DashboardPoolTokenFieldsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } };

export type DashboardPageQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DashboardPageQuery = { __typename?: 'Query', seniorPools: Array<{ __typename?: 'SeniorPool', id: string, sharePrice: TheGraph_BigInt }>, viewer: { __typename?: 'Viewer', fiduBalance?: CryptoAmount<"FIDU"> | null, gfiBalance?: CryptoAmount<"GFI"> | null, curveLpBalance?: CryptoAmount<"CURVE_LP"> | null, claimableMembershipRewards?: CryptoAmount<"FIDU"> | null, gfiGrants: Array<{ __typename: 'DirectGfiGrant', isAccepted: boolean, id: string, index: number, amount: TheGraph_BigInt } | { __typename: 'IndirectGfiGrant', indirectSource: IndirectGrantSource, vested: TheGraph_BigInt, id: string, index: number, amount: TheGraph_BigInt }> }, gfiPrice: { __typename?: 'GfiPrice', price: { __typename?: 'FiatAmount', amount: number, symbol: SupportedFiat } }, vaultedGfis: Array<{ __typename?: 'VaultedGfi', id: string, amount: TheGraph_BigInt }>, curvePool: { __typename?: 'CurvePool', usdPerLpToken: TheGraph_BigDecimal }, poolTokens: Array<{ __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } }>, vaultedPoolTokens: Array<{ __typename?: 'VaultedPoolToken', id: string, poolToken: { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } } }>, stakedFiduPositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt }>, vaultedStakedPositions: Array<{ __typename?: 'VaultedStakedPosition', id: string, seniorPoolStakedPosition: { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt } }>, stakedCurveLpPositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt }>, pastAndCurrentSeniorPoolPositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, claimable: TheGraph_BigInt, granted: TheGraph_BigInt, totalRewardsClaimed: TheGraph_BigInt }>, communityRewardsTokens: Array<{ __typename?: 'CommunityRewardsToken', id: string, source: CommunityRewardsTokenSource, index: number, totalClaimed: TheGraph_BigInt }>, seniorPoolWithdrawalRequests: Array<{ __typename?: 'SeniorPoolWithdrawalRequest', id: string, fiduRequested: TheGraph_BigInt }> };

export type CurrentUserTransactionsQueryVariables = Exact<{
  account: Scalars['String'];
  first: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type CurrentUserTransactionsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'Transaction', id: string, transactionHash: string, category: TransactionCategory, sentAmount?: TheGraph_BigInt | null, sentToken?: SupportedCrypto | null, sentNftId?: string | null, sentNftType?: SupportedNft | null, receivedAmount?: TheGraph_BigInt | null, receivedToken?: SupportedCrypto | null, receivedNftId?: string | null, receivedNftType?: SupportedNft | null, fiduPrice?: TheGraph_BigInt | null, timestamp: number, loan?: { __typename?: 'CallableLoan', id: string } | { __typename?: 'TranchedPool', id: string } | null }> };

export type ProtocolMetricsFieldsFragment = { __typename?: 'Protocol', id: string, totalDrawdowns: TheGraph_BigInt, totalWritedowns: TheGraph_BigInt, defaultRate: TheGraph_BigDecimal, totalReserveCollected: TheGraph_BigInt, totalInterestCollected: TheGraph_BigInt, totalPrincipalCollected: TheGraph_BigInt };

export type EarnPageQueryVariables = Exact<{
  numClosedPools: Scalars['Int'];
  account: Scalars['ID'];
}>;


export type EarnPageQuery = { __typename?: 'Query', seniorPools: Array<{ __typename?: 'SeniorPool', id: string, name: string, category: string, icon: string, estimatedApy: TheGraph_BigDecimal, estimatedApyFromGfiRaw: TheGraph_BigDecimal, sharePrice: TheGraph_BigInt }>, openPools: Array<{ __typename: 'CallableLoan', id: string, usdcApy: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, termInSeconds: number, remainingCapacity: TheGraph_BigInt, fundableAt: number, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt } | { __typename: 'TranchedPool', id: string, usdcApy: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, termInSeconds: number, remainingCapacity: TheGraph_BigInt, fundableAt: number, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt }>, closedPools: Array<{ __typename?: 'CallableLoan', id: string, principalAmount: TheGraph_BigInt, termEndTime: TheGraph_BigInt, balance: TheGraph_BigInt, delinquency: LoanDelinquency } | { __typename?: 'TranchedPool', id: string, principalAmount: TheGraph_BigInt, termEndTime: TheGraph_BigInt, balance: TheGraph_BigInt, delinquency: LoanDelinquency }>, protocols: Array<{ __typename?: 'Protocol', id: string, numLoans: number, totalDrawdowns: TheGraph_BigInt, totalWritedowns: TheGraph_BigInt, defaultRate: TheGraph_BigDecimal, totalReserveCollected: TheGraph_BigInt, totalInterestCollected: TheGraph_BigInt, totalPrincipalCollected: TheGraph_BigInt }>, gfiPrice: { __typename?: 'GfiPrice', lastUpdated: number, price: { __typename?: 'FiatAmount', amount: number, symbol: SupportedFiat } }, user?: { __typename?: 'User', uidType?: UidType | null } | null, viewer: { __typename?: 'Viewer', fiduBalance?: CryptoAmount<"FIDU"> | null }, currentBlock: { __typename?: 'BlockInfo', timestamp: number } };

export type EarnPageCmsQueryVariables = Exact<{ [key: string]: never; }>;


export type EarnPageCmsQuery = { __typename?: 'Query', Deals?: { __typename?: 'Deals', docs?: Array<{ __typename?: 'Deal', id: string, name: string, category: string, dealType?: Deal_DealType | null, borrower: { __typename?: 'Borrower', id?: string | null, name: string, logo?: { __typename?: 'Media', url?: string | null } | null } } | null> | null } | null };

export type BackerCardTokenFieldsFragment = { __typename?: 'PoolToken', id: string, mintedAt: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, rewardsClaimed: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, stakingRewardsClaimed: TheGraph_BigInt, principalAmount: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string, delinquency: LoanDelinquency, isPaused: boolean } | { __typename?: 'TranchedPool', id: string, name: string, delinquency: LoanDelinquency, isPaused: boolean } };

type GrantCardGrantFields_DirectGfiGrant_Fragment = { __typename: 'DirectGfiGrant', directSource: DirectGrantSource, isAccepted: boolean, id: string, index: number, reason: GrantReason, proof: Array<string>, amount: TheGraph_BigInt };

type GrantCardGrantFields_IndirectGfiGrant_Fragment = { __typename: 'IndirectGfiGrant', indirectSource: IndirectGrantSource, vestingLength: TheGraph_BigInt, vestingInterval: TheGraph_BigInt, cliffLength: TheGraph_BigInt, start: TheGraph_BigInt, end: TheGraph_BigInt, vested: TheGraph_BigInt, id: string, index: number, reason: GrantReason, proof: Array<string>, amount: TheGraph_BigInt };

export type GrantCardGrantFieldsFragment = GrantCardGrantFields_DirectGfiGrant_Fragment | GrantCardGrantFields_IndirectGfiGrant_Fragment;

export type GrantCardTokenFieldsFragment = { __typename?: 'CommunityRewardsToken', id: string, index: number, source: CommunityRewardsTokenSource, totalGranted: TheGraph_BigInt, totalClaimed: TheGraph_BigInt, grantedAt: TheGraph_BigInt, revokedAt: TheGraph_BigInt };

export type GfiPageQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GfiPageQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', gfiBalance?: CryptoAmount<"GFI"> | null, gfiGrants: Array<{ __typename: 'DirectGfiGrant', directSource: DirectGrantSource, isAccepted: boolean, id: string, index: number, reason: GrantReason, proof: Array<string>, amount: TheGraph_BigInt } | { __typename: 'IndirectGfiGrant', indirectSource: IndirectGrantSource, vestingLength: TheGraph_BigInt, vestingInterval: TheGraph_BigInt, cliffLength: TheGraph_BigInt, start: TheGraph_BigInt, end: TheGraph_BigInt, vested: TheGraph_BigInt, id: string, index: number, reason: GrantReason, proof: Array<string>, amount: TheGraph_BigInt }> }, communityRewardsTokens: Array<{ __typename?: 'CommunityRewardsToken', id: string, index: number, source: CommunityRewardsTokenSource, totalGranted: TheGraph_BigInt, totalClaimed: TheGraph_BigInt, grantedAt: TheGraph_BigInt, revokedAt: TheGraph_BigInt }>, poolTokens: Array<{ __typename?: 'PoolToken', id: string, mintedAt: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, rewardsClaimed: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, stakingRewardsClaimed: TheGraph_BigInt, principalAmount: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string, delinquency: LoanDelinquency, isPaused: boolean } | { __typename?: 'TranchedPool', id: string, name: string, delinquency: LoanDelinquency, isPaused: boolean } }>, vaultedPoolTokens: Array<{ __typename?: 'VaultedPoolToken', id: string, poolToken: { __typename?: 'PoolToken', id: string, mintedAt: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, rewardsClaimed: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, stakingRewardsClaimed: TheGraph_BigInt, principalAmount: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string, delinquency: LoanDelinquency, isPaused: boolean } | { __typename?: 'TranchedPool', id: string, name: string, delinquency: LoanDelinquency, isPaused: boolean } } }>, seniorPoolStakedPositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, initialAmount: TheGraph_BigInt, amount: TheGraph_BigInt, totalRewardsClaimed: TheGraph_BigInt, positionType: StakedPositionType, rewardEarnRate: TheGraph_BigInt, claimable: TheGraph_BigInt, granted: TheGraph_BigInt, startTime: TheGraph_BigInt, endTime: TheGraph_BigInt }>, vaultedStakedPositions: Array<{ __typename?: 'VaultedStakedPosition', id: string, seniorPoolStakedPosition: { __typename?: 'SeniorPoolStakedPosition', id: string, initialAmount: TheGraph_BigInt, amount: TheGraph_BigInt, totalRewardsClaimed: TheGraph_BigInt, positionType: StakedPositionType, rewardEarnRate: TheGraph_BigInt, claimable: TheGraph_BigInt, granted: TheGraph_BigInt, startTime: TheGraph_BigInt, endTime: TheGraph_BigInt } }> };

export type StakingCardPositionFieldsFragment = { __typename?: 'SeniorPoolStakedPosition', id: string, initialAmount: TheGraph_BigInt, amount: TheGraph_BigInt, totalRewardsClaimed: TheGraph_BigInt, positionType: StakedPositionType, rewardEarnRate: TheGraph_BigInt, claimable: TheGraph_BigInt, granted: TheGraph_BigInt, startTime: TheGraph_BigInt, endTime: TheGraph_BigInt };

export type AddToVaultPoolTokenFieldsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } };

export type StakedPositionFieldsForAssetsFragment = { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt };

export type PoolTokenFieldsForAssetsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } };

export type MembershipPageQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type MembershipPageQuery = { __typename?: 'Query', seniorPools: Array<{ __typename?: 'SeniorPool', id: string, sharePrice: TheGraph_BigInt }>, viewer: { __typename?: 'Viewer', gfiBalance?: CryptoAmount<"GFI"> | null, fiduBalance?: CryptoAmount<"FIDU"> | null, claimableMembershipRewards?: CryptoAmount<"FIDU"> | null, accruedMembershipRewardsThisEpoch?: CryptoAmount<"FIDU"> | null }, gfiPrice: { __typename?: 'GfiPrice', price: { __typename?: 'FiatAmount', amount: number, symbol: SupportedFiat } }, seniorPoolStakedPositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt }>, poolTokens: Array<{ __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } }>, ineligiblePoolTokens: Array<{ __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } }>, currentBlock: { __typename?: 'BlockInfo', timestamp: number }, vaultedGfis: Array<{ __typename?: 'VaultedGfi', id: string, amount: TheGraph_BigInt }>, vaultedStakedPositions: Array<{ __typename?: 'VaultedStakedPosition', id: string, usdcEquivalent: TheGraph_BigInt, seniorPoolStakedPosition: { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt } }>, vaultedPoolTokens: Array<{ __typename?: 'VaultedPoolToken', id: string, usdcEquivalent: TheGraph_BigInt, poolToken: { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } } }>, membershipRewardDisbursements: Array<{ __typename?: 'MembershipRewardDisbursement', id: string, allocatedAt: number, rewards: TheGraph_BigInt, epoch: TheGraph_BigInt }>, memberships: Array<{ __typename?: 'Membership', id: string, eligibleScore: TheGraph_BigInt, nextEpochScore: TheGraph_BigInt }>, membershipEpoches: Array<{ __typename?: 'MembershipEpoch', epoch: TheGraph_BigInt, totalRewards: TheGraph_BigInt }> };

export type VaultedGfiFieldsFragment = { __typename?: 'VaultedGfi', id: string, amount: TheGraph_BigInt };

export type VaultedStakedPositionFieldsFragment = { __typename?: 'VaultedStakedPosition', id: string, usdcEquivalent: TheGraph_BigInt, seniorPoolStakedPosition: { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt } };

export type VaultedPoolTokenFieldsFragment = { __typename?: 'VaultedPoolToken', id: string, usdcEquivalent: TheGraph_BigInt, poolToken: { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, loan: { __typename?: 'CallableLoan', id: string, name: string } | { __typename?: 'TranchedPool', id: string, name: string } } };

export type ChartDisbursementFieldsFragment = { __typename?: 'MembershipRewardDisbursement', id: string, allocatedAt: number, rewards: TheGraph_BigInt, epoch: TheGraph_BigInt };

type AmountStatsFields_CallableLoan_Fragment = { __typename?: 'CallableLoan', principalAmount: TheGraph_BigInt, initialInterestOwed: TheGraph_BigInt, id: string, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, delinquency: LoanDelinquency };

type AmountStatsFields_TranchedPool_Fragment = { __typename?: 'TranchedPool', principalAmount: TheGraph_BigInt, initialInterestOwed: TheGraph_BigInt, id: string, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, delinquency: LoanDelinquency };

export type AmountStatsFieldsFragment = AmountStatsFields_CallableLoan_Fragment | AmountStatsFields_TranchedPool_Fragment;

export type BorrowerAllPoolFieldsFragment = { __typename?: 'TranchedPool', id: string, name: string, principalAmount: TheGraph_BigInt, termEndTime: TheGraph_BigInt, balance: TheGraph_BigInt, delinquency: LoanDelinquency };

export type BorrowerProfileFieldsFragment = { __typename?: 'Borrower', id?: string | null, name: string, orgType?: string | null, bio?: any | null, website?: string | null, twitter?: string | null, linkedin?: string | null, logo?: { __typename?: 'Media', url?: string | null } | null };

export type CallPanelPoolTokenFieldsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemable: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, calledAt?: number | null, callDueAt?: number | null, isCapitalCalled: boolean, interestRedeemable: TheGraph_BigInt };

export type CallPanelCallableLoanFieldsFragment = { __typename?: 'CallableLoan', id: string, address: string, loanPhase: LoanPhase, inLockupPeriod: boolean, nextPrincipalDueTime: number, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, delinquency: LoanDelinquency };

export type SubmitCallModalPoolTokenFieldsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemable: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt };

export type ClaimPanelPoolTokenFieldsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemable: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, rewardsClaimed: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, stakingRewardsClaimed: TheGraph_BigInt, calledAt?: number | null, callDueAt?: number | null, isCapitalCalled: boolean, loan: { __typename?: 'CallableLoan', id: string } | { __typename?: 'TranchedPool', id: string } };

export type ClaimPanelVaultedPoolTokenFieldsFragment = { __typename?: 'VaultedPoolToken', id: string, poolToken: { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemable: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, rewardsClaimed: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, stakingRewardsClaimed: TheGraph_BigInt, calledAt?: number | null, callDueAt?: number | null, isCapitalCalled: boolean, loan: { __typename?: 'CallableLoan', id: string } | { __typename?: 'TranchedPool', id: string } } };

type ClaimPanelLoanFields_CallableLoan_Fragment = { __typename: 'CallableLoan', loanPhase: LoanPhase, id: string, allowedUidTypes: Array<UidType>, delinquency: LoanDelinquency, termStartTime: TheGraph_BigInt, address: string, inLockupPeriod: boolean, nextPrincipalDueTime: number, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt };

type ClaimPanelLoanFields_TranchedPool_Fragment = { __typename: 'TranchedPool', id: string, allowedUidTypes: Array<UidType>, delinquency: LoanDelinquency, termStartTime: TheGraph_BigInt };

export type ClaimPanelLoanFieldsFragment = ClaimPanelLoanFields_CallableLoan_Fragment | ClaimPanelLoanFields_TranchedPool_Fragment;

export type CreditMemoFieldsFragment = { __typename?: 'Deal_CreditMemos', id?: string | null, name?: string | null, subtitle?: string | null, content?: string | null, date?: any | null, fullMemoUrl?: string | null, executiveSummaryUrl?: string | null, thumbnail?: { __typename?: 'Media', url?: string | null, alt?: string | null, sizes?: { __typename?: 'Media_Sizes', thumbnail?: { __typename?: 'Media_Sizes_Thumbnail', url?: string | null } | null } | null } | null };

export type DealHighlightFieldsFragment = { __typename?: 'Deal_Highlights', heading?: string | null, body?: any | null };

type FundingStatsLoanFields_CallableLoan_Fragment = { __typename: 'CallableLoan', totalDeposited: TheGraph_BigInt, fundableAt: number, fundingLimit: TheGraph_BigInt };

type FundingStatsLoanFields_TranchedPool_Fragment = { __typename: 'TranchedPool', juniorDeposited: TheGraph_BigInt, estimatedLeverageRatio?: TheGraph_BigDecimal | null, totalDeposited: TheGraph_BigInt, fundableAt: number, fundingLimit: TheGraph_BigInt };

export type FundingStatsLoanFieldsFragment = FundingStatsLoanFields_CallableLoan_Fragment | FundingStatsLoanFields_TranchedPool_Fragment;

export type FundingStatsDealFieldsFragment = { __typename?: 'Deal', dealType?: Deal_DealType | null };

export type SingleTranchedPoolDataQueryVariables = Exact<{
  tranchedPoolId: Scalars['ID'];
  tranchedPoolAddress: Scalars['String'];
  userId: Scalars['ID'];
  borrowerAllPools?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isStratosPool: Scalars['Boolean'];
  isLendEastPool: Scalars['Boolean'];
}>;


export type SingleTranchedPoolDataQuery = { __typename?: 'Query', loan?: { __typename: 'CallableLoan', id: string, allowedUidTypes: Array<UidType>, usdcApy: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, fundableAt: number, address: string, interestRate: TheGraph_BigDecimal, termInSeconds: number, remainingCapacity: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, totalDeposited: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, loanPhase: LoanPhase, delinquency: LoanDelinquency, termStartTime: TheGraph_BigInt, numRepayments: number, repaymentFrequency: RepaymentFrequency, principalAmount: TheGraph_BigInt, initialInterestOwed: TheGraph_BigInt, inLockupPeriod: boolean, nextPrincipalDueTime: number, loanRepaymentSchedule: Array<{ __typename?: 'ScheduledRepayment', paymentPeriod: number, estimatedPaymentDate: number, interest: TheGraph_BigInt, principal: TheGraph_BigInt }> } | { __typename: 'TranchedPool', id: string, allowedUidTypes: Array<UidType>, usdcApy: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, fundableAt: number, address: string, interestRate: TheGraph_BigDecimal, termInSeconds: number, remainingCapacity: TheGraph_BigInt, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, juniorDeposited: TheGraph_BigInt, estimatedLeverageRatio?: TheGraph_BigDecimal | null, totalDeposited: TheGraph_BigInt, fundingLimit: TheGraph_BigInt, delinquency: LoanDelinquency, termStartTime: TheGraph_BigInt, numRepayments: number, repaymentFrequency: RepaymentFrequency, principalAmount: TheGraph_BigInt, initialInterestOwed: TheGraph_BigInt, loanRepaymentSchedule: Array<{ __typename?: 'ScheduledRepayment', paymentPeriod: number, estimatedPaymentDate: number, interest: TheGraph_BigInt, principal: TheGraph_BigInt }> } | null, borrowerAllPools: Array<{ __typename?: 'TranchedPool', id: string, name: string, principalAmount: TheGraph_BigInt, termEndTime: TheGraph_BigInt, balance: TheGraph_BigInt, delinquency: LoanDelinquency }>, seniorPools: Array<{ __typename?: 'SeniorPool', id: string, estimatedApyFromGfiRaw: TheGraph_BigDecimal }>, gfiPrice: { __typename?: 'GfiPrice', price: { __typename?: 'FiatAmount', amount: number, symbol: SupportedFiat } }, user?: { __typename?: 'User', id: string, uidType?: UidType | null, claimableFromStratosBackstop?: CryptoAmount<"USDC">, claimableFromLendEastBackstop?: CryptoAmount<"USDC">, isGoListed: boolean, nonce?: UidType | null, poolTokens: Array<{ __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemable: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, rewardsClaimed: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, stakingRewardsClaimed: TheGraph_BigInt, calledAt?: number | null, callDueAt?: number | null, isCapitalCalled: boolean, loan: { __typename?: 'CallableLoan', id: string } | { __typename?: 'TranchedPool', id: string } }>, vaultedPoolTokens: Array<{ __typename?: 'VaultedPoolToken', id: string, poolToken: { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt, principalRedeemable: TheGraph_BigInt, principalRedeemed: TheGraph_BigInt, interestRedeemable: TheGraph_BigInt, rewardsClaimable: TheGraph_BigInt, rewardsClaimed: TheGraph_BigInt, stakingRewardsClaimable: TheGraph_BigInt, stakingRewardsClaimed: TheGraph_BigInt, calledAt?: number | null, callDueAt?: number | null, isCapitalCalled: boolean, loan: { __typename?: 'CallableLoan', id: string } | { __typename?: 'TranchedPool', id: string } } }> } | null, currentBlock: { __typename?: 'BlockInfo', timestamp: number } };

export type SingleDealQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SingleDealQuery = { __typename?: 'Query', Deal?: { __typename?: 'Deal', id: string, name: string, dealType?: Deal_DealType | null, category: string, overview: any, details?: any | null, agreement?: string | null, dataroom?: string | null, defaultInterestRate?: number | null, dueDiligenceContact?: string | null, onChainCapitalPriority?: Deal_OnChainCapitalPriority | null, offChainCapitalPriority?: Deal_OffChainCapitalPriority | null, collateralAssets?: any | null, borrower: { __typename?: 'Borrower', id?: string | null, name: string, orgType?: string | null, bio?: any | null, website?: string | null, twitter?: string | null, linkedin?: string | null, deals?: Array<{ __typename?: 'Deal', id: string }> | null, logo?: { __typename?: 'Media', url?: string | null } | null }, highlights?: Array<{ __typename?: 'Deal_Highlights', heading?: string | null, body?: any | null }> | null, transactionStructure?: { __typename?: 'Media', filename?: string | null, fileNameOverride?: string | null, alt?: string | null, url?: string | null, mimeType?: string | null } | null, creditMemos?: Array<{ __typename?: 'Deal_CreditMemos', id?: string | null, name?: string | null, subtitle?: string | null, content?: string | null, date?: any | null, fullMemoUrl?: string | null, executiveSummaryUrl?: string | null, thumbnail?: { __typename?: 'Media', url?: string | null, alt?: string | null, sizes?: { __typename?: 'Media_Sizes', thumbnail?: { __typename?: 'Media_Sizes_Thumbnail', url?: string | null } | null } | null } | null }> | null, securitiesAndRecourse?: { __typename?: 'Deal_SecuritiesAndRecourse', value?: number | null, secured?: Deal_SecuritiesAndRecourse_Secured | null, type?: string | null, description?: any | null, recourse?: Deal_SecuritiesAndRecourse_Recourse | null, recourseDescription?: any | null } | null } | null };

type SupplyPanelLoanFields_CallableLoan_Fragment = { __typename: 'CallableLoan', id: string, address: string, usdcApy: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, totalDeposited: TheGraph_BigInt, allowedUidTypes: Array<UidType>, fundingLimit: TheGraph_BigInt };

type SupplyPanelLoanFields_TranchedPool_Fragment = { __typename: 'TranchedPool', juniorDeposited: TheGraph_BigInt, estimatedLeverageRatio?: TheGraph_BigDecimal | null, id: string, address: string, usdcApy: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, totalDeposited: TheGraph_BigInt, allowedUidTypes: Array<UidType>, fundingLimit: TheGraph_BigInt };

export type SupplyPanelLoanFieldsFragment = SupplyPanelLoanFields_CallableLoan_Fragment | SupplyPanelLoanFields_TranchedPool_Fragment;

export type SupplyPanelUserFieldsFragment = { __typename?: 'User', id: string, uidType?: UidType | null, isGoListed: boolean };

export type SupplyPanelDealFieldsFragment = { __typename?: 'Deal', id: string, name: string, agreement?: string | null, dealType?: Deal_DealType | null };

export type WithdrawalPanelPoolTokenFieldsFragment = { __typename?: 'PoolToken', id: string, principalAmount: TheGraph_BigInt };

type WithdrawalPanelLoanFields_CallableLoan_Fragment = { __typename: 'CallableLoan', id: string, address: string };

type WithdrawalPanelLoanFields_TranchedPool_Fragment = { __typename: 'TranchedPool', id: string, address: string };

export type WithdrawalPanelLoanFieldsFragment = WithdrawalPanelLoanFields_CallableLoan_Fragment | WithdrawalPanelLoanFields_TranchedPool_Fragment;

type LoanSummaryFields_CallableLoan_Fragment = { __typename: 'CallableLoan', id: string, address: string, usdcApy: TheGraph_BigDecimal, interestRate: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, termInSeconds: number };

type LoanSummaryFields_TranchedPool_Fragment = { __typename: 'TranchedPool', id: string, address: string, usdcApy: TheGraph_BigDecimal, interestRate: TheGraph_BigDecimal, rawGfiApy: TheGraph_BigDecimal, termInSeconds: number };

export type LoanSummaryFieldsFragment = LoanSummaryFields_CallableLoan_Fragment | LoanSummaryFields_TranchedPool_Fragment;

export type LoanSummaryBorrowerFieldsFragment = { __typename?: 'Borrower', id?: string | null, name: string, logo?: { __typename?: 'Media', url?: string | null } | null };

export type LoanSummaryDealFieldsFragment = { __typename?: 'Deal', id: string, name: string, overview: any, dealType?: Deal_DealType | null };

type RepaymentTableLoanFields_CallableLoan_Fragment = { __typename?: 'CallableLoan', loanRepaymentSchedule: Array<{ __typename?: 'ScheduledRepayment', paymentPeriod: number, estimatedPaymentDate: number, interest: TheGraph_BigInt, principal: TheGraph_BigInt }> };

type RepaymentTableLoanFields_TranchedPool_Fragment = { __typename?: 'TranchedPool', loanRepaymentSchedule: Array<{ __typename?: 'ScheduledRepayment', paymentPeriod: number, estimatedPaymentDate: number, interest: TheGraph_BigInt, principal: TheGraph_BigInt }> };

export type RepaymentTableLoanFieldsFragment = RepaymentTableLoanFields_CallableLoan_Fragment | RepaymentTableLoanFields_TranchedPool_Fragment;

type RepaymentTermsStatsFields_CallableLoan_Fragment = { __typename: 'CallableLoan', fundableAt: number, termInSeconds: number, termStartTime: TheGraph_BigInt, termEndTime: TheGraph_BigInt, numRepayments: number, repaymentFrequency: RepaymentFrequency };

type RepaymentTermsStatsFields_TranchedPool_Fragment = { __typename: 'TranchedPool', fundableAt: number, termInSeconds: number, termStartTime: TheGraph_BigInt, termEndTime: TheGraph_BigInt, numRepayments: number, repaymentFrequency: RepaymentFrequency };

export type RepaymentTermsStatsFieldsFragment = RepaymentTermsStatsFields_CallableLoan_Fragment | RepaymentTermsStatsFields_TranchedPool_Fragment;

export type RiskTableDealFieldsFragment = { __typename?: 'Deal', dealType?: Deal_DealType | null, agreement?: string | null, dataroom?: string | null, dueDiligenceContact?: string | null, onChainCapitalPriority?: Deal_OnChainCapitalPriority | null, offChainCapitalPriority?: Deal_OffChainCapitalPriority | null, collateralAssets?: any | null, securitiesAndRecourse?: { __typename?: 'Deal_SecuritiesAndRecourse', value?: number | null, secured?: Deal_SecuritiesAndRecourse_Secured | null, type?: string | null, description?: any | null, recourse?: Deal_SecuritiesAndRecourse_Recourse | null, recourseDescription?: any | null } | null };

type RiskTableLoanFields_CallableLoan_Fragment = { __typename: 'CallableLoan' };

type RiskTableLoanFields_TranchedPool_Fragment = { __typename: 'TranchedPool', estimatedLeverageRatio?: TheGraph_BigDecimal | null };

export type RiskTableLoanFieldsFragment = RiskTableLoanFields_CallableLoan_Fragment | RiskTableLoanFields_TranchedPool_Fragment;

export type TranchedPoolTransactionTableQueryVariables = Exact<{
  loanId: Scalars['ID'];
  loanAddress: Scalars['String'];
  first: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type TranchedPoolTransactionTableQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'Transaction', id: string, transactionHash: string, category: TransactionCategory, sentAmount?: TheGraph_BigInt | null, sentToken?: SupportedCrypto | null, receivedAmount?: TheGraph_BigInt | null, receivedToken?: SupportedCrypto | null, timestamp: number, user: { __typename?: 'User', id: string, ENSName?: string | null, ENSAvatar?: string | null } }>, loan?: { __typename?: 'CallableLoan', id: string, borrowerName: string, borrowerLogo?: string | null } | { __typename?: 'TranchedPool', id: string, borrowerName: string, borrowerLogo?: string | null } | null };

export type CapitalStatsFieldsFragment = { __typename?: 'SeniorPool', assets: TheGraph_BigInt, totalLoansOutstanding: TheGraph_BigInt, defaultRate: TheGraph_BigDecimal, nextRepayingPool: Array<{ __typename?: 'TranchedPool', id: string, nextDueTime: TheGraph_BigInt }> };

export type SeniorPoolPageQueryVariables = Exact<{
  userId: Scalars['ID'];
  user: Scalars['String'];
}>;


export type SeniorPoolPageQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, uidType?: UidType | null, isGoListed: boolean } | null, seniorPoolStakedPositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt }>, vaultedStakedPositions: Array<{ __typename?: 'VaultedStakedPosition', id: string, seniorPoolStakedPosition: { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt } }>, seniorPools: Array<{ __typename?: 'SeniorPool', id: string, address: string, sharePrice: TheGraph_BigInt, withdrawalCancellationFee: TheGraph_BigDecimal, epochEndsAt: number, name: string, category: string, icon: string, defaultRate: TheGraph_BigDecimal, totalLoansOutstanding: TheGraph_BigInt, assets: TheGraph_BigInt, estimatedApyFromGfiRaw: TheGraph_BigDecimal, estimatedApy: TheGraph_BigDecimal, poolsOrderedBySpInvestment: Array<{ __typename?: 'TranchedPool', id: string, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, actualSeniorPoolInvestment?: TheGraph_BigInt | null, delinquency: LoanDelinquency }>, nextRepayingPool: Array<{ __typename?: 'TranchedPool', id: string, nextDueTime: TheGraph_BigInt }>, repayingPools: Array<{ __typename?: 'TranchedPool', id: string, name: string, borrowerLogo?: string | null, repaymentSchedule: Array<{ __typename?: 'ScheduledRepayment', id: string, paymentPeriod: number, estimatedPaymentDate: number, interest: TheGraph_BigInt, principal: TheGraph_BigInt }> }> }>, gfiPrice: { __typename?: 'GfiPrice', price: { __typename?: 'FiatAmount', amount: number, symbol: SupportedFiat } }, viewer: { __typename?: 'Viewer', fiduBalance?: CryptoAmount<"FIDU"> | null }, seniorPoolWithdrawalRequests: Array<{ __typename?: 'SeniorPoolWithdrawalRequest', id: string, previewUsdcWithdrawable: TheGraph_BigInt, previewFiduRequested: TheGraph_BigInt, tokenId: TheGraph_BigInt, requestedAt: number, increasedAt?: number | null }> };

export type SeniorPoolPageCmsQueryVariables = Exact<{ [key: string]: never; }>;


export type SeniorPoolPageCmsQuery = { __typename?: 'Query', Deals?: { __typename?: 'Deals', docs?: Array<{ __typename?: 'Deal', id: string, name: string, category: string, dealType?: Deal_DealType | null, borrower: { __typename?: 'Borrower', id?: string | null, name: string, logo?: { __typename?: 'Media', url?: string | null } | null } } | null> | null } | null };

export type InvestAndWithdrawSeniorPoolFieldsFragment = { __typename?: 'SeniorPool', sharePrice: TheGraph_BigInt, address: string, estimatedApyFromGfiRaw: TheGraph_BigDecimal, epochEndsAt: number, withdrawalCancellationFee: TheGraph_BigDecimal };

export type SeniorPoolSupplyPanelPoolFieldsFragment = { __typename?: 'SeniorPool', address: string, estimatedApyFromGfiRaw: TheGraph_BigDecimal };

export type SeniorPoolWithdrawalPanelFieldsFragment = { __typename?: 'SeniorPool', sharePrice: TheGraph_BigInt, epochEndsAt: number, withdrawalCancellationFee: TheGraph_BigDecimal };

export type SeniorPoolWithdrawalPanelPositionFieldsFragment = { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt };

export type SeniorPoolWithdrawalPanelWithdrawalRequestFieldsFragment = { __typename?: 'SeniorPoolWithdrawalRequest', id: string, previewUsdcWithdrawable: TheGraph_BigInt, previewFiduRequested: TheGraph_BigInt, tokenId: TheGraph_BigInt, requestedAt: number, increasedAt?: number | null };

export type WithdrawalCancelModalWithdrawalFieldsFragment = { __typename?: 'SeniorPoolWithdrawalRequest', id: string, tokenId: TheGraph_BigInt, previewFiduRequested: TheGraph_BigInt };

export type WithdrawalHistory2QueryVariables = Exact<{
  user: Scalars['String'];
}>;


export type WithdrawalHistory2Query = { __typename?: 'Query', transactions: Array<{ __typename?: 'Transaction', id: string, timestamp: number, category: TransactionCategory, sentAmount?: TheGraph_BigInt | null, sentToken?: SupportedCrypto | null, receivedAmount?: TheGraph_BigInt | null, receivedToken?: SupportedCrypto | null }>, seniorPoolWithdrawalDisbursements: Array<{ __typename?: 'SeniorPoolWithdrawalDisbursement', id: string, allocatedAt: number, fiduLiquidated: TheGraph_BigInt }>, seniorPoolWithdrawalDisbursementPostponements: Array<{ __typename?: 'SeniorPoolWithdrawalDisbursementPostponement', id: string, oldEndsAt: number, newEndsAt: number }> };

export type WithdrawalRequestModalWithdrawalFieldsFragment = { __typename?: 'SeniorPoolWithdrawalRequest', id: string, tokenId: TheGraph_BigInt, previewFiduRequested: TheGraph_BigInt, requestedAt: number, increasedAt?: number | null };

export type SeniorPoolPortfolioDistributionFieldsFragment = { __typename?: 'SeniorPool', poolsOrderedBySpInvestment: Array<{ __typename?: 'TranchedPool', actualSeniorPoolInvestment?: TheGraph_BigInt | null, id: string, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, delinquency: LoanDelinquency }> };

export type SeniorPoolPortfolioPoolsDealsFieldsFragment = { __typename?: 'Deal', id: string, name: string, category: string, dealType?: Deal_DealType | null, borrower: { __typename?: 'Borrower', id?: string | null, name: string, logo?: { __typename?: 'Media', url?: string | null } | null } };

export type SeniorPoolPortfolioDetailsFieldsFragment = { __typename?: 'SeniorPool', name: string, category: string, icon: string, defaultRate: TheGraph_BigDecimal, totalLoansOutstanding: TheGraph_BigInt, poolsOrderedBySpInvestment: Array<{ __typename?: 'TranchedPool', id: string, balance: TheGraph_BigInt, termEndTime: TheGraph_BigInt, actualSeniorPoolInvestment?: TheGraph_BigInt | null, delinquency: LoanDelinquency }> };

export type SeniorPoolLoanSummaryFieldsFragment = { __typename?: 'SeniorPool', address: string, estimatedApy: TheGraph_BigDecimal, estimatedApyFromGfiRaw: TheGraph_BigDecimal };

export type SeniorPoolRepaymentFieldsFragment = { __typename?: 'SeniorPool', repayingPools: Array<{ __typename?: 'TranchedPool', id: string, name: string, borrowerLogo?: string | null, repaymentSchedule: Array<{ __typename?: 'ScheduledRepayment', id: string, paymentPeriod: number, estimatedPaymentDate: number, interest: TheGraph_BigInt, principal: TheGraph_BigInt }> }> };

export type BorrowerTransactionsQueryVariables = Exact<{
  first: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type BorrowerTransactionsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'Transaction', id: string, transactionHash: string, timestamp: number, category: TransactionCategory, sentAmount?: TheGraph_BigInt | null, sentToken?: SupportedCrypto | null, receivedAmount?: TheGraph_BigInt | null, receivedToken?: SupportedCrypto | null, user: { __typename?: 'User', id: string, ENSName?: string | null, ENSAvatar?: string | null }, loan?: { __typename?: 'CallableLoan', id: string, name: string, borrowerName: string, borrowerLogo?: string | null } | { __typename?: 'TranchedPool', id: string, name: string, borrowerName: string, borrowerLogo?: string | null } | null }> };

export type StakePageQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type StakePageQuery = { __typename?: 'Query', stakedFiduPositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt, positionType: StakedPositionType, endTime: TheGraph_BigInt }>, stakedCurvePositions: Array<{ __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt, positionType: StakedPositionType, endTime: TheGraph_BigInt }>, vaultedStakedPositions: Array<{ __typename?: 'VaultedStakedPosition', id: string, seniorPoolStakedPosition: { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt } }>, seniorPools: Array<{ __typename?: 'SeniorPool', id: string, estimatedApy: TheGraph_BigDecimal, estimatedApyFromGfiRaw: TheGraph_BigDecimal, sharePrice: TheGraph_BigInt }>, gfiPrice: { __typename?: 'GfiPrice', lastUpdated: number, price: { __typename?: 'FiatAmount', amount: number, symbol: SupportedFiat } }, viewer: { __typename?: 'Viewer', usdcBalance?: CryptoAmount<"USDC"> | null, fiduBalance?: CryptoAmount<"FIDU"> | null, curveLpBalance?: CryptoAmount<"CURVE_LP"> | null }, curvePool: { __typename?: 'CurvePool', estimatedCurveStakingApyRaw: TheGraph_BigDecimal } };

export type MigrateFormPositionFieldsFragment = { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt, endTime: TheGraph_BigInt };

export type UnstakeFormPositionFieldsFragment = { __typename?: 'SeniorPoolStakedPosition', id: string, amount: TheGraph_BigInt, positionType: StakedPositionType, endTime: TheGraph_BigInt };

export const HighlightGridFieldsFragmentDoc = gql`
    fragment HighlightGridFields on Deal_Highlights {
  heading
  body
}
    `;
export const FundingStatusLoanFieldsFragmentDoc = gql`
    fragment FundingStatusLoanFields on Loan {
  id
  remainingCapacity
  fundableAt
  balance
  termEndTime
}
    `;
export const UserEligibilityFieldsFragmentDoc = gql`
    fragment UserEligibilityFields on User {
  id
  uidType
  isGoListed
}
    `;
export const CallableLoanCallPoolTokensFieldsFragmentDoc = gql`
    fragment CallableLoanCallPoolTokensFields on PoolToken {
  id
  principalAmount
  callDueAt
}
    `;
export const LoanBorrowCardFieldsFragmentDoc = gql`
    fragment LoanBorrowCardFields on Deal {
  id
  name
  category
}
    `;
export const TranchedPoolBorrowerAccountingFieldsFragmentDoc = gql`
    fragment TranchedPoolBorrowerAccountingFields on TranchedPool {
  id
  nextDueTime
  interestAccruedAsOf
  interestOwed @client
  collectedPaymentBalance @client
  interestAccruedAsOf
  fundingLimit
  principalAmount
  drawdownsPaused
  creditLine {
    id
  }
  juniorTranches {
    id
    principalSharePrice
    principalDeposited
    lockedUntil
  }
  seniorTranches {
    id
    principalSharePrice
    principalDeposited
  }
}
    `;
export const CallableLoanBorrowerAccountingFieldsFragmentDoc = gql`
    fragment CallableLoanBorrowerAccountingFields on CallableLoan {
  id
  totalDeposited
  availableForDrawdown
  lastFullPaymentTime
  principalAmountRepaid
  delinquency @client
  periodInterestDueAmount @client
  periodPrincipalDueAmount @client
  termTotalDueAmount @client
  nextDueTime @client
  loanPhase @client
}
    `;
export const LoanBorrowerAccountingFieldsFragmentDoc = gql`
    fragment LoanBorrowerAccountingFields on Loan {
  __typename
  isPaused
  drawdownsPaused
  termInSeconds
  interestRate
  interestRateBigInt
  balance
  termEndTime
  principalAmount
  fundingLimit
  creditLineAddress
  repaymentFrequency
  delinquency @client
  isAfterTermEndTime @client
  ...TranchedPoolBorrowerAccountingFields
  ...CallableLoanBorrowerAccountingFields
  borrowerContract {
    id
  }
}
    ${TranchedPoolBorrowerAccountingFieldsFragmentDoc}
${CallableLoanBorrowerAccountingFieldsFragmentDoc}`;
export const DashboardStakedPositionFieldsFragmentDoc = gql`
    fragment DashboardStakedPositionFields on SeniorPoolStakedPosition {
  id
  amount
}
    `;
export const DashboardPoolTokenFieldsFragmentDoc = gql`
    fragment DashboardPoolTokenFields on PoolToken {
  id
  principalAmount
  principalRedeemed
  interestRedeemable
  rewardsClaimable
  stakingRewardsClaimable
  loan {
    id
    name @client
  }
}
    `;
export const ProtocolMetricsFieldsFragmentDoc = gql`
    fragment ProtocolMetricsFields on Protocol {
  id
  totalDrawdowns
  totalWritedowns
  defaultRate
  totalReserveCollected
  totalInterestCollected
  totalPrincipalCollected
}
    `;
export const BackerCardTokenFieldsFragmentDoc = gql`
    fragment BackerCardTokenFields on PoolToken {
  id
  loan {
    id
    name @client
    delinquency @client
    isPaused
  }
  mintedAt
  rewardsClaimable
  rewardsClaimed
  stakingRewardsClaimable
  stakingRewardsClaimed
  principalAmount
}
    `;
export const GrantCardGrantFieldsFragmentDoc = gql`
    fragment GrantCardGrantFields on GfiGrant {
  __typename
  id
  index
  reason
  proof
  amount
  ... on IndirectGfiGrant {
    indirectSource
    vestingLength
    vestingInterval
    cliffLength
    start
    end
    vested
  }
  ... on DirectGfiGrant {
    directSource
    isAccepted
  }
}
    `;
export const GrantCardTokenFieldsFragmentDoc = gql`
    fragment GrantCardTokenFields on CommunityRewardsToken {
  id
  index
  source
  totalGranted
  totalClaimed
  grantedAt
  revokedAt
}
    `;
export const StakingCardPositionFieldsFragmentDoc = gql`
    fragment StakingCardPositionFields on SeniorPoolStakedPosition {
  id
  initialAmount
  amount
  totalRewardsClaimed
  positionType
  rewardEarnRate @client
  claimable @client
  granted @client
  startTime
  endTime @client
}
    `;
export const AddToVaultPoolTokenFieldsFragmentDoc = gql`
    fragment AddToVaultPoolTokenFields on PoolToken {
  id
  principalAmount
  loan {
    id
    name @client
  }
}
    `;
export const VaultedGfiFieldsFragmentDoc = gql`
    fragment VaultedGfiFields on VaultedGfi {
  id
  amount
}
    `;
export const StakedPositionFieldsForAssetsFragmentDoc = gql`
    fragment StakedPositionFieldsForAssets on SeniorPoolStakedPosition {
  id
  amount
}
    `;
export const VaultedStakedPositionFieldsFragmentDoc = gql`
    fragment VaultedStakedPositionFields on VaultedStakedPosition {
  id
  usdcEquivalent
  seniorPoolStakedPosition {
    ...StakedPositionFieldsForAssets
  }
}
    ${StakedPositionFieldsForAssetsFragmentDoc}`;
export const PoolTokenFieldsForAssetsFragmentDoc = gql`
    fragment PoolTokenFieldsForAssets on PoolToken {
  id
  principalAmount
  principalRedeemed
  loan {
    id
    name @client
  }
}
    `;
export const VaultedPoolTokenFieldsFragmentDoc = gql`
    fragment VaultedPoolTokenFields on VaultedPoolToken {
  id
  usdcEquivalent
  poolToken {
    ...PoolTokenFieldsForAssets
  }
}
    ${PoolTokenFieldsForAssetsFragmentDoc}`;
export const ChartDisbursementFieldsFragmentDoc = gql`
    fragment ChartDisbursementFields on MembershipRewardDisbursement {
  id
  allocatedAt
  rewards
  epoch
}
    `;
export const RepaymentStatusLoanFieldsFragmentDoc = gql`
    fragment RepaymentStatusLoanFields on Loan {
  id
  balance
  termEndTime
  delinquency @client
}
    `;
export const AmountStatsFieldsFragmentDoc = gql`
    fragment AmountStatsFields on Loan {
  principalAmount
  initialInterestOwed
  ...RepaymentStatusLoanFields
}
    ${RepaymentStatusLoanFieldsFragmentDoc}`;
export const BorrowerAllPoolFieldsFragmentDoc = gql`
    fragment BorrowerAllPoolFields on TranchedPool {
  id
  name @client
  principalAmount
  termEndTime
  ...RepaymentStatusLoanFields
}
    ${RepaymentStatusLoanFieldsFragmentDoc}`;
export const BorrowerProfileFieldsFragmentDoc = gql`
    fragment BorrowerProfileFields on Borrower {
  id
  name
  logo {
    url
  }
  orgType
  bio
  website
  twitter
  linkedin
}
    `;
export const SubmitCallModalPoolTokenFieldsFragmentDoc = gql`
    fragment SubmitCallModalPoolTokenFields on PoolToken {
  id
  principalAmount
  principalRedeemable @client
  interestRedeemable
}
    `;
export const CallPanelPoolTokenFieldsFragmentDoc = gql`
    fragment CallPanelPoolTokenFields on PoolToken {
  id
  principalAmount
  principalRedeemable @client
  principalRedeemed
  calledAt
  callDueAt
  isCapitalCalled
  ...SubmitCallModalPoolTokenFields
}
    ${SubmitCallModalPoolTokenFieldsFragmentDoc}`;
export const ClaimPanelPoolTokenFieldsFragmentDoc = gql`
    fragment ClaimPanelPoolTokenFields on PoolToken {
  id
  principalAmount
  principalRedeemable @client
  principalRedeemed
  interestRedeemable
  rewardsClaimable
  rewardsClaimed
  stakingRewardsClaimable
  stakingRewardsClaimed
  loan {
    id
  }
  ...CallPanelPoolTokenFields
}
    ${CallPanelPoolTokenFieldsFragmentDoc}`;
export const ClaimPanelVaultedPoolTokenFieldsFragmentDoc = gql`
    fragment ClaimPanelVaultedPoolTokenFields on VaultedPoolToken {
  id
  poolToken {
    ...ClaimPanelPoolTokenFields
  }
}
    ${ClaimPanelPoolTokenFieldsFragmentDoc}`;
export const CallPanelCallableLoanFieldsFragmentDoc = gql`
    fragment CallPanelCallableLoanFields on CallableLoan {
  id
  address
  loanPhase @client
  inLockupPeriod @client
  nextPrincipalDueTime @client
  ...RepaymentStatusLoanFields
}
    ${RepaymentStatusLoanFieldsFragmentDoc}`;
export const ClaimPanelLoanFieldsFragmentDoc = gql`
    fragment ClaimPanelLoanFields on Loan {
  __typename
  id
  allowedUidTypes
  delinquency @client
  termStartTime
  ... on CallableLoan {
    ...CallPanelCallableLoanFields
    loanPhase @client
  }
}
    ${CallPanelCallableLoanFieldsFragmentDoc}`;
export const CreditMemoFieldsFragmentDoc = gql`
    fragment CreditMemoFields on Deal_CreditMemos {
  id
  thumbnail {
    url
    alt
    sizes {
      thumbnail {
        url
      }
    }
  }
  name
  subtitle
  content
  date
  fullMemoUrl
  executiveSummaryUrl
}
    `;
export const DealHighlightFieldsFragmentDoc = gql`
    fragment DealHighlightFields on Deal_Highlights {
  heading
  body
}
    `;
export const FundingStatsLoanFieldsFragmentDoc = gql`
    fragment FundingStatsLoanFields on Loan {
  __typename
  ... on TranchedPool {
    juniorDeposited
    estimatedLeverageRatio
  }
  totalDeposited
  fundableAt
  fundingLimit
}
    `;
export const FundingStatsDealFieldsFragmentDoc = gql`
    fragment FundingStatsDealFields on Deal {
  dealType
}
    `;
export const SupplyPanelLoanFieldsFragmentDoc = gql`
    fragment SupplyPanelLoanFields on Loan {
  __typename
  id
  address
  usdcApy
  rawGfiApy
  ... on TranchedPool {
    juniorDeposited
    estimatedLeverageRatio
  }
  totalDeposited
  allowedUidTypes
  fundingLimit
}
    `;
export const SupplyPanelUserFieldsFragmentDoc = gql`
    fragment SupplyPanelUserFields on User {
  id
  uidType
  isGoListed
}
    `;
export const SupplyPanelDealFieldsFragmentDoc = gql`
    fragment SupplyPanelDealFields on Deal {
  id
  name
  agreement
  dealType
}
    `;
export const WithdrawalPanelPoolTokenFieldsFragmentDoc = gql`
    fragment WithdrawalPanelPoolTokenFields on PoolToken {
  id
  principalAmount
}
    `;
export const WithdrawalPanelLoanFieldsFragmentDoc = gql`
    fragment WithdrawalPanelLoanFields on Loan {
  id
  __typename
  address
}
    `;
export const LoanSummaryFieldsFragmentDoc = gql`
    fragment LoanSummaryFields on Loan {
  __typename
  id
  address
  usdcApy
  interestRate
  rawGfiApy
  termInSeconds
}
    `;
export const LoanSummaryBorrowerFieldsFragmentDoc = gql`
    fragment LoanSummaryBorrowerFields on Borrower {
  id
  name
  logo {
    url
  }
}
    `;
export const LoanSummaryDealFieldsFragmentDoc = gql`
    fragment LoanSummaryDealFields on Deal {
  id
  name
  overview
  dealType
}
    `;
export const RepaymentTableLoanFieldsFragmentDoc = gql`
    fragment RepaymentTableLoanFields on Loan {
  loanRepaymentSchedule: repaymentSchedule(orderBy: paymentPeriod, first: 1000) {
    paymentPeriod
    estimatedPaymentDate
    interest
    principal
  }
}
    `;
export const RepaymentTermsStatsFieldsFragmentDoc = gql`
    fragment RepaymentTermsStatsFields on Loan {
  __typename
  fundableAt
  termInSeconds
  termStartTime
  termEndTime
  numRepayments
  repaymentFrequency
}
    `;
export const RiskTableDealFieldsFragmentDoc = gql`
    fragment RiskTableDealFields on Deal {
  securitiesAndRecourse {
    value
    secured
    type
    description
    recourse
    recourseDescription
  }
  dealType
  agreement
  dataroom
  dueDiligenceContact
  onChainCapitalPriority
  offChainCapitalPriority
  collateralAssets
}
    `;
export const RiskTableLoanFieldsFragmentDoc = gql`
    fragment RiskTableLoanFields on Loan {
  __typename
  ... on TranchedPool {
    estimatedLeverageRatio
  }
}
    `;
export const CapitalStatsFieldsFragmentDoc = gql`
    fragment CapitalStatsFields on SeniorPool {
  assets
  totalLoansOutstanding
  defaultRate
  nextRepayingPool: tranchedPools(
    orderBy: nextDueTime
    orderDirection: asc
    first: 1
    where: {nextDueTime_not: 0}
  ) {
    id
    nextDueTime
  }
}
    `;
export const SeniorPoolSupplyPanelPoolFieldsFragmentDoc = gql`
    fragment SeniorPoolSupplyPanelPoolFields on SeniorPool {
  address
  estimatedApyFromGfiRaw
}
    `;
export const SeniorPoolWithdrawalPanelFieldsFragmentDoc = gql`
    fragment SeniorPoolWithdrawalPanelFields on SeniorPool {
  sharePrice
  epochEndsAt @client
  withdrawalCancellationFee
}
    `;
export const InvestAndWithdrawSeniorPoolFieldsFragmentDoc = gql`
    fragment InvestAndWithdrawSeniorPoolFields on SeniorPool {
  sharePrice
  ...SeniorPoolSupplyPanelPoolFields
  ...SeniorPoolWithdrawalPanelFields
}
    ${SeniorPoolSupplyPanelPoolFieldsFragmentDoc}
${SeniorPoolWithdrawalPanelFieldsFragmentDoc}`;
export const SeniorPoolWithdrawalPanelPositionFieldsFragmentDoc = gql`
    fragment SeniorPoolWithdrawalPanelPositionFields on SeniorPoolStakedPosition {
  id
  amount
}
    `;
export const WithdrawalCancelModalWithdrawalFieldsFragmentDoc = gql`
    fragment WithdrawalCancelModalWithdrawalFields on SeniorPoolWithdrawalRequest {
  id
  tokenId
  previewFiduRequested @client
}
    `;
export const WithdrawalRequestModalWithdrawalFieldsFragmentDoc = gql`
    fragment WithdrawalRequestModalWithdrawalFields on SeniorPoolWithdrawalRequest {
  id
  tokenId
  previewFiduRequested @client
  requestedAt
  increasedAt
}
    `;
export const SeniorPoolWithdrawalPanelWithdrawalRequestFieldsFragmentDoc = gql`
    fragment SeniorPoolWithdrawalPanelWithdrawalRequestFields on SeniorPoolWithdrawalRequest {
  id
  previewUsdcWithdrawable @client
  previewFiduRequested @client
  ...WithdrawalCancelModalWithdrawalFields
  ...WithdrawalRequestModalWithdrawalFields
}
    ${WithdrawalCancelModalWithdrawalFieldsFragmentDoc}
${WithdrawalRequestModalWithdrawalFieldsFragmentDoc}`;
export const SeniorPoolPortfolioDistributionFieldsFragmentDoc = gql`
    fragment SeniorPoolPortfolioDistributionFields on SeniorPool {
  poolsOrderedBySpInvestment: tranchedPools(
    orderBy: actualSeniorPoolInvestment
    orderDirection: desc
    where: {balance_gt: 0, termEndTime_gt: 0, actualSeniorPoolInvestment_gt: 0}
  ) {
    ...RepaymentStatusLoanFields
    actualSeniorPoolInvestment
  }
}
    ${RepaymentStatusLoanFieldsFragmentDoc}`;
export const SeniorPoolPortfolioPoolsDealsFieldsFragmentDoc = gql`
    fragment SeniorPoolPortfolioPoolsDealsFields on Deal {
  id
  name
  category
  dealType
  borrower {
    id
    name
    logo {
      url
    }
  }
}
    `;
export const SeniorPoolPortfolioDetailsFieldsFragmentDoc = gql`
    fragment SeniorPoolPortfolioDetailsFields on SeniorPool {
  name @client
  category @client
  icon @client
  defaultRate
  totalLoansOutstanding
  poolsOrderedBySpInvestment: tranchedPools(
    orderBy: actualSeniorPoolInvestment
    orderDirection: desc
    where: {balance_gt: 0, termEndTime_gt: 0, actualSeniorPoolInvestment_gt: 0}
  ) {
    id
    balance
    termEndTime
    actualSeniorPoolInvestment
    delinquency @client
  }
}
    `;
export const SeniorPoolLoanSummaryFieldsFragmentDoc = gql`
    fragment SeniorPoolLoanSummaryFields on SeniorPool {
  address
  estimatedApy
  estimatedApyFromGfiRaw
}
    `;
export const SeniorPoolRepaymentFieldsFragmentDoc = gql`
    fragment SeniorPoolRepaymentFields on SeniorPool {
  repayingPools: tranchedPools(
    orderBy: nextDueTime
    orderDirection: asc
    where: {nextDueTime_not: 0}
  ) {
    id
    name @client
    borrowerLogo @client
    repaymentSchedule(orderBy: paymentPeriod, first: 1000) {
      id
      paymentPeriod
      estimatedPaymentDate
      interest
      principal
    }
  }
}
    `;
export const MigrateFormPositionFieldsFragmentDoc = gql`
    fragment MigrateFormPositionFields on SeniorPoolStakedPosition {
  id
  amount
  endTime @client
}
    `;
export const UnstakeFormPositionFieldsFragmentDoc = gql`
    fragment UnstakeFormPositionFields on SeniorPoolStakedPosition {
  id
  amount
  positionType
  endTime @client
}
    `;
export const AccountStatusDocument = gql`
    query AccountStatus($userId: ID!) {
  user(id: $userId) {
    id
    uidType
    isGoListed
  }
}
    `;

/**
 * __useAccountStatusQuery__
 *
 * To run a query within a React component, call `useAccountStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAccountStatusQuery(baseOptions: Apollo.QueryHookOptions<AccountStatusQuery, AccountStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountStatusQuery, AccountStatusQueryVariables>(AccountStatusDocument, options);
      }
export function useAccountStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountStatusQuery, AccountStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountStatusQuery, AccountStatusQueryVariables>(AccountStatusDocument, options);
        }
export type AccountStatusQueryHookResult = ReturnType<typeof useAccountStatusQuery>;
export type AccountStatusLazyQueryHookResult = ReturnType<typeof useAccountStatusLazyQuery>;
export type AccountStatusQueryResult = Apollo.QueryResult<AccountStatusQuery, AccountStatusQueryVariables>;
export const CurrentUserWalletInfoDocument = gql`
    query CurrentUserWalletInfo {
  gfiPrice(fiat: USD) @client {
    price {
      amount
      symbol
    }
  }
  viewer @client {
    usdcBalance
    gfiBalance
  }
}
    `;

/**
 * __useCurrentUserWalletInfoQuery__
 *
 * To run a query within a React component, call `useCurrentUserWalletInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWalletInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWalletInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWalletInfoQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWalletInfoQuery, CurrentUserWalletInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWalletInfoQuery, CurrentUserWalletInfoQueryVariables>(CurrentUserWalletInfoDocument, options);
      }
export function useCurrentUserWalletInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWalletInfoQuery, CurrentUserWalletInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWalletInfoQuery, CurrentUserWalletInfoQueryVariables>(CurrentUserWalletInfoDocument, options);
        }
export type CurrentUserWalletInfoQueryHookResult = ReturnType<typeof useCurrentUserWalletInfoQuery>;
export type CurrentUserWalletInfoLazyQueryHookResult = ReturnType<typeof useCurrentUserWalletInfoLazyQuery>;
export type CurrentUserWalletInfoQueryResult = Apollo.QueryResult<CurrentUserWalletInfoQuery, CurrentUserWalletInfoQueryVariables>;
export const StatusCheckStepDocument = gql`
    query StatusCheckStep($account: ID!) {
  user(id: $account) {
    id
    uidType
  }
}
    `;

/**
 * __useStatusCheckStepQuery__
 *
 * To run a query within a React component, call `useStatusCheckStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusCheckStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusCheckStepQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useStatusCheckStepQuery(baseOptions: Apollo.QueryHookOptions<StatusCheckStepQuery, StatusCheckStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatusCheckStepQuery, StatusCheckStepQueryVariables>(StatusCheckStepDocument, options);
      }
export function useStatusCheckStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatusCheckStepQuery, StatusCheckStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatusCheckStepQuery, StatusCheckStepQueryVariables>(StatusCheckStepDocument, options);
        }
export type StatusCheckStepQueryHookResult = ReturnType<typeof useStatusCheckStepQuery>;
export type StatusCheckStepLazyQueryHookResult = ReturnType<typeof useStatusCheckStepLazyQuery>;
export type StatusCheckStepQueryResult = Apollo.QueryResult<StatusCheckStepQuery, StatusCheckStepQueryVariables>;
export const UserUidForAnalyticsDocument = gql`
    query UserUidForAnalytics($account: ID!) {
  user(id: $account) {
    id
    uidType
  }
}
    `;

/**
 * __useUserUidForAnalyticsQuery__
 *
 * To run a query within a React component, call `useUserUidForAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserUidForAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUidForAnalyticsQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useUserUidForAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<UserUidForAnalyticsQuery, UserUidForAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserUidForAnalyticsQuery, UserUidForAnalyticsQueryVariables>(UserUidForAnalyticsDocument, options);
      }
export function useUserUidForAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserUidForAnalyticsQuery, UserUidForAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserUidForAnalyticsQuery, UserUidForAnalyticsQueryVariables>(UserUidForAnalyticsDocument, options);
        }
export type UserUidForAnalyticsQueryHookResult = ReturnType<typeof useUserUidForAnalyticsQuery>;
export type UserUidForAnalyticsLazyQueryHookResult = ReturnType<typeof useUserUidForAnalyticsLazyQuery>;
export type UserUidForAnalyticsQueryResult = Apollo.QueryResult<UserUidForAnalyticsQuery, UserUidForAnalyticsQueryVariables>;
export const AccountPageDocument = gql`
    query AccountPage($account: ID!) {
  user(id: $account) {
    uidType
  }
  viewer @client {
    kycStatus {
      kycProvider
      status
      identityStatus
      accreditationStatus
      countryCode
      type
    }
  }
}
    `;

/**
 * __useAccountPageQuery__
 *
 * To run a query within a React component, call `useAccountPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPageQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useAccountPageQuery(baseOptions: Apollo.QueryHookOptions<AccountPageQuery, AccountPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPageQuery, AccountPageQueryVariables>(AccountPageDocument, options);
      }
export function useAccountPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPageQuery, AccountPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPageQuery, AccountPageQueryVariables>(AccountPageDocument, options);
        }
export type AccountPageQueryHookResult = ReturnType<typeof useAccountPageQuery>;
export type AccountPageLazyQueryHookResult = ReturnType<typeof useAccountPageLazyQuery>;
export type AccountPageQueryResult = Apollo.QueryResult<AccountPageQuery, AccountPageQueryVariables>;
export const KnownTokensDocument = gql`
    query KnownTokens($account: String!, $merkleDistributorIndices: [Int!]!, $backerMerkleDistributorIndices: [Int!]!) {
  ownedTokens: communityRewardsTokens(where: {user: $account}) {
    user {
      id
    }
    index
    source
  }
  relinquishedTokens: communityRewardsTokens(
    where: {and: [{user_not: $account}, {or: [{index_in: $merkleDistributorIndices, source: MERKLE_DISTRIBUTOR}, {index_in: $backerMerkleDistributorIndices, source: BACKER_MERKLE_DISTRIBUTOR}]}]}
  ) {
    index
    source
  }
}
    `;

/**
 * __useKnownTokensQuery__
 *
 * To run a query within a React component, call `useKnownTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnownTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnownTokensQuery({
 *   variables: {
 *      account: // value for 'account'
 *      merkleDistributorIndices: // value for 'merkleDistributorIndices'
 *      backerMerkleDistributorIndices: // value for 'backerMerkleDistributorIndices'
 *   },
 * });
 */
export function useKnownTokensQuery(baseOptions: Apollo.QueryHookOptions<KnownTokensQuery, KnownTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnownTokensQuery, KnownTokensQueryVariables>(KnownTokensDocument, options);
      }
export function useKnownTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnownTokensQuery, KnownTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnownTokensQuery, KnownTokensQueryVariables>(KnownTokensDocument, options);
        }
export type KnownTokensQueryHookResult = ReturnType<typeof useKnownTokensQuery>;
export type KnownTokensLazyQueryHookResult = ReturnType<typeof useKnownTokensLazyQuery>;
export type KnownTokensQueryResult = Apollo.QueryResult<KnownTokensQuery, KnownTokensQueryVariables>;
export const CallableLoanCallPoolTokensDocument = gql`
    query CallableLoanCallPoolTokens($loanId: String!) {
  poolTokens(where: {loan: $loanId, isCapitalCalled: true}, first: 1000) {
    ...CallableLoanCallPoolTokensFields
  }
}
    ${CallableLoanCallPoolTokensFieldsFragmentDoc}`;

/**
 * __useCallableLoanCallPoolTokensQuery__
 *
 * To run a query within a React component, call `useCallableLoanCallPoolTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallableLoanCallPoolTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallableLoanCallPoolTokensQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useCallableLoanCallPoolTokensQuery(baseOptions: Apollo.QueryHookOptions<CallableLoanCallPoolTokensQuery, CallableLoanCallPoolTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallableLoanCallPoolTokensQuery, CallableLoanCallPoolTokensQueryVariables>(CallableLoanCallPoolTokensDocument, options);
      }
export function useCallableLoanCallPoolTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallableLoanCallPoolTokensQuery, CallableLoanCallPoolTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallableLoanCallPoolTokensQuery, CallableLoanCallPoolTokensQueryVariables>(CallableLoanCallPoolTokensDocument, options);
        }
export type CallableLoanCallPoolTokensQueryHookResult = ReturnType<typeof useCallableLoanCallPoolTokensQuery>;
export type CallableLoanCallPoolTokensLazyQueryHookResult = ReturnType<typeof useCallableLoanCallPoolTokensLazyQuery>;
export type CallableLoanCallPoolTokensQueryResult = Apollo.QueryResult<CallableLoanCallPoolTokensQuery, CallableLoanCallPoolTokensQueryVariables>;
export const PoolCreditLinePageDocument = gql`
    query PoolCreditLinePage($loanId: ID!) {
  loan(id: $loanId) {
    ...LoanBorrowerAccountingFields
  }
}
    ${LoanBorrowerAccountingFieldsFragmentDoc}`;

/**
 * __usePoolCreditLinePageQuery__
 *
 * To run a query within a React component, call `usePoolCreditLinePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoolCreditLinePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoolCreditLinePageQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function usePoolCreditLinePageQuery(baseOptions: Apollo.QueryHookOptions<PoolCreditLinePageQuery, PoolCreditLinePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoolCreditLinePageQuery, PoolCreditLinePageQueryVariables>(PoolCreditLinePageDocument, options);
      }
export function usePoolCreditLinePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoolCreditLinePageQuery, PoolCreditLinePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoolCreditLinePageQuery, PoolCreditLinePageQueryVariables>(PoolCreditLinePageDocument, options);
        }
export type PoolCreditLinePageQueryHookResult = ReturnType<typeof usePoolCreditLinePageQuery>;
export type PoolCreditLinePageLazyQueryHookResult = ReturnType<typeof usePoolCreditLinePageLazyQuery>;
export type PoolCreditLinePageQueryResult = Apollo.QueryResult<PoolCreditLinePageQuery, PoolCreditLinePageQueryVariables>;
export const PoolCreditLinePageCmsDocument = gql`
    query PoolCreditLinePageCMS($id: String!) @api(name: cms) {
  Deal(id: $id) {
    ...LoanBorrowCardFields
  }
}
    ${LoanBorrowCardFieldsFragmentDoc}`;

/**
 * __usePoolCreditLinePageCmsQuery__
 *
 * To run a query within a React component, call `usePoolCreditLinePageCmsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoolCreditLinePageCmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoolCreditLinePageCmsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePoolCreditLinePageCmsQuery(baseOptions: Apollo.QueryHookOptions<PoolCreditLinePageCmsQuery, PoolCreditLinePageCmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoolCreditLinePageCmsQuery, PoolCreditLinePageCmsQueryVariables>(PoolCreditLinePageCmsDocument, options);
      }
export function usePoolCreditLinePageCmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoolCreditLinePageCmsQuery, PoolCreditLinePageCmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoolCreditLinePageCmsQuery, PoolCreditLinePageCmsQueryVariables>(PoolCreditLinePageCmsDocument, options);
        }
export type PoolCreditLinePageCmsQueryHookResult = ReturnType<typeof usePoolCreditLinePageCmsQuery>;
export type PoolCreditLinePageCmsLazyQueryHookResult = ReturnType<typeof usePoolCreditLinePageCmsLazyQuery>;
export type PoolCreditLinePageCmsQueryResult = Apollo.QueryResult<PoolCreditLinePageCmsQuery, PoolCreditLinePageCmsQueryVariables>;
export const BorrowPageDocument = gql`
    query BorrowPage($userId: String!) {
  loans(
    where: {borrowerContract_: {user: $userId}}
    orderBy: createdAt
    orderDirection: desc
  ) {
    ...LoanBorrowerAccountingFields
  }
}
    ${LoanBorrowerAccountingFieldsFragmentDoc}`;

/**
 * __useBorrowPageQuery__
 *
 * To run a query within a React component, call `useBorrowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBorrowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBorrowPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBorrowPageQuery(baseOptions: Apollo.QueryHookOptions<BorrowPageQuery, BorrowPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BorrowPageQuery, BorrowPageQueryVariables>(BorrowPageDocument, options);
      }
export function useBorrowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BorrowPageQuery, BorrowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BorrowPageQuery, BorrowPageQueryVariables>(BorrowPageDocument, options);
        }
export type BorrowPageQueryHookResult = ReturnType<typeof useBorrowPageQuery>;
export type BorrowPageLazyQueryHookResult = ReturnType<typeof useBorrowPageLazyQuery>;
export type BorrowPageQueryResult = Apollo.QueryResult<BorrowPageQuery, BorrowPageQueryVariables>;
export const BorrowPageCmsDocument = gql`
    query BorrowPageCMS @api(name: cms) {
  Deals(limit: 100, where: {hidden: {not_equals: true}}) {
    docs {
      ...LoanBorrowCardFields
    }
  }
}
    ${LoanBorrowCardFieldsFragmentDoc}`;

/**
 * __useBorrowPageCmsQuery__
 *
 * To run a query within a React component, call `useBorrowPageCmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBorrowPageCmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBorrowPageCmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBorrowPageCmsQuery(baseOptions?: Apollo.QueryHookOptions<BorrowPageCmsQuery, BorrowPageCmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BorrowPageCmsQuery, BorrowPageCmsQueryVariables>(BorrowPageCmsDocument, options);
      }
export function useBorrowPageCmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BorrowPageCmsQuery, BorrowPageCmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BorrowPageCmsQuery, BorrowPageCmsQueryVariables>(BorrowPageCmsDocument, options);
        }
export type BorrowPageCmsQueryHookResult = ReturnType<typeof useBorrowPageCmsQuery>;
export type BorrowPageCmsLazyQueryHookResult = ReturnType<typeof useBorrowPageCmsLazyQuery>;
export type BorrowPageCmsQueryResult = Apollo.QueryResult<BorrowPageCmsQuery, BorrowPageCmsQueryVariables>;
export const DashboardPageDocument = gql`
    query DashboardPage($userId: String!) {
  seniorPools {
    id
    sharePrice
  }
  viewer @client {
    fiduBalance
    gfiBalance
    curveLpBalance
    gfiGrants {
      __typename
      id
      index
      amount
      ... on IndirectGfiGrant {
        indirectSource
        vested
      }
      ... on DirectGfiGrant {
        isAccepted
      }
    }
    claimableMembershipRewards
  }
  gfiPrice(fiat: USD) @client {
    price {
      amount
      symbol
    }
  }
  vaultedGfis(where: {user: $userId}) {
    id
    amount
  }
  curvePool @client {
    usdPerLpToken
  }
  poolTokens(
    where: {user: $userId, principalAmount_gt: 0}
    orderBy: mintedAt
    orderDirection: desc
  ) {
    ...DashboardPoolTokenFields
  }
  vaultedPoolTokens(where: {user: $userId}) {
    id
    poolToken {
      ...DashboardPoolTokenFields
    }
  }
  stakedFiduPositions: seniorPoolStakedPositions(
    where: {user: $userId, amount_gt: 0, positionType: Fidu}
    orderBy: startTime
    orderDirection: desc
  ) {
    ...DashboardStakedPositionFields
  }
  vaultedStakedPositions(where: {user: $userId}) {
    id
    seniorPoolStakedPosition {
      ...DashboardStakedPositionFields
    }
  }
  stakedCurveLpPositions: seniorPoolStakedPositions(
    where: {user: $userId, amount_gt: 0, positionType: CurveLP}
    orderBy: startTime
    orderDirection: desc
  ) {
    ...DashboardStakedPositionFields
  }
  pastAndCurrentSeniorPoolPositions: seniorPoolStakedPositions(
    where: {user: $userId}
  ) {
    id
    claimable @client
    granted @client
    totalRewardsClaimed
  }
  communityRewardsTokens(where: {user: $userId}) {
    id
    source
    index
    totalClaimed
  }
  seniorPoolWithdrawalRequests(where: {user: $userId}, first: 1) {
    id
    fiduRequested
  }
}
    ${DashboardPoolTokenFieldsFragmentDoc}
${DashboardStakedPositionFieldsFragmentDoc}`;

/**
 * __useDashboardPageQuery__
 *
 * To run a query within a React component, call `useDashboardPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDashboardPageQuery(baseOptions: Apollo.QueryHookOptions<DashboardPageQuery, DashboardPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, options);
      }
export function useDashboardPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPageQuery, DashboardPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, options);
        }
export type DashboardPageQueryHookResult = ReturnType<typeof useDashboardPageQuery>;
export type DashboardPageLazyQueryHookResult = ReturnType<typeof useDashboardPageLazyQuery>;
export type DashboardPageQueryResult = Apollo.QueryResult<DashboardPageQuery, DashboardPageQueryVariables>;
export const CurrentUserTransactionsDocument = gql`
    query CurrentUserTransactions($account: String!, $first: Int!, $skip: Int!) {
  transactions(
    orderBy: timestamp
    orderDirection: desc
    first: $first
    skip: $skip
    where: {user: $account}
  ) {
    id
    transactionHash
    category
    sentAmount
    sentToken
    sentNftId
    sentNftType
    receivedAmount
    receivedToken
    receivedNftId
    receivedNftType
    fiduPrice
    timestamp
    loan {
      id
    }
  }
}
    `;

/**
 * __useCurrentUserTransactionsQuery__
 *
 * To run a query within a React component, call `useCurrentUserTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserTransactionsQuery({
 *   variables: {
 *      account: // value for 'account'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCurrentUserTransactionsQuery(baseOptions: Apollo.QueryHookOptions<CurrentUserTransactionsQuery, CurrentUserTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserTransactionsQuery, CurrentUserTransactionsQueryVariables>(CurrentUserTransactionsDocument, options);
      }
export function useCurrentUserTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserTransactionsQuery, CurrentUserTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserTransactionsQuery, CurrentUserTransactionsQueryVariables>(CurrentUserTransactionsDocument, options);
        }
export type CurrentUserTransactionsQueryHookResult = ReturnType<typeof useCurrentUserTransactionsQuery>;
export type CurrentUserTransactionsLazyQueryHookResult = ReturnType<typeof useCurrentUserTransactionsLazyQuery>;
export type CurrentUserTransactionsQueryResult = Apollo.QueryResult<CurrentUserTransactionsQuery, CurrentUserTransactionsQueryVariables>;
export const EarnPageDocument = gql`
    query EarnPage($numClosedPools: Int!, $account: ID!) {
  seniorPools(first: 1) {
    id
    name @client
    category @client
    icon @client
    estimatedApy
    estimatedApyFromGfiRaw
    sharePrice
  }
  openPools: loans(
    orderBy: createdAt
    orderDirection: desc
    where: {termStartTime: 0}
  ) {
    __typename
    id
    usdcApy
    rawGfiApy
    termInSeconds
    ...FundingStatusLoanFields
  }
  closedPools: loans(
    orderBy: createdAt
    orderDirection: desc
    where: {termStartTime_not: 0}
    first: $numClosedPools
  ) {
    id
    principalAmount
    termEndTime
    ...RepaymentStatusLoanFields
  }
  protocols(first: 1) {
    id
    numLoans
    ...ProtocolMetricsFields
  }
  gfiPrice(fiat: USD) @client {
    lastUpdated
    price {
      amount
      symbol
    }
  }
  user(id: $account) {
    uidType
  }
  viewer @client {
    fiduBalance
  }
  currentBlock @client {
    timestamp
  }
}
    ${FundingStatusLoanFieldsFragmentDoc}
${RepaymentStatusLoanFieldsFragmentDoc}
${ProtocolMetricsFieldsFragmentDoc}`;

/**
 * __useEarnPageQuery__
 *
 * To run a query within a React component, call `useEarnPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnPageQuery({
 *   variables: {
 *      numClosedPools: // value for 'numClosedPools'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useEarnPageQuery(baseOptions: Apollo.QueryHookOptions<EarnPageQuery, EarnPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EarnPageQuery, EarnPageQueryVariables>(EarnPageDocument, options);
      }
export function useEarnPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EarnPageQuery, EarnPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EarnPageQuery, EarnPageQueryVariables>(EarnPageDocument, options);
        }
export type EarnPageQueryHookResult = ReturnType<typeof useEarnPageQuery>;
export type EarnPageLazyQueryHookResult = ReturnType<typeof useEarnPageLazyQuery>;
export type EarnPageQueryResult = Apollo.QueryResult<EarnPageQuery, EarnPageQueryVariables>;
export const EarnPageCmsDocument = gql`
    query EarnPageCMS @api(name: cms) {
  Deals(limit: 100, where: {hidden: {not_equals: true}}) {
    docs {
      id
      name
      category
      dealType
      borrower {
        id
        name
        logo {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useEarnPageCmsQuery__
 *
 * To run a query within a React component, call `useEarnPageCmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarnPageCmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarnPageCmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEarnPageCmsQuery(baseOptions?: Apollo.QueryHookOptions<EarnPageCmsQuery, EarnPageCmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EarnPageCmsQuery, EarnPageCmsQueryVariables>(EarnPageCmsDocument, options);
      }
export function useEarnPageCmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EarnPageCmsQuery, EarnPageCmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EarnPageCmsQuery, EarnPageCmsQueryVariables>(EarnPageCmsDocument, options);
        }
export type EarnPageCmsQueryHookResult = ReturnType<typeof useEarnPageCmsQuery>;
export type EarnPageCmsLazyQueryHookResult = ReturnType<typeof useEarnPageCmsLazyQuery>;
export type EarnPageCmsQueryResult = Apollo.QueryResult<EarnPageCmsQuery, EarnPageCmsQueryVariables>;
export const GfiPageDocument = gql`
    query GfiPage($userId: String!) {
  viewer @client {
    gfiGrants {
      ...GrantCardGrantFields
    }
    gfiBalance
  }
  communityRewardsTokens(where: {user: $userId}) {
    ...GrantCardTokenFields
  }
  poolTokens(where: {user: $userId}, orderBy: mintedAt, orderDirection: asc) {
    ...BackerCardTokenFields
  }
  vaultedPoolTokens(where: {user: $userId}) {
    id
    poolToken {
      ...BackerCardTokenFields
    }
  }
  seniorPoolStakedPositions(
    where: {user: $userId}
    orderBy: startTime
    orderDirection: asc
  ) {
    ...StakingCardPositionFields
  }
  vaultedStakedPositions(where: {user: $userId}) {
    id
    seniorPoolStakedPosition {
      ...StakingCardPositionFields
    }
  }
}
    ${GrantCardGrantFieldsFragmentDoc}
${GrantCardTokenFieldsFragmentDoc}
${BackerCardTokenFieldsFragmentDoc}
${StakingCardPositionFieldsFragmentDoc}`;

/**
 * __useGfiPageQuery__
 *
 * To run a query within a React component, call `useGfiPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGfiPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGfiPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGfiPageQuery(baseOptions: Apollo.QueryHookOptions<GfiPageQuery, GfiPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GfiPageQuery, GfiPageQueryVariables>(GfiPageDocument, options);
      }
export function useGfiPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GfiPageQuery, GfiPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GfiPageQuery, GfiPageQueryVariables>(GfiPageDocument, options);
        }
export type GfiPageQueryHookResult = ReturnType<typeof useGfiPageQuery>;
export type GfiPageLazyQueryHookResult = ReturnType<typeof useGfiPageLazyQuery>;
export type GfiPageQueryResult = Apollo.QueryResult<GfiPageQuery, GfiPageQueryVariables>;
export const MembershipPageDocument = gql`
    query MembershipPage($userId: String!) {
  seniorPools {
    id
    sharePrice
  }
  viewer @client(always: true) {
    gfiBalance
    fiduBalance
    claimableMembershipRewards
    accruedMembershipRewardsThisEpoch
  }
  gfiPrice(fiat: USD) @client {
    price {
      amount
      symbol
    }
  }
  seniorPoolStakedPositions(
    where: {user: $userId, amount_gt: 0, positionType: Fidu}
    orderBy: startTime
    orderDirection: desc
  ) {
    ...StakedPositionFieldsForAssets
  }
  poolTokens(
    where: {user: $userId, principalAmount_gt: 0, loan_: {termStartTime_gt: 0}}
    orderBy: mintedAt
    orderDirection: desc
  ) {
    ...PoolTokenFieldsForAssets
  }
  ineligiblePoolTokens: poolTokens(
    where: {user: $userId, principalAmount_gt: 0, loan_: {termStartTime: 0}}
    orderBy: mintedAt
    orderDirection: desc
  ) {
    ...PoolTokenFieldsForAssets
  }
  currentBlock @client {
    timestamp
  }
  vaultedGfis(
    where: {user: $userId, amount_gt: 0}
    orderBy: vaultedAt
    orderDirection: desc
  ) {
    id
    amount
    ...VaultedGfiFields
  }
  vaultedStakedPositions(where: {user: $userId}) {
    id
    ...VaultedStakedPositionFields
  }
  vaultedPoolTokens(where: {user: $userId}) {
    id
    ...VaultedPoolTokenFields
  }
  membershipRewardDisbursements(
    where: {user: $userId}
    orderBy: epoch
    orderDirection: asc
  ) {
    id
    ...ChartDisbursementFields
  }
  memberships(where: {user: $userId}) {
    id
    eligibleScore
    nextEpochScore
  }
  membershipEpoches(orderBy: epoch, orderDirection: desc, first: 8) {
    epoch
    totalRewards
  }
}
    ${StakedPositionFieldsForAssetsFragmentDoc}
${PoolTokenFieldsForAssetsFragmentDoc}
${VaultedGfiFieldsFragmentDoc}
${VaultedStakedPositionFieldsFragmentDoc}
${VaultedPoolTokenFieldsFragmentDoc}
${ChartDisbursementFieldsFragmentDoc}`;

/**
 * __useMembershipPageQuery__
 *
 * To run a query within a React component, call `useMembershipPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMembershipPageQuery(baseOptions: Apollo.QueryHookOptions<MembershipPageQuery, MembershipPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipPageQuery, MembershipPageQueryVariables>(MembershipPageDocument, options);
      }
export function useMembershipPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipPageQuery, MembershipPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipPageQuery, MembershipPageQueryVariables>(MembershipPageDocument, options);
        }
export type MembershipPageQueryHookResult = ReturnType<typeof useMembershipPageQuery>;
export type MembershipPageLazyQueryHookResult = ReturnType<typeof useMembershipPageLazyQuery>;
export type MembershipPageQueryResult = Apollo.QueryResult<MembershipPageQuery, MembershipPageQueryVariables>;
export const SingleTranchedPoolDataDocument = gql`
    query SingleTranchedPoolData($tranchedPoolId: ID!, $tranchedPoolAddress: String!, $userId: ID!, $borrowerAllPools: [ID!], $isStratosPool: Boolean!, $isLendEastPool: Boolean!) {
  loan(id: $tranchedPoolId) {
    __typename
    id
    allowedUidTypes
    usdcApy
    rawGfiApy
    fundableAt
    ...LoanSummaryFields
    ...FundingStatusLoanFields
    ...SupplyPanelLoanFields
    ...ClaimPanelLoanFields
    ...RepaymentTermsStatsFields
    ...AmountStatsFields
    ...RepaymentTableLoanFields
  }
  borrowerAllPools: tranchedPools(
    where: {id_in: $borrowerAllPools, principalAmount_not: 0}
    orderBy: createdAt
    orderDirection: desc
  ) {
    ...BorrowerAllPoolFields
  }
  seniorPools(first: 1) {
    id
    estimatedApyFromGfiRaw
  }
  gfiPrice(fiat: USD) @client {
    price {
      amount
      symbol
    }
  }
  user(id: $userId) {
    id
    ...SupplyPanelUserFields
    poolTokens(where: {loan: $tranchedPoolAddress}) {
      ...WithdrawalPanelPoolTokenFields
      ...ClaimPanelPoolTokenFields
    }
    vaultedPoolTokens(where: {loan: $tranchedPoolAddress}) {
      id
      poolToken {
        ...WithdrawalPanelPoolTokenFields
        ...ClaimPanelPoolTokenFields
      }
    }
    uidType @include(if: $isStratosPool)
    claimableFromStratosBackstop @include(if: $isStratosPool) @client
    nonce: uidType @include(if: $isLendEastPool)
    claimableFromLendEastBackstop @include(if: $isLendEastPool) @client
  }
  currentBlock @client {
    timestamp
  }
}
    ${LoanSummaryFieldsFragmentDoc}
${FundingStatusLoanFieldsFragmentDoc}
${SupplyPanelLoanFieldsFragmentDoc}
${ClaimPanelLoanFieldsFragmentDoc}
${RepaymentTermsStatsFieldsFragmentDoc}
${AmountStatsFieldsFragmentDoc}
${RepaymentTableLoanFieldsFragmentDoc}
${BorrowerAllPoolFieldsFragmentDoc}
${SupplyPanelUserFieldsFragmentDoc}
${WithdrawalPanelPoolTokenFieldsFragmentDoc}
${ClaimPanelPoolTokenFieldsFragmentDoc}`;

/**
 * __useSingleTranchedPoolDataQuery__
 *
 * To run a query within a React component, call `useSingleTranchedPoolDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTranchedPoolDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTranchedPoolDataQuery({
 *   variables: {
 *      tranchedPoolId: // value for 'tranchedPoolId'
 *      tranchedPoolAddress: // value for 'tranchedPoolAddress'
 *      userId: // value for 'userId'
 *      borrowerAllPools: // value for 'borrowerAllPools'
 *      isStratosPool: // value for 'isStratosPool'
 *      isLendEastPool: // value for 'isLendEastPool'
 *   },
 * });
 */
export function useSingleTranchedPoolDataQuery(baseOptions: Apollo.QueryHookOptions<SingleTranchedPoolDataQuery, SingleTranchedPoolDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTranchedPoolDataQuery, SingleTranchedPoolDataQueryVariables>(SingleTranchedPoolDataDocument, options);
      }
export function useSingleTranchedPoolDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTranchedPoolDataQuery, SingleTranchedPoolDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTranchedPoolDataQuery, SingleTranchedPoolDataQueryVariables>(SingleTranchedPoolDataDocument, options);
        }
export type SingleTranchedPoolDataQueryHookResult = ReturnType<typeof useSingleTranchedPoolDataQuery>;
export type SingleTranchedPoolDataLazyQueryHookResult = ReturnType<typeof useSingleTranchedPoolDataLazyQuery>;
export type SingleTranchedPoolDataQueryResult = Apollo.QueryResult<SingleTranchedPoolDataQuery, SingleTranchedPoolDataQueryVariables>;
export const SingleDealDocument = gql`
    query SingleDeal($id: String!) @api(name: cms) {
  Deal(id: $id) {
    id
    name
    dealType
    category
    borrower {
      ...LoanSummaryBorrowerFields
      ...BorrowerProfileFields
      deals {
        id
      }
    }
    overview
    highlights {
      ...DealHighlightFields
    }
    details
    agreement
    dataroom
    defaultInterestRate
    transactionStructure {
      filename
      fileNameOverride
      alt
      url
      mimeType
    }
    creditMemos {
      ...CreditMemoFields
    }
    ...SupplyPanelDealFields
    ...RiskTableDealFields
  }
}
    ${LoanSummaryBorrowerFieldsFragmentDoc}
${BorrowerProfileFieldsFragmentDoc}
${DealHighlightFieldsFragmentDoc}
${CreditMemoFieldsFragmentDoc}
${SupplyPanelDealFieldsFragmentDoc}
${RiskTableDealFieldsFragmentDoc}`;

/**
 * __useSingleDealQuery__
 *
 * To run a query within a React component, call `useSingleDealQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleDealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleDealQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleDealQuery(baseOptions: Apollo.QueryHookOptions<SingleDealQuery, SingleDealQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleDealQuery, SingleDealQueryVariables>(SingleDealDocument, options);
      }
export function useSingleDealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleDealQuery, SingleDealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleDealQuery, SingleDealQueryVariables>(SingleDealDocument, options);
        }
export type SingleDealQueryHookResult = ReturnType<typeof useSingleDealQuery>;
export type SingleDealLazyQueryHookResult = ReturnType<typeof useSingleDealLazyQuery>;
export type SingleDealQueryResult = Apollo.QueryResult<SingleDealQuery, SingleDealQueryVariables>;
export const TranchedPoolTransactionTableDocument = gql`
    query TranchedPoolTransactionTable($loanId: ID!, $loanAddress: String!, $first: Int!, $skip: Int!) {
  transactions(
    where: {loan: $loanAddress}
    orderBy: timestamp
    orderDirection: desc
    first: $first
    skip: $skip
  ) {
    id
    transactionHash
    user {
      id
      ENSName @client
      ENSAvatar @client
    }
    category
    sentAmount
    sentToken
    receivedAmount
    receivedToken
    timestamp
  }
  loan(id: $loanId) {
    id
    borrowerName @client
    borrowerLogo @client
  }
}
    `;

/**
 * __useTranchedPoolTransactionTableQuery__
 *
 * To run a query within a React component, call `useTranchedPoolTransactionTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranchedPoolTransactionTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranchedPoolTransactionTableQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      loanAddress: // value for 'loanAddress'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useTranchedPoolTransactionTableQuery(baseOptions: Apollo.QueryHookOptions<TranchedPoolTransactionTableQuery, TranchedPoolTransactionTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranchedPoolTransactionTableQuery, TranchedPoolTransactionTableQueryVariables>(TranchedPoolTransactionTableDocument, options);
      }
export function useTranchedPoolTransactionTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranchedPoolTransactionTableQuery, TranchedPoolTransactionTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranchedPoolTransactionTableQuery, TranchedPoolTransactionTableQueryVariables>(TranchedPoolTransactionTableDocument, options);
        }
export type TranchedPoolTransactionTableQueryHookResult = ReturnType<typeof useTranchedPoolTransactionTableQuery>;
export type TranchedPoolTransactionTableLazyQueryHookResult = ReturnType<typeof useTranchedPoolTransactionTableLazyQuery>;
export type TranchedPoolTransactionTableQueryResult = Apollo.QueryResult<TranchedPoolTransactionTableQuery, TranchedPoolTransactionTableQueryVariables>;
export const SeniorPoolPageDocument = gql`
    query SeniorPoolPage($userId: ID!, $user: String!) {
  user(id: $userId) {
    id
    ...UserEligibilityFields
  }
  seniorPoolStakedPositions(
    where: {user: $user, positionType: Fidu, amount_gt: 0}
  ) {
    ...SeniorPoolWithdrawalPanelPositionFields
  }
  vaultedStakedPositions(where: {user: $user}) {
    id
    seniorPoolStakedPosition {
      ...SeniorPoolWithdrawalPanelPositionFields
    }
  }
  seniorPools(first: 1) {
    id
    address
    sharePrice
    withdrawalCancellationFee
    epochEndsAt @client
    ...SeniorPoolPortfolioDetailsFields
    ...CapitalStatsFields
    ...SeniorPoolSupplyPanelPoolFields
    ...SeniorPoolLoanSummaryFields
    ...InvestAndWithdrawSeniorPoolFields
    ...SeniorPoolRepaymentFields
  }
  gfiPrice(fiat: USD) @client {
    price {
      amount
      symbol
    }
  }
  viewer @client {
    fiduBalance
  }
  seniorPoolWithdrawalRequests(where: {user: $user}) {
    ...SeniorPoolWithdrawalPanelWithdrawalRequestFields
  }
}
    ${UserEligibilityFieldsFragmentDoc}
${SeniorPoolWithdrawalPanelPositionFieldsFragmentDoc}
${SeniorPoolPortfolioDetailsFieldsFragmentDoc}
${CapitalStatsFieldsFragmentDoc}
${SeniorPoolSupplyPanelPoolFieldsFragmentDoc}
${SeniorPoolLoanSummaryFieldsFragmentDoc}
${InvestAndWithdrawSeniorPoolFieldsFragmentDoc}
${SeniorPoolRepaymentFieldsFragmentDoc}
${SeniorPoolWithdrawalPanelWithdrawalRequestFieldsFragmentDoc}`;

/**
 * __useSeniorPoolPageQuery__
 *
 * To run a query within a React component, call `useSeniorPoolPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeniorPoolPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeniorPoolPageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useSeniorPoolPageQuery(baseOptions: Apollo.QueryHookOptions<SeniorPoolPageQuery, SeniorPoolPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeniorPoolPageQuery, SeniorPoolPageQueryVariables>(SeniorPoolPageDocument, options);
      }
export function useSeniorPoolPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeniorPoolPageQuery, SeniorPoolPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeniorPoolPageQuery, SeniorPoolPageQueryVariables>(SeniorPoolPageDocument, options);
        }
export type SeniorPoolPageQueryHookResult = ReturnType<typeof useSeniorPoolPageQuery>;
export type SeniorPoolPageLazyQueryHookResult = ReturnType<typeof useSeniorPoolPageLazyQuery>;
export type SeniorPoolPageQueryResult = Apollo.QueryResult<SeniorPoolPageQuery, SeniorPoolPageQueryVariables>;
export const SeniorPoolPageCmsDocument = gql`
    query SeniorPoolPageCMS @api(name: cms) {
  Deals(limit: 100, where: {hidden: {not_equals: true}}) {
    docs {
      ...SeniorPoolPortfolioPoolsDealsFields
    }
  }
}
    ${SeniorPoolPortfolioPoolsDealsFieldsFragmentDoc}`;

/**
 * __useSeniorPoolPageCmsQuery__
 *
 * To run a query within a React component, call `useSeniorPoolPageCmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeniorPoolPageCmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeniorPoolPageCmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSeniorPoolPageCmsQuery(baseOptions?: Apollo.QueryHookOptions<SeniorPoolPageCmsQuery, SeniorPoolPageCmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeniorPoolPageCmsQuery, SeniorPoolPageCmsQueryVariables>(SeniorPoolPageCmsDocument, options);
      }
export function useSeniorPoolPageCmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeniorPoolPageCmsQuery, SeniorPoolPageCmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeniorPoolPageCmsQuery, SeniorPoolPageCmsQueryVariables>(SeniorPoolPageCmsDocument, options);
        }
export type SeniorPoolPageCmsQueryHookResult = ReturnType<typeof useSeniorPoolPageCmsQuery>;
export type SeniorPoolPageCmsLazyQueryHookResult = ReturnType<typeof useSeniorPoolPageCmsLazyQuery>;
export type SeniorPoolPageCmsQueryResult = Apollo.QueryResult<SeniorPoolPageCmsQuery, SeniorPoolPageCmsQueryVariables>;
export const WithdrawalHistory2Document = gql`
    query WithdrawalHistory2($user: String!) {
  transactions(
    where: {user: $user, category_in: [SENIOR_POOL_WITHDRAWAL_REQUEST, SENIOR_POOL_ADD_TO_WITHDRAWAL_REQUEST, SENIOR_POOL_CANCEL_WITHDRAWAL_REQUEST]}
    orderBy: timestamp
    orderDirection: asc
  ) {
    id
    timestamp
    category
    sentAmount
    sentToken
    receivedAmount
    receivedToken
  }
  seniorPoolWithdrawalDisbursements(
    where: {user: $user}
    orderBy: allocatedAt
    orderDirection: asc
  ) {
    id
    allocatedAt
    fiduLiquidated
  }
  seniorPoolWithdrawalDisbursementPostponements(
    where: {user: $user}
    orderBy: oldEndsAt
    orderDirection: asc
  ) {
    id
    oldEndsAt
    newEndsAt
  }
}
    `;

/**
 * __useWithdrawalHistory2Query__
 *
 * To run a query within a React component, call `useWithdrawalHistory2Query` and pass it any options that fit your needs.
 * When your component renders, `useWithdrawalHistory2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWithdrawalHistory2Query({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useWithdrawalHistory2Query(baseOptions: Apollo.QueryHookOptions<WithdrawalHistory2Query, WithdrawalHistory2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WithdrawalHistory2Query, WithdrawalHistory2QueryVariables>(WithdrawalHistory2Document, options);
      }
export function useWithdrawalHistory2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WithdrawalHistory2Query, WithdrawalHistory2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WithdrawalHistory2Query, WithdrawalHistory2QueryVariables>(WithdrawalHistory2Document, options);
        }
export type WithdrawalHistory2QueryHookResult = ReturnType<typeof useWithdrawalHistory2Query>;
export type WithdrawalHistory2LazyQueryHookResult = ReturnType<typeof useWithdrawalHistory2LazyQuery>;
export type WithdrawalHistory2QueryResult = Apollo.QueryResult<WithdrawalHistory2Query, WithdrawalHistory2QueryVariables>;
export const BorrowerTransactionsDocument = gql`
    query BorrowerTransactions($first: Int!, $skip: Int!) {
  transactions(
    where: {category_in: [TRANCHED_POOL_DRAWDOWN, TRANCHED_POOL_REPAYMENT, SENIOR_POOL_DEPOSIT, SENIOR_POOL_DEPOSIT_AND_STAKE, SENIOR_POOL_STAKE, SENIOR_POOL_WITHDRAWAL, SENIOR_POOL_UNSTAKE_AND_WITHDRAWAL, SENIOR_POOL_UNSTAKE, SENIOR_POOL_DISTRIBUTION]}
    orderBy: timestamp
    orderDirection: desc
    first: $first
    skip: $skip
  ) {
    id
    transactionHash
    user {
      id
      ENSName @client
      ENSAvatar @client
    }
    timestamp
    category
    sentAmount
    sentToken
    receivedAmount
    receivedToken
    loan {
      id
      name @client
      borrowerName @client
      borrowerLogo @client
    }
  }
}
    `;

/**
 * __useBorrowerTransactionsQuery__
 *
 * To run a query within a React component, call `useBorrowerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBorrowerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBorrowerTransactionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useBorrowerTransactionsQuery(baseOptions: Apollo.QueryHookOptions<BorrowerTransactionsQuery, BorrowerTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BorrowerTransactionsQuery, BorrowerTransactionsQueryVariables>(BorrowerTransactionsDocument, options);
      }
export function useBorrowerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BorrowerTransactionsQuery, BorrowerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BorrowerTransactionsQuery, BorrowerTransactionsQueryVariables>(BorrowerTransactionsDocument, options);
        }
export type BorrowerTransactionsQueryHookResult = ReturnType<typeof useBorrowerTransactionsQuery>;
export type BorrowerTransactionsLazyQueryHookResult = ReturnType<typeof useBorrowerTransactionsLazyQuery>;
export type BorrowerTransactionsQueryResult = Apollo.QueryResult<BorrowerTransactionsQuery, BorrowerTransactionsQueryVariables>;
export const StakePageDocument = gql`
    query StakePage($userId: String!) {
  stakedFiduPositions: seniorPoolStakedPositions(
    where: {user: $userId, positionType: Fidu, amount_gt: 0}
  ) {
    id
    amount
    ...UnstakeFormPositionFields
    ...MigrateFormPositionFields
  }
  stakedCurvePositions: seniorPoolStakedPositions(
    where: {user: $userId, positionType: CurveLP, amount_gt: 0}
  ) {
    id
    amount
    ...UnstakeFormPositionFields
    ...MigrateFormPositionFields
  }
  vaultedStakedPositions(where: {user: $userId}) {
    id
    seniorPoolStakedPosition {
      id
      amount
    }
  }
  seniorPools(first: 1) {
    id
    estimatedApy
    estimatedApyFromGfiRaw
    sharePrice
  }
  gfiPrice(fiat: USD) @client {
    lastUpdated
    price {
      amount
      symbol
    }
  }
  viewer @client {
    usdcBalance
    fiduBalance
    curveLpBalance
  }
  curvePool @client {
    estimatedCurveStakingApyRaw
  }
}
    ${UnstakeFormPositionFieldsFragmentDoc}
${MigrateFormPositionFieldsFragmentDoc}`;

/**
 * __useStakePageQuery__
 *
 * To run a query within a React component, call `useStakePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStakePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStakePageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStakePageQuery(baseOptions: Apollo.QueryHookOptions<StakePageQuery, StakePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StakePageQuery, StakePageQueryVariables>(StakePageDocument, options);
      }
export function useStakePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StakePageQuery, StakePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StakePageQuery, StakePageQueryVariables>(StakePageDocument, options);
        }
export type StakePageQueryHookResult = ReturnType<typeof useStakePageQuery>;
export type StakePageLazyQueryHookResult = ReturnType<typeof useStakePageLazyQuery>;
export type StakePageQueryResult = Apollo.QueryResult<StakePageQuery, StakePageQueryVariables>;